import DragIndicatorIcon from '@mui/icons-material/DragIndicator'
import VideocamIcon from '@mui/icons-material/Videocam'
import VideocamOffIcon from '@mui/icons-material/VideocamOff'
import MicIcon from '@mui/icons-material/Mic'
import MicOffIcon from '@mui/icons-material/MicOff'
import VolumeUpIcon from '@mui/icons-material/VolumeUp'
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner'
import LoginIcon from '@mui/icons-material/Login'
import LayersClearIcon from '@mui/icons-material/LayersClear'
import ReplayIcon from '@mui/icons-material/Replay'
import RefreshIcon from '@mui/icons-material/Refresh'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import SearchIcon from '@mui/icons-material/Search'
import PreviewIcon from '@mui/icons-material/Preview'
import HistoryIcon from '@mui/icons-material/History'
import SettingsIcon from '@mui/icons-material/Settings'
import MedicationIcon from '@mui/icons-material/Medication'
import CloseIcon from '@mui/icons-material/Close'
import HeightIcon from '@mui/icons-material/Height'
import ScreenRotationIcon from '@mui/icons-material/ScreenRotation'
import CropPortraitIcon from '@mui/icons-material/CropPortrait'
import CropLandscapeIcon from '@mui/icons-material/CropLandscape'
import ViewModuleIcon from '@mui/icons-material/ViewModule'
import ViewComfyIcon from '@mui/icons-material/ViewComfy'
import { Box, IconButton, Select, MenuItem, FormControl, Typography, Paper, Tooltip, Avatar, Drawer, Fab, Button, ListItemIcon, ListItemText, CircularProgress, Menu } from '@mui/material'
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong'
import BoltIcon from '@mui/icons-material/Bolt'
import AssignmentIcon from '@mui/icons-material/Assignment'
import { getAndSetCameras, getAndSetMicrophones, getAndSetSpeakers } from 'src/consumer/components/LiveSessionPage/LiveSessionPageComponents'
import { getSelectedCameraInLocalStorage, getSelectedMicrophoneInLocalStorage, getSelectedSpeakerInLocalStorage } from 'src/consumer/services/localstorageServices'
import AgoraRTC from 'agora-rtc-sdk-ng'
import { layout } from 'amhm-vc-ui-kit'
import React, { useCallback, useContext, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import { flushSync } from 'react-dom'
import { Spinner } from 'react-bootstrap'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import dayjs from 'dayjs'
import { CheckoutButtonComponent, EmrCheckedInIdlePopup } from 'src/clinic/components/CheckIn/checkInComponents'
import DayViewCalendarComponent from 'src/clinic/components/ClinicManageBookingsPage/DayViewCalendarComponent'
import BookedSlotsDrawer from 'src/clinic/components/ClinicManageBookingsPage/components/BookedSlotsDrawer'
import PatientSearchDrawer from 'src/mentor/components/MentorClinicBookingsPage/component/PatientSearchDrawer'
import SplitScreenHeader from './components/SplitScreenHeader'
import NotificationPanel, { showNotification } from './components/NotificationPanel'
import CustomVideoPlaceholder from './components/CustomVideoPlaceholder'
import DebugPanel from './components/DebugPanel'
import './VideoCallButtons.css' // Enhanced video call controls v2.1
import { getCPDataWithParams } from 'src/clinic/services'
import BaseUITabsComponent from 'src/common/tabs/BaseUITabs'
import {
  HCIPMenuContainer,
  HCIPMenuItem,
  HotlineChamberInteractionPart,
  HotlineSectionSeparator,
} from 'src/consumer/components/HotlineChamberPage/HotlineChamberStyles'
import MomentDatePicker from 'src/mentor/components/PrescriptionMakingPage/inputComponents/diagnosis/components/MomentDatePicker'
import {
  LSPastPrescriptionsComponent,
} from 'src/consumer/components/LiveSessionPage/LiveSessionPageComponents'
import AgoraVideoComponent from 'src/consumer/components/PublicLiveSessionPage/components/AgoraVideoComponent'
import {
  allAvailableEventTypes,
  BOOKING_SESSION_STATUS,
  CHAMBER_SCREEN_ACTIONS,
  CHAMBER_SCREEN_STATES,
  STATUS_SESSION_CANCELLED,
  BOOKING_STATUSES,
  BOOKING_PAYMENT_STATUSES,
} from 'src/consumer/constants'
import {
  askCheckedInChamberScreenToPollNextAction,
  checkChamberScreenStatus,
  getDataWithoutParams,
  markBookedEventLog,
  sendShowImageCommandToChamberScreen,
  getAgoraToken,
  sendReloadChamberRoomScreenSignal,
} from 'src/consumer/services/featureServices'
import { getDataWithParams } from 'src/consumer/services/profileService'
import { useCheckedInOnlyChamberRoomId, useCheckedInOrPeekedInChamberRoomId } from 'src/customHooks/customHooks'
import AssessmentReportMakingPage from 'src/mentor/components/AssessmentReport/AssessmentReportMakingPage'
import PractitionerAssessmentDrawer from 'src/mentor/components/PractitionerAssessment/PractitionerAssessmentDrawer'
import {
  MENTOR_CLINIC_BOOKING_TABS,
  MENTOR_CLINIC_BOOKING_TABS_LIST,
} from 'src/mentor/components/MentorClinicBookingsPage/util'
import ChamberScreenSignallingActions from 'src/mentor/components/MentorClinicSomeChamberAutoJoiningPage/components/ChamberScreenSignallingActions'
import { ChamberScreenSignallingSnackBarContext } from 'src/mentor/components/MentorClinicSomeChamberAutoJoiningPage/components/ChamberScreenSignallingSnackBarProvider'
import LeaveButton from 'src/mentor/components/MentorClinicSomeChamberAutoJoiningPage/components/LeaveButton'
import ChamberRoomStatusIndicator from 'src/mentor/components/MentorClinicSomeChamberAutoJoiningPage/components/ChamberRoomStatusIndicator'
import ScreeningSectionsProvider from 'src/mentor/components/PrescriptionMakingPage/context/ScreeningSectionsProvider'
import { MentorProfileContext } from 'src/mentor/context/MentorProfileContext'
import { DocSideContext } from 'src/context/DocSideContextProvider'
import {
  isCommonResponseSuccessful,
  markBookedSessionAsCompletedFunction,
  sleep,
} from 'src/mentor/helpers/utilityFunctions'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import { buildMentorRtmUsername } from './utils/rtmUsernameBuilder'
import PrescriptionMakingPage from '../PrescriptionMakingPage'
import PrescriptionDataProvider from '../PrescriptionMakingPage/context/PrescriptionDataProvider'
import ScreeningReportMakingPage from '../ScreeningReportMakingPage'
import TherapyReportMakingPage from '../TherapyReportMakingPage'
import VitalsListingPage from '../VitalsListingPage'
import LSPastVisitReportsComponent from 'src/consumer/components/LiveSessionPage/components/LSPastVisitReportsComponent/LSPastVisitReportsComponent'
import { getPastPatientReports } from 'src/reducers/emr/services/pastPatientReports'
import store from 'src/store'
import { FLOW_STATUSES_FOR_LEAVING_SESSION } from 'src/consumer/components/LiveSessionPage/utils/sessionNavigationUtils'
import RXDrawerComponent from 'src/consumer/components/LiveSessionPage/components/RXDrawerComponent/RXDrawerComponent'

// 3-dot menu component for Screening Report actions
function ScreeningReportActionsMenu({ screeningReportRef }) {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSaveAndPrint = async () => {
    if (screeningReportRef?.current?.saveAndPrint) {
      await screeningReportRef.current.saveAndPrint()
    }
    handleClose()
  }

  return (
    <>
      <HCIPMenuItem
        onClick={handleClick}
        style={{
          background: '#fff',
          color: '#64748b',
          border: '1px solid #e2e8f0',
          fontSize: '12px',
          padding: '6px 12px',
          fontWeight: 500,
          minWidth: '36px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <MoreVertIcon sx={{ fontSize: 18 }} />
      </HCIPMenuItem>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            mt: 1,
            minWidth: 160,
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
            border: '1px solid rgba(103, 121, 227, 0.1)',
          },
        }}
      >
        <MenuItem
          onClick={handleSaveAndPrint}
          sx={{
            fontSize: '14px',
            padding: '10px 16px',
            '&:hover': {
              backgroundColor: 'rgba(103, 121, 227, 0.08)',
            },
          }}
        >
          Save & Print
        </MenuItem>
      </Menu>
    </>
  )
}

export default function MentorClinicSomeChamberAutoJoiningPage() {
  const { clinicId, clinicBrandId, sessionSlug } = useParams()
  const { mentorClinicAssociationData } = useContext(MentorProfileContext)

  // wakelock - Only request when page is visible
  useEffect(() => {
    let wakeLock = null

    const requestWakeLock = async () => {
      // Check if page is visible before requesting wake lock
      if (document.hidden || !document.visibilityState || document.visibilityState === 'hidden') {
        return
      }

      // Check if WakeLock API is available
      if (!('wakeLock' in navigator)) {
        return
      }

      try {
        wakeLock = await navigator.wakeLock.request('screen')

        // Optionally handle the wake lock release
        wakeLock.addEventListener('release', () => {
          // Wake lock released
        })
      } catch (err) {
        // Silently handle errors (e.g., page not visible, user denied, etc.)
        if (err.name !== 'NotAllowedError') {
        console.error(`${err.name}: ${err.message}`)
        }
      }
    }

    // Request wake lock when page becomes visible
    const handleVisibilityChange = () => {
      if (!document.hidden && document.visibilityState === 'visible') {
    requestWakeLock()
      } else if (wakeLock) {
        // Release wake lock when page becomes hidden
        wakeLock.release().catch(() => {})
        wakeLock = null
      }
    }

    // Initial request if page is visible
    if (!document.hidden) {
      requestWakeLock()
    }

    // Listen for visibility changes
    document.addEventListener('visibilitychange', handleVisibilityChange)

    // Clean up on component unmount
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      if (wakeLock) {
        wakeLock.release().then(() => {
          // Wake lock released
        }).catch(() => {})
      }
    }
  }, [])

  const showPredecidedUIComponent =
    clinicId && mentorClinicAssociationData?.find((item) => item?.id === clinicId)

  return (
    <div
      className={
        'vh-100 vw-100 justify-content-center align-items-center' +
        (showPredecidedUIComponent ? ' d-flex' : '')
      }
    >
      {showPredecidedUIComponent ? (
        <PredecidedClinicIdUIComponent 
          clinicLocationId={clinicId}
          clinicBrandId={clinicBrandId}
          sessionSlug={sessionSlug}
        />
      ) : (
        <UndecidedClinicIdUIComponent />
      )}
    </div>
  )
}

const PredecidedClinicIdUIComponent = ({ clinicLocationId, clinicBrandId, sessionSlug }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const { showSnackBar } = useContext(ChamberScreenSignallingSnackBarContext)
  const [serverGivenNextAction, setServerGivenNextAction] = useState()
  const { mentorClinicAssociationData, mentorProfileData } = useContext(MentorProfileContext)
  const { setFlowId, setButtonTopOffset } = useContext(DocSideContext)
  const chosenClinicData = mentorClinicAssociationData?.find(
    (item) => item?.id === clinicLocationId,
  )

  // const [anchorElForMenu, setAnchorElForMenu] = useState(null)
  // const menuOpen = Boolean(anchorElForMenu)
  // const handleClickMenuOpener = (event) => {
  //   setAnchorElForMenu(event.currentTarget)
  // }
  // const handleCloseMenu = () => {
  //   setAnchorElForMenu(null)
  // }

  // serverGivenNextAction?.channel?.chamberRoomId

  const [chamberScreenStateNow, setChamberScreenStateNow] = useState(CHAMBER_SCREEN_STATES.IDLING)
  const [joinedChamberName, setJoinedChamberName] = useState('')
  const [joinedChannelName, setJoinedChannelName] = useState('')
  const [agoraRtcProps, setAgoraRtcProps] = useState({})
  const [agoraRtmProps, setAgoraRtmProps] = useState({})
  
  // Store original chamber room channel to reconnect after booked event session
  const [originalChamberRoomChannel, setOriginalChamberRoomChannel] = useState(null)
  const [isInBookedEventSession, setIsInBookedEventSession] = useState(false)

  // interaction menu related:
  const [triggerSave, setTriggerSave] = useState()
  const [newWantedMenuItemId, setNewWantedMenuItemId] = useState()
  const [patientMenuOptions, setPatientMenuOptions] = useState([])
  const [selectedOptionPatientMenu, setSelectedOptionPatientMenu] = useState()
  const [patientBookedSlotDetailsLoading, setPatientBookedSlotDetailsLoading] = useState(false)
  const [patientSelected, setPatientSelected] = useState(false)
  const [selectedPatientBookedEventId, setSelectedPatientBookedEventId] = useState()
  const [selectedPatientBookedEventData, setSelectedPatientBookedEventData] = useState()
  const [auxiliaryData, setAuxiliaryData] = useState()
  const [rxDrawerOpen, setRxDrawerOpen] = useState(false)
  const [assessmentDrawerOpen, setAssessmentDrawerOpen] = useState(false)
  
  // Ref to prevent multiple LEAVE API calls
  const isClosingBookedEventRef = useRef(false)
  
  // Ref to track if we've already determined this is an offline meeting
  const isOfflineMeetingRef = useRef(false)
  
  // Ref to track the last report mode that was active (for cleanup)
  const lastActiveReportModeRef = useRef(null)
  
  // Ref to prevent multiple calls to getEventBySlug
  const isFetchingEventBySlugRef = useRef(false)
  
  // Ref to prevent URL updates when leaving session
  // CRITICAL: This ref MUST be set to true BEFORE clearing selectedOptionPatientMenu
  // to prevent the menu setup useEffect from re-selecting the menu after leaving
  // See: finallyCloseBookedEvent() and the menu setup useEffect at line ~1821
  const isLeavingSessionRef = useRef(false)
  
  // Ref to track the last slug we intentionally removed from URL
  const lastRemovedSlugRef = useRef(null)
  const [hideLayoutComponents, setHideLayoutComponents] = useState({
    sidebar: false,
    endSession: false,
    patientDetails: false,
  })

  const chamberRoomId = useCheckedInOnlyChamberRoomId()

  // Chamber screen status tracking
  const [chamberScreenStatus, setChamberScreenStatus] = useState('unknown') // 'online', 'offline', or 'unknown'

  const [showDocOnSidebar, setShowDocOnSidebar] = useState()

  const [isCameraOpen, setIsCameraOpen] = useState(false)
  const [isAudioOpen, setIsAudioOpen] = useState(false)
  
  // Device preview states
  const [availableCameras, setAvailableCameras] = useState([])
  const [availableMicrophones, setAvailableMicrophones] = useState([])
  const [availableSpeakers, setAvailableSpeakers] = useState([])
  const [selectedCamera, setSelectedCamera] = useState('')
  const [selectedMicrophone, setSelectedMicrophone] = useState('')
  const [selectedSpeaker, setSelectedSpeaker] = useState('')
  const [previewStream, setPreviewStream] = useState(null)
  const previewVideoRef = useRef(null)

  // Tab state for calendar views
  const [selectedTab, setSelectedTab] = useState(MENTOR_CLINIC_BOOKING_TABS.calendar.id)
  
  // Calendar date state
  const [selectedDate, setSelectedDate] = useState(dayjs().format('DD-MM-YYYY'))
  const isToday = dayjs().format('DD-MM-YYYY') === selectedDate

  // Action button states
  const [patientSearchOpen, setPatientSearchOpen] = useState(false)
  const [bookedSlotsDrawerOpen, setBookedSlotsDrawerOpen] = useState(false)
  const [calendarDrawerOpen, setCalendarDrawerOpen] = useState(false) // Calendar drawer for mobile
  const [combinedMenuAnchorEl, setCombinedMenuAnchorEl] = useState(null) // For 3-dots menu in drawer
  const [isRefreshingBookings, setIsRefreshingBookings] = useState(false)
  const [isLeavingSession, setIsLeavingSession] = useState(false)
  const [isVideoLandscape, setIsVideoLandscape] = useState(false) // Video view mode: false = portrait (full height), true = landscape (full width)
  const [videoLayoutMode, setVideoLayoutMode] = useState(layout.pin) // Video layout: grid or pin (default pin for mentor)
  const [bookedSlotsInDay, setBookedSlotsInDay] = useState([])

  const enrichBookedEventWithPatientData = useCallback((bookedEvent, auxiliaryDataFromApi = null) => {
    if (!bookedEvent || typeof bookedEvent !== 'object') return bookedEvent

    const selectedPatientInfo =
      selectedPatientBookedEventData?.patientInfoData?.id === bookedEvent?.patientId
        ? selectedPatientBookedEventData?.patientInfoData
        : selectedPatientBookedEventData?.patientInfo?.id === bookedEvent?.patientId
          ? selectedPatientBookedEventData?.patientInfo
          : null

    const slotMatch = bookedSlotsInDay?.find(
      (slot) => slot?.id === bookedEvent?.id || slot?.slug === bookedEvent?.slug,
    )
    const patientMatchById = bookedSlotsInDay?.find((slot) => slot?.patientId === bookedEvent?.patientId)

    const auxiliaryPatientInfo = Array.isArray(auxiliaryDataFromApi?.patientInfo)
      ? auxiliaryDataFromApi.patientInfo.find((patient) => patient?.id === bookedEvent?.patientId)
      : auxiliaryDataFromApi?.patientInfo?.id === bookedEvent?.patientId
        ? auxiliaryDataFromApi.patientInfo
        : null

    const resolvedPatientInfo =
      selectedPatientInfo ??
      slotMatch?.patientInfoData ??
      slotMatch?.patientInfo ??
      patientMatchById?.patientInfoData ??
      patientMatchById?.patientInfo ??
      auxiliaryPatientInfo ??
      null

    if (!resolvedPatientInfo) return bookedEvent

    return {
      ...bookedEvent,
      patientInfo: {
        ...(bookedEvent?.patientInfo ?? {}),
        ...resolvedPatientInfo,
      },
      patientInfoData: {
        ...(bookedEvent?.patientInfoData ?? {}),
        ...resolvedPatientInfo,
      },
      patientDateOfBirth:
        bookedEvent?.patientDateOfBirth ?? resolvedPatientInfo?.dateOfBirth ?? null,
      patientGender: bookedEvent?.patientGender ?? resolvedPatientInfo?.gender ?? null,
      patientNumber: bookedEvent?.patientNumber ?? resolvedPatientInfo?.patientNumber ?? null,
      patientName: bookedEvent?.patientName ?? resolvedPatientInfo?.name ?? bookedEvent?.userName ?? null,
    }
  }, [bookedSlotsInDay, selectedPatientBookedEventData])

  const fetchPatientInfoById = useCallback(async (patientId) => {
    if (!patientId) return null
    try {
      const response = await getDataWithParams('/api/secure/patient/get', { patientId })
      if (response?.status === 200 && response?.data?.data) {
        return response.data.data
      }
    } catch (error) {
      console.error('Error fetching patient info for booked event', error)
    }
    return null
  }, [])
  
  // Slot duration state
  const [eachSlotDurationInMins, setEachSlotDurationInMins] = useState(30)
  
  // Calendar navigation functions
  const onPrevClick = useCallback(() => {
    const newDate = dayjs(selectedDate, 'DD-MM-YYYY').subtract(1, 'day').format('DD-MM-YYYY')
    setSelectedDate(newDate)
    // Defer event dispatch to avoid updating components during render
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('calendar-date-change', { detail: { date: newDate } }))
    }, 0)
  }, [selectedDate])
  
  const onNextClick = useCallback(() => {
    const newDate = dayjs(selectedDate, 'DD-MM-YYYY').add(1, 'day').format('DD-MM-YYYY')
    setSelectedDate(newDate)
    // Defer event dispatch to avoid updating components during render
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('calendar-date-change', { detail: { date: newDate } }))
    }, 0)
  }, [selectedDate])
  
  const handleGoToToday = useCallback(() => {
    setSelectedDate(dayjs().format('DD-MM-YYYY'))
  }, [])

  // Action button handlers
  const handleOpenPatientSearch = useCallback(() => {
    setPatientSearchOpen(true)
  }, [])

  const handleOpenBookedSlotsDrawer = useCallback(() => {
    setBookedSlotsDrawerOpen(true)
  }, [])

  const handleRefreshBookings = useCallback(() => {
    // Trigger refresh using the calendar ref
    setIsRefreshingBookings(true)
    if (calendarRef.current?.refresh) {
      calendarRef.current.refresh()
    }
    // Reset the refreshing state after a short delay
    setTimeout(() => {
      setIsRefreshingBookings(false)
    }, 1000)
  }, [])
  
  const clinicSchedules = chosenClinicData?.schedules

  const therapyReportRef = useRef()
  const prescriptionRef = useRef()
  const screeningReportRef = useRef() // NEW: Ref for screening report
  const assessmentReportRef = useRef()
  const calendarRef = useRef() // Ref for calendar component

  if (!chosenClinicData) {
    navigate('/mentor-home')
  }

  // video part:

  const agoraCallbacks = {
    EndCall: () => {
      leaveThisSession()
    },
  } // contains Agora Engine events as keys and callback functions as their values.

  const getAndHandleNextAction = async () => {
    // Don't poll for server actions if we're in a booked event session
    if (isInBookedEventSession) {
      return
    }
    
    const response = await getCPDataWithParams(
      `/api/secure/teacher/mentor-screen/get-next-action`,
      {
        clinicLocationId: clinicLocationId,
        screenState: chamberScreenStateNow,
        joinedChannelName: agoraRtcProps?.channel,
        chamberRoomId: chamberRoomId,
      },
    )
    if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
      handleIncomingNextActionFromServer(response?.data?.data)
      setServerGivenNextAction(response?.data?.data)
    } else {
      showNotification.error('Error getting next action')
    }
  }

  async function handleIncomingNextActionFromServer(nextActionData) {
    // Don't override if we're in a booked event session
    if (isInBookedEventSession) {
      return
    }
    
    const data = nextActionData?.chamberScreenAction
    switch (data?.action) {
      case CHAMBER_SCREEN_ACTIONS.ACTION_JOIN:
        try {
          showNotification.info('Server commanded to join a session...')
          
          await sleep(5000)
          
          await joinAgoraChannelAndStartVideo(data)

          // Call askCheckedInChamberScreenToPollNextAction only after joinAgoraChannelAndStartVideo completes
          const chamberRoomIdForSignal = nextActionData?.channel?.chamberRoomId
          
          if (chamberRoomIdForSignal) {
            await askCheckedInChamberScreenToPollNextAction(chamberRoomIdForSignal)
          }
        } catch (error) {
          showNotification.error('Error joining session. Please try again.')
          // Don't rethrow - allow the function to continue processing other actions
        }
        break
      case CHAMBER_SCREEN_ACTIONS.ACTION_CONTINUE_SESSION:
        // toast.info('Server commanded to continue session...')
        setTimeout(() => continueSession(data), 5000)
        break
      case CHAMBER_SCREEN_ACTIONS.ACTION_LEAVE:
        showNotification.info('Server commanded to leave the current session...')
        setTimeout(() => {
          leaveThisSession()
        }, 5000)
        break
      case CHAMBER_SCREEN_ACTIONS.ACTION_CONTINUE_IDLING:
        // toast.info('Server commanded to continue idling...')
        setTimeout(() => continueIdling(data), 5000)
        break
      default:
        // Unknown action received
        break
    }
  }

  async function informChamberRoomChannelJoin(channelName) {
    const responseOne = await getCPDataWithParams(
      `/api/secure/teacher/mentor-screen/chamber-room-channel/log/join`,
      {
        channelName: channelName,
      },
    )
    // Channel join logged to server
  }

  async function informChamberRoomChannelLeave(channelName) {
    const responseOne = await getCPDataWithParams(
      `/api/secure/teacher/mentor-screen/chamber-room-channel/log/leave`,
      {
        channelName: channelName,
      },
    )
    // Channel leave logged to server
  }

  // Load available devices only when a patient is selected
  // Skip device loading for offline meetings to avoid browser permission prompts
  // Don't load devices just because mentor is checked in - wait until patient is selected
  useEffect(() => {
    // CRITICAL: Check ref FIRST - this is the source of truth set synchronously in getAndSetPatientBookedEventDetails
    // If ref says offline, return immediately without any checks that might trigger device enumeration
    if (isOfflineMeetingRef.current) {
      setAvailableCameras([])
      setAvailableMicrophones([])
      setAvailableSpeakers([])
      return // Don't proceed with device loading - CRITICAL to prevent permission requests
    }
    
    // If no patient is selected and camera/mic are not enabled, don't load devices
    // But if camera/mic are enabled, allow device loading for preview
    if (!selectedPatientBookedEventData && !isCameraOpen && !isAudioOpen) {
      // Don't clear devices if they're already loaded and camera/mic are enabled
      // This allows device dropdowns to remain populated when user enables camera/mic
      if (availableCameras.length === 0 && availableMicrophones.length === 0) {
        return
      }
    }
    
    // Check meetingSrc as additional safeguard (ref should already be set, but double-check)
    const meetingSrc = selectedPatientBookedEventData?.meetingSrc
    const isOffline = meetingSrc === 'offline'
    
    // Update ref to track offline status immediately (synchronously)
    // This ensures ref is always in sync with current data
    isOfflineMeetingRef.current = isOffline
    
    // For offline meetings, explicitly set empty device lists and return early
    // Do this BEFORE any async operations that might request permissions
    if (isOffline) {
      setAvailableCameras([])
      setAvailableMicrophones([])
      setAvailableSpeakers([])
      return // Don't proceed with device loading - CRITICAL to prevent permission requests
    }
    
    // Load devices when:
    // 1. We're in IDLING state (checked in)
    // 2. Either a patient is selected OR camera/mic are enabled (for preview)
    // 3. The meeting is NOT offline (ref is false AND meetingSrc is not 'offline')
    const shouldLoadDevices = 
      chamberScreenStateNow === CHAMBER_SCREEN_STATES.IDLING &&
      !isOfflineMeetingRef.current &&
      (selectedPatientBookedEventData || isCameraOpen || isAudioOpen) &&
      (!selectedPatientBookedEventData || meetingSrc !== 'offline')
    
    if (shouldLoadDevices) {
      const loadDevices = async () => {
        // Final check before calling functions that might request permissions
        // This is a safety check in case state changed during async operation
        // Check ref FIRST, then data
        if (isOfflineMeetingRef.current) {
          return
        }

        if (!selectedPatientBookedEventData || selectedPatientBookedEventData.meetingSrc === 'offline') {
          return
        }
        
        try {
          // Check permissions first - some browsers require permissions before device enumeration
          let hasCameraPermission = false
          let hasMicrophonePermission = false
          
          try {
            if (navigator.permissions) {
              const [cameraPerm, micPerm] = await Promise.all([
                navigator.permissions.query({ name: 'camera' }).catch(() => ({ state: 'prompt' })),
                navigator.permissions.query({ name: 'microphone' }).catch(() => ({ state: 'prompt' })),
              ])
              hasCameraPermission = cameraPerm.state === 'granted'
              hasMicrophonePermission = micPerm.state === 'granted'
            }
          } catch (permError) {
            // Permissions API not available, try to request permissions via getUserMedia
          }
          
          // Request permissions if not granted (this enables device enumeration)
          if (!hasCameraPermission || !hasMicrophonePermission) {
            try {
              const stream = await navigator.mediaDevices.getUserMedia({
                video: true,
                audio: true,
              })
              // Stop the stream immediately - we just needed permissions
              stream.getTracks().forEach(track => track.stop())
              hasCameraPermission = true
              hasMicrophonePermission = true
            } catch (mediaError) {
              // Continue anyway - some browsers allow device enumeration without permissions
            }
          }
          
          // Load devices - these may return empty arrays if permissions aren't granted
          // but we'll try anyway as some browsers allow enumeration without permissions
          const [cameras, microphones, speakers] = await Promise.all([
            AgoraRTC.getCameras().catch(err => {
              // Suppress permission errors - they're expected if permissions weren't granted
              if (err?.code === 'PERMISSION_DENIED' || err?.name === 'NotAllowedError' || err?.message?.includes('Permission denied')) {
                return []
              }
              // Log other unexpected errors
              console.warn('Error getting cameras:', err)
              return []
            }),
            AgoraRTC.getMicrophones().catch(err => {
              // Suppress permission errors
              if (err?.code === 'PERMISSION_DENIED' || err?.name === 'NotAllowedError' || err?.message?.includes('Permission denied')) {
                return []
              }
              // Log other unexpected errors
              console.warn('Error getting microphones:', err)
              return []
            }),
            AgoraRTC.getPlaybackDevices().catch(err => {
              // Check if it's a permission error (some browsers may require permissions for speakers)
              const isPermissionError = err?.code === 'PERMISSION_DENIED' || 
                                      err?.name === 'NotAllowedError' || 
                                      err?.message?.includes('Permission denied') ||
                                      err?.message?.includes('PERMISSION_DENIED')
              if (isPermissionError) {
                // Don't log permission errors for speakers
                return []
              }
              // Log other unexpected errors (but not permission errors)
              console.warn('Error getting speakers:', err)
              return []
            }),
          ])
          
          // Update state with devices
          if (cameras.length > 0) {
            setAvailableCameras(cameras)
            const defaultCam = cameras[0].deviceId
            const localStorageCam = getSelectedCameraInLocalStorage()
            const isLocalCamAvailable = cameras.find((item) => item.deviceId === localStorageCam)
            if (localStorageCam && isLocalCamAvailable) {
              setSelectedCamera(localStorageCam)
            } else {
              setSelectedCamera(defaultCam)
              localStorage.setItem('selectedCamera', defaultCam)
            }
          } else {
            console.warn('No cameras found - permissions may not be granted or no camera available')
            setAvailableCameras([])
            setSelectedCamera('')
          }
          
          if (microphones.length > 0) {
            setAvailableMicrophones(microphones)
            const defaultMic = microphones[0].deviceId
            const localStorageMic = getSelectedMicrophoneInLocalStorage()
            const isLocalMicAvailable = microphones.find((item) => item.deviceId === localStorageMic)
            if (localStorageMic && isLocalMicAvailable) {
              setSelectedMicrophone(localStorageMic)
            } else {
              setSelectedMicrophone(defaultMic)
              localStorage.setItem('selectedMicrophone', defaultMic)
            }
          } else {
            console.warn('No microphones found - permissions may not be granted or no microphone available')
            setAvailableMicrophones([])
            setSelectedMicrophone('')
          }
          
          if (speakers.length > 0) {
            setAvailableSpeakers(speakers)
            const defaultSpeaker = speakers[0].deviceId
            const localStorageSpeaker = getSelectedSpeakerInLocalStorage()
            const isLocalSpeakerAvailable = speakers.find((item) => item.deviceId === localStorageSpeaker)
            if (localStorageSpeaker && isLocalSpeakerAvailable) {
              setSelectedSpeaker(localStorageSpeaker)
            } else {
              setSelectedSpeaker(defaultSpeaker)
              localStorage.setItem('selectedSpeaker', defaultSpeaker)
            }
          } else {
            console.warn('No speakers found')
            setAvailableSpeakers([])
            setSelectedSpeaker('')
          }
        } catch (error) {
          console.error('Error loading devices:', error)
        }
      }
      loadDevices()
    }
  }, [chamberScreenStateNow, selectedPatientBookedEventData, isCameraOpen, isAudioOpen])

  // Refresh devices when session starts (when call auto-joins)
  // This ensures device lists are populated even if initial load failed
  useEffect(() => {
    if (chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING && joinedChannelName) {
      // Session has started, refresh devices to ensure UI is up to date
      const refreshDevices = async () => {
        try {
          // Check if devices are already loaded
          if (availableCameras.length === 0 || availableMicrophones.length === 0) {
            // Request permissions if needed (this enables device enumeration)
            let permissionsExplicitlyDenied = false
            try {
              const stream = await navigator.mediaDevices.getUserMedia({
                video: true,
                audio: true,
              })
              // Stop the stream immediately - we just needed permissions
              stream.getTracks().forEach(track => track.stop())
            } catch (mediaError) {
              // Permission denied is expected if user hasn't granted access
              if (mediaError.name === 'NotAllowedError' || mediaError.name === 'PermissionDeniedError') {
                permissionsExplicitlyDenied = true
              }
            }
            
            // Don't try to enumerate devices if permissions were explicitly denied
            if (permissionsExplicitlyDenied) {
              return
            }
            
            // Load devices (permissions might already be granted or we'll handle errors gracefully)
            const [cameras, microphones, speakers] = await Promise.all([
              AgoraRTC.getCameras().catch(err => {
                // Suppress permission errors - they're expected if permissions weren't granted
                const isPermissionError = err?.code === 'PERMISSION_DENIED' || 
                                        err?.name === 'NotAllowedError' || 
                                        err?.message?.includes('Permission denied') ||
                                        err?.message?.includes('PERMISSION_DENIED')
                if (isPermissionError) {
                  // Silently handle permission errors
                  return []
                }
                // Log other unexpected errors
                // Error getting cameras
                return []
              }),
              AgoraRTC.getMicrophones().catch(err => {
                // Suppress permission errors
                const isPermissionError = err?.code === 'PERMISSION_DENIED' || 
                                        err?.name === 'NotAllowedError' || 
                                        err?.message?.includes('Permission denied') ||
                                        err?.message?.includes('PERMISSION_DENIED')
                if (isPermissionError) {
                  return []
                }
                // Log other unexpected errors
                // Error getting microphones
                return []
              }),
              AgoraRTC.getPlaybackDevices().catch(err => {
                // Check if it's a permission error (some browsers may require permissions for speakers)
                const isPermissionError = err?.code === 'PERMISSION_DENIED' || 
                                        err?.name === 'NotAllowedError' || 
                                        err?.message?.includes('Permission denied') ||
                                        err?.message?.includes('PERMISSION_DENIED')
                if (isPermissionError) {
                  // Don't log permission errors for speakers
                  return []
                }
                // Log other unexpected errors (but not permission errors)
                // Error getting speakers
                return []
              }),
            ])
            
            // Update state with devices
            if (cameras.length > 0) {
              setAvailableCameras(cameras)
              if (!selectedCamera || !cameras.find(cam => cam.deviceId === selectedCamera)) {
                const defaultCam = cameras[0].deviceId
                setSelectedCamera(defaultCam)
                localStorage.setItem('selectedCamera', defaultCam)
              }
            }
            
            if (microphones.length > 0) {
              setAvailableMicrophones(microphones)
              if (!selectedMicrophone || !microphones.find(mic => mic.deviceId === selectedMicrophone)) {
                const defaultMic = microphones[0].deviceId
                setSelectedMicrophone(defaultMic)
                localStorage.setItem('selectedMicrophone', defaultMic)
              }
            }
            
            if (speakers.length > 0) {
              setAvailableSpeakers(speakers)
              if (!selectedSpeaker || !speakers.find(sp => sp.deviceId === selectedSpeaker)) {
                const defaultSpeaker = speakers[0].deviceId
                setSelectedSpeaker(defaultSpeaker)
                localStorage.setItem('selectedSpeaker', defaultSpeaker)
              }
            }
          }
        } catch (error) {
          console.error('[Device Refresh] Error refreshing devices:', error)
        }
      }
      
      // Small delay to ensure permissions are granted after call starts
      const timeoutId = setTimeout(refreshDevices, 500)
      return () => clearTimeout(timeoutId)
    }
  }, [chamberScreenStateNow, joinedChannelName, availableCameras.length, availableMicrophones.length, selectedCamera, selectedMicrophone, selectedSpeaker])

  // Handle camera preview stream
  // Skip camera preview for offline meetings to avoid permission requests
  useEffect(() => {
    let currentStream = null
    
    // Don't start preview for offline meetings - check both ref and meetingSrc
    // But allow preview if no patient is selected (waiting screen)
    const isOfflineMeeting = 
      selectedPatientBookedEventData &&
      (isOfflineMeetingRef.current || selectedPatientBookedEventData?.meetingSrc === 'offline')
    
    if (isCameraOpen && selectedCamera && previewVideoRef.current && !isOfflineMeeting) {
      const startPreview = async () => {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({
            video: { deviceId: { exact: selectedCamera } },
            audio: false,
          })
          if (previewVideoRef.current) {
            previewVideoRef.current.srcObject = stream
            setPreviewStream(stream)
            currentStream = stream
          }
        } catch (error) {
          console.error('Error starting camera preview:', error)
        }
      }
      startPreview()
    } else {
      // Stop preview when camera is turned off
      setPreviewStream((prevStream) => {
        if (prevStream) {
          prevStream.getTracks().forEach(track => track.stop())
          if (previewVideoRef.current) {
            previewVideoRef.current.srcObject = null
          }
        }
        return null
      })
    }

    return () => {
      if (currentStream) {
        currentStream.getTracks().forEach(track => track.stop())
      }
      setPreviewStream((prevStream) => {
        if (prevStream) {
          prevStream.getTracks().forEach(track => track.stop())
        }
        return null
      })
    }
  }, [isCameraOpen, selectedCamera, selectedPatientBookedEventData?.meetingSrc])

  async function joinAgoraChannelAndStartVideo(data) {
    // Don't join chamber room channel if we're in a booked event session
    // Also check if current channel is a booked event channel (not a chamber room channel)
    const currentChannel = agoraRtcProps?.channel
    const isCurrentChannelBookedEvent = currentChannel && !currentChannel.includes('chamber-room') && !currentChannel.includes('CHAMBER')
    
    if (isInBookedEventSession || isCurrentChannelBookedEvent) {
      return
    }
    
    // Stop preview stream before joining
    setPreviewStream((prevStream) => {
      if (prevStream) {
        prevStream.getTracks().forEach(track => track.stop())
        if (previewVideoRef.current) {
          previewVideoRef.current.srcObject = null
        }
      }
      return null
    })
    
    // Validate and refresh device IDs before joining to prevent NotFoundError
    // Also load devices to populate UI dropdowns even if camera/audio aren't enabled yet
    let validCameraDeviceId = undefined
    let validMicrophoneDeviceId = undefined
    
    try {
      // Track permission state to provide better UI feedback
      let cameraPermissionDenied = false
      let microphonePermissionDenied = false
      let speakerError = false
      
      // Always load all devices to populate UI dropdowns, not just when camera/audio are enabled
      // This ensures device lists are available in the UI
      const [currentCameras, currentMicrophones, currentSpeakers] = await Promise.all([
        AgoraRTC.getCameras().catch(err => {
          // Check if it's a permission error
          const isPermissionError = err?.code === 'PERMISSION_DENIED' || 
                                   err?.name === 'NotAllowedError' || 
                                   err?.message?.includes('Permission denied') ||
                                   err?.message?.includes('PERMISSION_DENIED')
          
          if (isPermissionError) {
            cameraPermissionDenied = true
            return []
          }
          // Log other unexpected errors
          // Error getting cameras
          return []
        }),
        AgoraRTC.getMicrophones().catch(err => {
          // Check if it's a permission error
          const isPermissionError = err?.code === 'PERMISSION_DENIED' || 
                                   err?.name === 'NotAllowedError' || 
                                   err?.message?.includes('Permission denied') ||
                                   err?.message?.includes('PERMISSION_DENIED')
          
          if (isPermissionError) {
            microphonePermissionDenied = true
            return []
          }
          // Log other unexpected errors
          // Error getting microphones
          return []
        }),
        AgoraRTC.getPlaybackDevices().catch(err => {
          // Check if it's a permission error (some browsers may require permissions for speakers)
          const isPermissionError = err?.code === 'PERMISSION_DENIED' || 
                                   err?.name === 'NotAllowedError' || 
                                   err?.message?.includes('Permission denied') ||
                                   err?.message?.includes('PERMISSION_DENIED')
          
          if (isPermissionError) {
            // Speakers typically don't require permissions, but some browsers might throw this
            // Don't show a warning for permission errors on speakers
            return []
          }
          // Log other unexpected errors (but not permission errors)
          speakerError = true
          // Error getting speakers
          return []
        }),
      ])
      
      // Update camera devices in state
      if (currentCameras && currentCameras.length > 0) {
        setAvailableCameras(currentCameras)
        const defaultCam = currentCameras[0].deviceId
        const localStorageCam = getSelectedCameraInLocalStorage()
        const isLocalCamAvailable = currentCameras.find((item) => item.deviceId === localStorageCam)
        
        if (localStorageCam && isLocalCamAvailable) {
          setSelectedCamera(localStorageCam)
          if (isCameraOpen) {
            validCameraDeviceId = localStorageCam
          }
        } else {
          setSelectedCamera(defaultCam)
          localStorage.setItem('selectedCamera', defaultCam)
          if (isCameraOpen) {
            validCameraDeviceId = defaultCam
          }
        }
      } else {
        // Only log warning if it's not a permission issue
        if (!cameraPermissionDenied) {
          // No cameras available
        }
        setAvailableCameras([])
      }
      
      // Update microphone devices in state
      if (currentMicrophones && currentMicrophones.length > 0) {
        setAvailableMicrophones(currentMicrophones)
        const defaultMic = currentMicrophones[0].deviceId
        const localStorageMic = getSelectedMicrophoneInLocalStorage()
        const isLocalMicAvailable = currentMicrophones.find((item) => item.deviceId === localStorageMic)
        
        if (localStorageMic && isLocalMicAvailable) {
          setSelectedMicrophone(localStorageMic)
          if (isAudioOpen) {
            validMicrophoneDeviceId = localStorageMic
          }
        } else {
          setSelectedMicrophone(defaultMic)
          localStorage.setItem('selectedMicrophone', defaultMic)
          if (isAudioOpen) {
            validMicrophoneDeviceId = defaultMic
          }
        }
      } else {
        // Only log warning if it's not a permission issue
        if (!microphonePermissionDenied) {
          // No microphones available
        }
        setAvailableMicrophones([])
      }
      
      // Update speaker devices in state
      if (currentSpeakers && currentSpeakers.length > 0) {
        setAvailableSpeakers(currentSpeakers)
        const defaultSpeaker = currentSpeakers[0].deviceId
        const localStorageSpeaker = getSelectedSpeakerInLocalStorage()
        const isLocalSpeakerAvailable = currentSpeakers.find((item) => item.deviceId === localStorageSpeaker)
        
        if (localStorageSpeaker && isLocalSpeakerAvailable) {
          setSelectedSpeaker(localStorageSpeaker)
        } else {
          setSelectedSpeaker(defaultSpeaker)
          localStorage.setItem('selectedSpeaker', defaultSpeaker)
        }
      } else {
        // Only log warning if it's not a permission error
        if (speakerError) {
          // No speakers available
        }
        setAvailableSpeakers([])
      }
      
      // Show user-friendly toast messages if permissions are needed
      if (cameraPermissionDenied || microphonePermissionDenied) {
        const missingPermissions = []
        if (cameraPermissionDenied) missingPermissions.push('camera')
        if (microphonePermissionDenied) missingPermissions.push('microphone')
        
        toast.info(
          `Please allow ${missingPermissions.join(' and ')} access in your browser settings to use video/audio features.`,
          {
            autoClose: 5000,
            toastId: 'media-permissions-needed', // Prevent duplicate toasts
          }
        )
      }
    } catch (error) {
      console.error('[joinAgoraChannelAndStartVideo] Error validating devices:', error)
      // Continue without device IDs if validation fails - Agora will use default devices
    }
    
    await informChamberRoomChannelJoin(data?.joinChannelName)
    setChamberScreenStateNow(CHAMBER_SCREEN_STATES.SESSION_RUNNING)
    setJoinedChamberName(data?.chamberRoomName)
    setJoinedChannelName(data?.joinChannelName)
    setAgoraRtcProps({
      appId: import.meta.env.VITE_AGORA_APP_ID,
      channel: data?.joinChannelName,
      uid: parseInt(data?.joinChannelUid),
      token: data?.joinChannelRtcToken,
      layout: videoLayoutMode,
      role: 'host',
      enableAudio: isAudioOpen,
      enableVideo: isCameraOpen,
      cameraDeviceId: validCameraDeviceId,
      microphoneDeviceId: validMicrophoneDeviceId,
      // Beautiful custom placeholder when camera is off - use memoized wrapper that updates with state
      CustomVideoPlaceholder: customVideoPlaceholderWrapper,
    })
    // Build RTM username as JSON string with role, name, and profilePicId
    const rtmUsername = buildMentorRtmUsername(mentorProfileData)
    let parsedUsername = null
    try {
      parsedUsername = JSON.parse(rtmUsername)
    } catch (e) {
      console.error('Error parsing RTM username:', e)
    }
    // RTM props set for chamber room
    setAgoraRtmProps({
      username: rtmUsername,
      displayUsername: true,
      token: data?.joinChannelRtmToken,
    })
  }

  // Join booked event video call channel - navigates to /l/* page
  async function joinBookedEventVideoCall(bookedEventData) {
    try {
      // Check if session is blocked (payment pending - slot held but not confirmed)
      // No one should be able to join blocked sessions
      const isSessionBlocked = 
        bookedEventData?.status === BOOKING_STATUSES.BOOKING_INITIATED &&
        bookedEventData?.paymentStatus === BOOKING_PAYMENT_STATUSES.PENDING
      
      if (isSessionBlocked) {
        toast.warning('This session is awaiting payment confirmation and cannot be joined yet.')
        return
      }
      
      // Check if this is a video call event type
      const isVideoCallEvent = 
        bookedEventData?.eventType === allAvailableEventTypes.consultation ||
        bookedEventData?.eventType === allAvailableEventTypes.therapySession ||
        bookedEventData?.eventType === allAvailableEventTypes.screening ||
        bookedEventData?.eventType === allAvailableEventTypes.assessment

      if (!isVideoCallEvent) {
        // Not a video call, just set the selected event
        setSelectedPatientBookedEventId(bookedEventData?.id)
        setPatientSelected(true)
        return
      }

      // Store current chamber room state for reconnection BEFORE closing the session
      if (joinedChannelName && chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING) {
        setOriginalChamberRoomChannel(joinedChannelName)
        // Store current Agora props in sessionStorage for reconnection
        sessionStorage.setItem('chamberRoomRtcProps', JSON.stringify(agoraRtcProps))
        sessionStorage.setItem('chamberRoomRtmProps', JSON.stringify(agoraRtmProps))
        sessionStorage.setItem('chamberRoomChannelName', joinedChannelName)
        sessionStorage.setItem('chamberRoomChamberName', joinedChamberName)
        sessionStorage.setItem('chamberRoomUrl', window.location.pathname)
        
        // Close the current video call session to free camera and mic
        // Stop preview stream if active
        setPreviewStream((prevStream) => {
          if (prevStream) {
            prevStream.getTracks().forEach(track => track.stop())
            if (previewVideoRef.current) {
              previewVideoRef.current.srcObject = null
            }
          }
          return null
        })
        
        // Inform server that we're leaving the chamber room channel
        await informChamberRoomChannelLeave(joinedChannelName)
        
        // Use flushSync to ensure state updates complete before navigation
        // This prevents React warnings about updating components during render
        flushSync(() => {
          setAgoraRtcProps({})
          setAgoraRtmProps({})
          setChamberScreenStateNow(CHAMBER_SCREEN_STATES.IDLING)
        })
        
        // Small delay to ensure Agora cleanup completes before navigating
        await new Promise(resolve => setTimeout(resolve, 300))
      }

      // Mark that we're joining this event
      markBookedEventLog(bookedEventData?.id, 'JOIN', 'mentor')
      
      // Navigate to live session page with return state
      const eventSlug = bookedEventData?.slug || bookedEventData?.id
      navigate(`/l/${eventSlug}`, {
        state: {
          from: 'mentor-chamber-room',
          returnUrl: window.location.pathname,
          chamberRoomId: chamberRoomId,
        },
      })
    } catch (error) {
      console.error('Error joining booked event video call:', error)
      showNotification.error('Error joining video call')
    }
  }

  function continueIdling(data) {
    setJoinedChamberName()
    setJoinedChannelName()
    setChamberScreenStateNow(CHAMBER_SCREEN_STATES.IDLING)
  }

  function continueSession(data) {
    setChamberScreenStateNow(CHAMBER_SCREEN_STATES.SESSION_RUNNING)
  }

  /**
   * CRITICAL FIX: Header Persistence After Leaving Session
   * 
   * This function has a specific order of operations that MUST be maintained to prevent
   * the session header from persisting on the calendar page after leaving.
   * 
   * CRITICAL ORDER OF OPERATIONS (DO NOT CHANGE):
   * 1. Set isLeavingSessionRef.current = true FIRST (line ~1102)
   *    - This prevents the menu setup useEffect from re-selecting the menu
   * 2. Refresh event data if markAsCompleted (line ~1140)
   *    - Must happen AFTER guard is set, BEFORE clearing state
   *    - The guard prevents menu re-selection even though data is refreshed
   * 3. Clear selectedOptionPatientMenu and selectedPatientBookedEventData (line ~1147)
   *    - This triggers the header management useEffect to reset header
   * 
   * DEPENDENCIES:
   * - Menu setup useEffect (line ~1821) MUST check isLeavingSessionRef.current FIRST
   * - Header management useEffect (line ~2007) watches selectedOptionPatientMenu
   * - Child report components MUST NOT set headers (they were removed)
   * 
   * IF THIS BREAKS:
   * - Check that isLeavingSessionRef.current is set BEFORE clearing selectedOptionPatientMenu
   * - Check that menu setup useEffect still has the guard check
   * - Check that header management useEffect is still watching selectedOptionPatientMenu
   * - Check that child components aren't setting headers again
   */
  async function finallyCloseBookedEvent(markAsCompleted = false) {
    // Guard against multiple simultaneous calls
    if (isClosingBookedEventRef.current) {
      return
    }
    
    // CRITICAL: Mark that we're leaving FIRST, before any state changes
    // This MUST happen before clearing selectedOptionPatientMenu to prevent the menu setup
    // useEffect from re-selecting the menu. See menu setup useEffect at line ~1821
    // 
    // IMPORTANT: If this line is moved or removed, the header will persist after leaving
    isLeavingSessionRef.current = true
    
    // Reset header IMMEDIATELY before any state changes to prevent it from being re-set
    // This must happen before setSelectedOptionPatientMenu() to ensure header is cleared
    // Reset for ALL report types: prescription, therapy_report, screening_report, assessment_report
    // Use flushSync to ensure this happens synchronously before other state updates
    flushSync(() => {
      setFlowId(null)
      setButtonTopOffset(0)
    })
    
    // Immediately set to mentor-portal to ensure calendar header shows
    // Use requestAnimationFrame to ensure this runs after the null reset but still quickly
    requestAnimationFrame(() => {
      setFlowId('mentor-portal')
    })
    
    // Only log LEAVE if we have a valid booked event ID
    const bookedEventId = selectedPatientBookedEventData?.id
    if (bookedEventId) {
      isClosingBookedEventRef.current = true
      try {
        await markBookedEventLog(bookedEventId, 'LEAVE', 'mentor')
      } catch (error) {
        console.error('Error logging LEAVE event:', error)
      } finally {
        // Reset the guard after a short delay to allow state updates to complete
        setTimeout(() => {
          isClosingBookedEventRef.current = false
        }, 1000)
      }
    }
    
    // If marking as completed, refresh event data BEFORE clearing state
    // This ensures the calendar shows the updated "completed" status
    // 
    // CRITICAL ORDER: This MUST happen:
    // 1. AFTER isLeavingSessionRef.current = true (already set above)
    // 2. BEFORE clearing selectedOptionPatientMenu (below)
    // 
    // The isLeavingSessionRef guard in the menu setup useEffect will prevent menu re-selection
    // even though we're refreshing the event data here
    if (markAsCompleted && selectedPatientBookedEventId) {
      // Verify guard is set (defensive check)
      if (!isLeavingSessionRef.current) {
        isLeavingSessionRef.current = true
      }
      
      await markBookedSessionAsCompletedFunction(selectedPatientBookedEventData)
      // Refresh event data to show updated "completed" status
      // isLeavingSessionRef is already true, so the menu setup useEffect won't re-select the menu
      await getAndSetPatientBookedEventDetails(false)
    }
    
    // Clear state in a batch to prevent multiple re-renders
    // Use flushSync to ensure these happen synchronously and in order
    flushSync(() => {
      // Clear selectedOptionPatientMenu FIRST - this will trigger the parent's useEffect
      // to automatically reset the header (since parent manages header based on this state)
      setSelectedOptionPatientMenu()
      
      // Clear selectedPatientBookedEventData - this also triggers parent's header reset
      setSelectedPatientBookedEventData(null)
      
      // Then clear other state
      setSelectedPatientBookedEventId()
      setPatientSelected(false)
      setNewWantedMenuItemId()
    })
    
    // Header will be automatically reset by the parent's useEffect that watches selectedOptionPatientMenu
    // No need to manually reset it here - the parent is the single source of truth
    
    // Remove /l/<slug> from URL when leaving session
    // Use flushSync to ensure URL is updated synchronously before any other effects run
    if (clinicBrandId && clinicLocationId) {
      const basePath = `/mentor-home/join-chamber-room/${clinicBrandId}/${clinicLocationId}`
      const currentPath = window.location.pathname // Use window.location to get absolute latest
      // If URL contains /l/, remove it immediately
      if (currentPath.includes('/l/')) {
        // Extract the slug we're removing to prevent re-adding it
        const slugMatch = currentPath.match(/\/l\/([^/]+)/)
        if (slugMatch) {
          lastRemovedSlugRef.current = slugMatch[1]
        }
        // Use navigate with replace to update URL and prevent back navigation
        flushSync(() => {
          navigate(basePath, { replace: true })
        })
        // Force a small delay to ensure URL change is processed before any effects run
        await new Promise(resolve => setTimeout(resolve, 100))
      }
    }
    
    // Keep the leaving flag set for longer to prevent URL updates from re-triggering
    // Reset after a longer delay to ensure all effects have completed
    setTimeout(() => {
      isLeavingSessionRef.current = false
      // Clear the removed slug ref after a longer delay to allow new sessions to be opened
      setTimeout(() => {
        lastRemovedSlugRef.current = null
      }, 2000) // Increased delay to prevent re-opening
    }, 1000) // Increased delay to ensure all effects have completed
    
    // If we were in a booked event video call session, reconnect to chamber room
    if (isInBookedEventSession) {
      setIsInBookedEventSession(false)
      // Leave the booked event channel
      if (joinedChannelName) {
        informChamberRoomChannelLeave(joinedChannelName)
      }
      // Reset video call state
      setJoinedChamberName()
      setJoinedChannelName()
      setChamberScreenStateNow(CHAMBER_SCREEN_STATES.IDLING)
      setAgoraRtcProps({})
      setAgoraRtmProps({})
      // Trigger reconnection to chamber room by calling getAndHandleNextAction
      // The server will send the chamber room join action
      setTimeout(() => {
        if (chamberRoomId) {
          getAndHandleNextAction()
        }
      }, 500)
    }
  }

  // Function to mark as completed without leaving the page
  async function markAsCompletedOnly() {
    if (selectedOptionPatientMenu === 'screening_report') {
      // For screening reports, use the new markAsCompletedOnly function
      await screeningReportRef?.current?.markAsCompletedOnly()
      // Mark the event as completed via API
      if (selectedPatientBookedEventData) {
        await markBookedSessionAsCompletedFunction(selectedPatientBookedEventData)
        // Refresh the event data to show updated status
        await getAndSetPatientBookedEventDetails(false)
      }
      return
    }
    
    // For other report types, fall back to closeBookedEvent
    await closeBookedEvent(true)
  }

  async function closeBookedEvent(markAsCompleted = true) {
    // Default to true - "Save & Leave Session" should always mark as completed
    if (selectedOptionPatientMenu === 'prescription') {
      setNewWantedMenuItemId('end')
      await prescriptionRef?.current?.savePrescriptionData()
    }
    if (selectedOptionPatientMenu === 'therapy_report') {
      try {
        const result = await therapyReportRef?.current?.checkAndOpenModal(markAsCompleted)
        // Therapy checkAndOpenModal only saves and returns continue/stop; it does NOT call leaveRoom.
        // When result is continue, we must call finallyCloseBookedEvent to clear state and return to calendar (same as screening).
        if (result === FLOW_STATUSES_FOR_LEAVING_SESSION.continue) {
          await finallyCloseBookedEvent(markAsCompleted)
        }
        return result
      } catch (error) {
        console.error('Error in checkAndOpenModal:', error)
        throw error
      }
    }
    if (selectedOptionPatientMenu === 'screening_report') {
      // For screening reports, checkAndOpenModal with shouldLeave=true will handle leaving
      const result = await screeningReportRef?.current?.checkAndOpenModal(markAsCompleted, true)
      if (result === FLOW_STATUSES_FOR_LEAVING_SESSION.continue) {
        await finallyCloseBookedEvent(markAsCompleted)
      }
      return result
    }

    await finallyCloseBookedEvent(markAsCompleted)
  }

  // Cleanup function to stop all media tracks (both video and audio)
  const cleanupMediaTracks = useCallback(() => {
    try {
      // Stop all tracks from any active media streams
      // This includes tracks from getUserMedia, Agora local streams, and preview streams
      
      // 1. Clean up video elements
      const videoElements = document.querySelectorAll('video')
      videoElements.forEach((video) => {
        if (video.srcObject) {
          const stream = video.srcObject
          if (stream instanceof MediaStream) {
            stream.getTracks().forEach((track) => {
              if (track.readyState !== 'ended') {
                track.stop()
              }
            })
          }
          video.srcObject = null
        }
      })

      // 2. Clean up audio elements
      const audioElements = document.querySelectorAll('audio')
      audioElements.forEach((audio) => {
        if (audio.srcObject) {
          const stream = audio.srcObject
          if (stream instanceof MediaStream) {
            stream.getTracks().forEach((track) => {
              if (track.readyState !== 'ended') {
                track.stop()
              }
            })
          }
          audio.srcObject = null
        }
      })

      // 3. Clean up preview stream if active
      setPreviewStream((prevStream) => {
        if (prevStream) {
          prevStream.getTracks().forEach((track) => {
            if (track.readyState !== 'ended') {
              track.stop()
            }
          })
          if (previewVideoRef.current) {
            previewVideoRef.current.srcObject = null
          }
        }
        return null
      })

      // 4. Explicitly stop all audio and video tracks from any active streams
      const allMediaElements = document.querySelectorAll('video, audio')
      allMediaElements.forEach((element) => {
        if (element.srcObject) {
          const stream = element.srcObject
          if (stream instanceof MediaStream) {
            stream.getAudioTracks().forEach((audioTrack) => {
              if (audioTrack.readyState !== 'ended') {
                audioTrack.stop()
              }
            })
            stream.getVideoTracks().forEach((videoTrack) => {
              if (videoTrack.readyState !== 'ended') {
                videoTrack.stop()
              }
            })
          }
        }
      })

      // 5. Clean up any tracked streams in global scope (if used)
      if (window.localMediaStreams && Array.isArray(window.localMediaStreams)) {
        window.localMediaStreams.forEach((stream) => {
          if (stream instanceof MediaStream) {
            stream.getTracks().forEach((track) => {
              if (track.readyState !== 'ended') {
                track.stop()
              }
            })
          }
        })
        window.localMediaStreams = []
      }
    } catch (error) {
      console.error('Error cleaning up media tracks:', error)
    }
  }, [])

  async function leaveThisSession() {
    // Cleanup all media tracks (camera and microphone) before leaving
    cleanupMediaTracks()
    
    informChamberRoomChannelLeave(joinedChannelName)
    setJoinedChamberName()
    setJoinedChannelName()
    setChamberScreenStateNow(CHAMBER_SCREEN_STATES.IDLING)
    setAgoraRtcProps({})
    setAgoraRtmProps({})
    
    // If we were in a booked event session, reconnect to chamber room
    if (isInBookedEventSession) {
      setIsInBookedEventSession(false)
      // Trigger reconnection to chamber room
      setTimeout(() => {
        if (chamberRoomId) {
          getAndHandleNextAction()
        }
      }, 500)
    }
  }

  // Use refs to track current camera/audio state without causing effect re-runs
  const isCameraOpenRef = useRef(isCameraOpen)
  const isAudioOpenRef = useRef(isAudioOpen)
  
  // Update refs when values change (without triggering effect)
  useEffect(() => {
    isCameraOpenRef.current = isCameraOpen
  }, [isCameraOpen])
  
  useEffect(() => {
    isAudioOpenRef.current = isAudioOpen
  }, [isAudioOpen])

  const handleRefreshStatusForUser = useCallback(() => {
    if (!selectedPatientBookedEventId) return
    markBookedEventLog(selectedPatientBookedEventId, 'REFRESH', 'mentor', {
      camera: isCameraOpenRef.current,
      mic: isAudioOpenRef.current,
    })
  }, [selectedPatientBookedEventId])

  useEffect(() => {
    let interval = null
    if (selectedPatientBookedEventId) {
      // Immediately log status when session starts
      handleRefreshStatusForUser()
      // Set up periodic logging every 3 minutes (180000ms)
      interval = setInterval(() => {
        handleRefreshStatusForUser()
      }, 180000)
    }
    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }
  }, [selectedPatientBookedEventId, handleRefreshStatusForUser])

  // Log camera/mic state changes immediately when they toggle (without resetting the interval)
  // Use refs to track previous values and only log when they actually change
  const prevCameraStateRef = useRef(isCameraOpen)
  const prevAudioStateRef = useRef(isAudioOpen)
  const prevBookedEventIdRef = useRef(selectedPatientBookedEventId)

  useEffect(() => {
    // If session changed (new session started or ended), reset tracking refs
    // This ensures we don't log on session start (interval effect handles that)
    if (prevBookedEventIdRef.current !== selectedPatientBookedEventId) {
      prevBookedEventIdRef.current = selectedPatientBookedEventId
      prevCameraStateRef.current = isCameraOpen
      prevAudioStateRef.current = isAudioOpen
      return
    }

    // Only log if we have an active session and the state actually changed
    if (selectedPatientBookedEventId) {
      const cameraChanged = prevCameraStateRef.current !== isCameraOpen
      const audioChanged = prevAudioStateRef.current !== isAudioOpen

      if (cameraChanged || audioChanged) {
        // Log the state change immediately
        markBookedEventLog(selectedPatientBookedEventId, 'REFRESH', 'mentor', {
          camera: isCameraOpen,
          mic: isAudioOpen,
        })

        // Update refs to track current state
        prevCameraStateRef.current = isCameraOpen
        prevAudioStateRef.current = isAudioOpen
      }
    }
  }, [isCameraOpen, isAudioOpen, selectedPatientBookedEventId])

  // Store channel in ref to avoid recreating interval unnecessarily
  const currentChannelRef = useRef(agoraRtcProps?.channel)
  useEffect(() => {
    currentChannelRef.current = agoraRtcProps?.channel
  }, [agoraRtcProps?.channel])

  useEffect(() => {
    if (chamberRoomId) {
      getAndHandleNextAction() // Initial call
    }
  }, [chamberRoomId])

  // Cleanup media tracks on component unmount
  useEffect(() => {
    return () => {
      cleanupMediaTracks()
    }
  }, [cleanupMediaTracks])

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (chamberRoomId) {
        getAndHandleNextAction()
      }
    }, 60000)
    return () => {
      clearInterval(intervalId)
    }
    // Only recreate interval when these core values change, not when agoraRtcProps object reference changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chamberRoomId, chamberScreenStateNow, clinicLocationId])

  // Periodically check chamber screen status
  useEffect(() => {
    if (!chamberRoomId) {
      setChamberScreenStatus('unknown')
      return
    }

    // Initial check
    const checkStatus = async () => {
      try {
        const status = await checkChamberScreenStatus(chamberRoomId)
        setChamberScreenStatus(status)
      } catch (error) {
        console.error('[MENTOR PORTAL] Error checking chamber screen status:', error)
        setChamberScreenStatus('unknown')
      }
    }

    checkStatus()

    // Check every 30 seconds
    const statusIntervalId = setInterval(() => {
      checkStatus()
    }, 30000)

    return () => {
      clearInterval(statusIntervalId)
    }
  }, [chamberRoomId])

  // Auto-refresh calendar bookings (similar to calendar page)
  useEffect(() => {
    // Only auto-refresh when viewing calendar tab
    if (selectedTab !== MENTOR_CLINIC_BOOKING_TABS.calendar.id) {
      return
    }
    
    // Initial refresh
    if (calendarRef.current?.refresh) {
      calendarRef.current.refresh()
    }
    
    // Scroll to current time when returning to calendar view
    // Only scroll if viewing today's date
    const isToday = dayjs().format('DD-MM-YYYY') === selectedDate
    if (isToday && calendarRef.current?.scrollToPresentLine) {
      // Small delay to ensure calendar is rendered
      setTimeout(() => {
        calendarRef.current?.scrollToPresentLine()
      }, 500)
    }
    
    // Set up interval to refresh every 75 seconds (same as calendar page)
    const intervalId = setInterval(() => {
      if (calendarRef.current?.refresh) {
        calendarRef.current.refresh()
      }
    }, 75000)
    
    return () => {
      clearInterval(intervalId)
    }
  }, [selectedTab, selectedDate]) // Refresh when tab or date changes

  // interaction part:

  async function getAndSetPatientBookedEventDetails(updateBookedEventDatOnly = false) {
    const bookedEventDetailResponse = await getDataWithoutParams(
      `/api/secure/user/booked-slot/details?eventId=${selectedPatientBookedEventId}&send-auxiliary-data=true`,
    )
    if (
      isCommonResponseSuccessful(bookedEventDetailResponse?.data?.code) &&
      Object.keys(bookedEventDetailResponse?.data?.data?.bookedEvent)?.length !== 0
    ) {
      const { bookedEvent, ...auxiliaryDataFromApi } = bookedEventDetailResponse?.data?.data
      
      // Immediately check if this is an offline meeting and set the ref
      if (bookedEvent?.meetingSrc === 'offline') {
        isOfflineMeetingRef.current = true
        // Clear devices immediately for offline meetings
        setAvailableCameras([])
        setAvailableMicrophones([])
        setAvailableSpeakers([])
      } else {
        isOfflineMeetingRef.current = false
      }
      
      let enrichedBookedEvent = enrichBookedEventWithPatientData(bookedEvent, auxiliaryDataFromApi)
      if (!(
        enrichedBookedEvent?.patientInfoData?.dateOfBirth ||
        enrichedBookedEvent?.patientInfo?.dateOfBirth ||
        enrichedBookedEvent?.patientDateOfBirth
      )) {
        const fetchedPatientInfo = await fetchPatientInfoById(bookedEvent?.patientId)
        if (fetchedPatientInfo) {
          enrichedBookedEvent = enrichBookedEventWithPatientData(bookedEvent, {
            ...auxiliaryDataFromApi,
            patientInfo: fetchedPatientInfo,
          })
        }
      }

      if (updateBookedEventDatOnly) {
        setSelectedPatientBookedEventData(enrichedBookedEvent)
      } else {
        setAuxiliaryData(auxiliaryDataFromApi)
        setSelectedPatientBookedEventData(enrichedBookedEvent)
      }
    }
  }

  // Function to get event by slug (for URL-based session opening)
  async function getEventBySlug(slug) {
    try {
      const response = await getDataWithoutParams(
        `/api/secure/user/booked-slot/details?slug=${slug}&send-auxiliary-data=true`,
      )
      if (
        isCommonResponseSuccessful(response?.data?.code) &&
        Object.keys(response?.data?.data?.bookedEvent)?.length !== 0
      ) {
        const { bookedEvent, ...auxiliaryDataFromApi } = response?.data?.data
        let enrichedBookedEvent = enrichBookedEventWithPatientData(bookedEvent, auxiliaryDataFromApi)
        if (!(
          enrichedBookedEvent?.patientInfoData?.dateOfBirth ||
          enrichedBookedEvent?.patientInfo?.dateOfBirth ||
          enrichedBookedEvent?.patientDateOfBirth
        )) {
          const fetchedPatientInfo = await fetchPatientInfoById(bookedEvent?.patientId)
          if (fetchedPatientInfo) {
            enrichedBookedEvent = enrichBookedEventWithPatientData(bookedEvent, {
              ...auxiliaryDataFromApi,
              patientInfo: fetchedPatientInfo,
            })
          }
        }
        setAuxiliaryData(auxiliaryDataFromApi)
        setSelectedPatientBookedEventData(enrichedBookedEvent)
        setSelectedPatientBookedEventId(bookedEvent?.id)
        setPatientSelected(true)
        return bookedEvent
      }
    } catch (error) {
      console.error('Error fetching event by slug:', error)
    }
    return null
  }

  async function setup() {
    setPatientBookedSlotDetailsLoading(true)
    await getAndSetPatientBookedEventDetails()
    setPatientBookedSlotDetailsLoading(false)
  }

  const allowPrescribing =
    selectedPatientBookedEventData?.patientId &&
    (getAllRolesInBoolean().isDoctor ||
      selectedPatientBookedEventData?.eventType === allAvailableEventTypes.consultation) &&
    mentorProfileData?.allowedToPrescribe

  const allowTherapyReport =
    selectedPatientBookedEventData?.patientId &&
    selectedPatientBookedEventData?.eventType === allAvailableEventTypes.therapySession
  const allowAssessmentReport =
    selectedPatientBookedEventData?.patientId &&
    selectedPatientBookedEventData?.eventType === allAvailableEventTypes.assessment

  const allowScreeningReport =
    selectedPatientBookedEventData?.patientId &&
    selectedPatientBookedEventData?.eventType === allAvailableEventTypes.screening

  function showPaymentQrToPatient(paymentLinkWithPatientDetails) {
    if (paymentLinkWithPatientDetails?.userPaymentLink?.paymentLink) {
      showSnackBar(
        'Showing payment QR with patient details on room screen',
        200,
        serverGivenNextAction?.channel?.chamberRoomId,
      )
    } else {
      showSnackBar(
        'Showing created patient details on room screen',
        200,
        serverGivenNextAction?.channel?.chamberRoomId,
      )
    }

    sendShowImageCommandToChamberScreen(
      serverGivenNextAction?.channel?.chamberRoomId,
      'event-booking-payment-qr-with-patient-details',
      paymentLinkWithPatientDetails,
    )
  }

  // Desktop horizontal resizer - waits for refs to be ready
  useEffect(() => {
    if (isMobile) {
      return undefined
    }

    let cleanup = null
    let interval = null
    const minLeftWidth = 200
    const minRightWidth = 400

    // Check if refs are ready
    const checkRefs = () => {
      const dragger = refLeft?.current
      const leftPanel = refVideoContainer?.current
      const rightPanel = refBox?.current

      if (!dragger || !leftPanel || !rightPanel) {
        return false
      }

      // Check if resizer is visible (not hidden on mobile)
      const resizerStyles = window.getComputedStyle(dragger)
      const isVisible = resizerStyles.display !== 'none'

      if (!isVisible) {
        return false
      }

      return true
    }

    function setupResizer() {
      const dragger = refLeft?.current
      const leftPanel = refVideoContainer?.current
      const rightPanel = refBox?.current

      if (!dragger || !leftPanel || !rightPanel) {
        return null
      }

      let startX = 0
      let startLeftWidth = 0
      let startRightWidth = 0
      let isDragging = false

      const applyPanelWidths = (leftWidth, rightWidth) => {
        leftPanel.style.width = `${leftWidth}px`
        leftPanel.style.flexShrink = '0'
        leftPanel.style.flexGrow = '0'
        leftPanel.style.flexBasis = `${leftWidth}px`

        rightPanel.style.width = `${rightWidth}px`
        rightPanel.style.flexShrink = '0'
        rightPanel.style.flexGrow = '0'
        rightPanel.style.flexBasis = `${rightWidth}px`
      }

      /**
       * Get clientX from either mouse or touch event
       */
      const getClientX = (e) => {
        return e.touches ? e.touches[0].clientX : e.clientX
      }

      const getAvailableWidth = () => {
        const separatorWidth = dragger.getBoundingClientRect().width || dragger.offsetWidth || 0
        const containerWidth =
          dragger.parentElement?.getBoundingClientRect().width ||
          leftPanel.offsetWidth + rightPanel.offsetWidth + separatorWidth

        return Math.max(minLeftWidth + minRightWidth, containerWidth - separatorWidth)
      }

      const getNextWidths = (deltaX) => {
        const availableWidth = getAvailableWidth()
        const minDelta = minLeftWidth - startLeftWidth
        const maxDelta = startRightWidth - minRightWidth
        const boundedDelta = Math.min(maxDelta, Math.max(minDelta, deltaX))
        const nextLeftWidth = Math.min(
          availableWidth - minRightWidth,
          Math.max(minLeftWidth, startLeftWidth + boundedDelta),
        )
        const nextRightWidth = Math.max(minRightWidth, availableWidth - nextLeftWidth)

        return { nextLeftWidth, nextRightWidth }
      }

      /**
       * Handle movement during drag (works for both mouse and touch)
       * Calculates new panel widths and applies them in real-time
       */
      const handleMove = (e) => {
        if (!isDragging) return

        if (e.touches) {
          e.preventDefault()
        }

        const currentX = getClientX(e)
        const deltaX = currentX - startX
        const { nextLeftWidth, nextRightWidth } = getNextWidths(deltaX)
        applyPanelWidths(nextLeftWidth, nextRightWidth)
      }

      /**
       * Handle end of drag - clean up event listeners and reset styles
       */
      const handleEnd = () => {
        isDragging = false
        document.removeEventListener('mousemove', handleMove)
        document.removeEventListener('mouseup', handleEnd)
        document.removeEventListener('touchmove', handleMove)
        document.removeEventListener('touchend', handleEnd)
        document.removeEventListener('touchcancel', handleEnd)
        window.removeEventListener('blur', handleEnd)
        document.body.style.cursor = ''
        document.body.style.userSelect = ''
        document.body.style.touchAction = ''
      }

      /**
       * Handle start of drag (works for both mouse and touch)
       */
      const handleStart = (e) => {
        if (!e.touches && e.button !== undefined && e.button !== 0) {
          return
        }

        e.preventDefault()
        e.stopPropagation()

        // Store initial state
        startX = getClientX(e)
        startLeftWidth = leftPanel.offsetWidth
        startRightWidth = rightPanel.offsetWidth
        isDragging = true

        // Set drag cursor and disable text selection
        document.body.style.cursor = 'col-resize'
        document.body.style.userSelect = 'none'
        document.body.style.touchAction = 'none' // Prevent scrolling while dragging

        // Add document-level event listeners for smooth dragging
        if (e.touches) {
          // Touch events
          document.addEventListener('touchmove', handleMove, { passive: false })
          document.addEventListener('touchend', handleEnd)
          document.addEventListener('touchcancel', handleEnd)
        } else {
          // Mouse events
          document.addEventListener('mousemove', handleMove)
          document.addEventListener('mouseup', handleEnd)
        }

        window.addEventListener('blur', handleEnd)
      }

      // Attach event listeners for both mouse and touch
      dragger.addEventListener('mousedown', handleStart, true) // Use capture phase
      dragger.addEventListener('touchstart', handleStart, { passive: false, capture: true })

      // Return cleanup function
      return () => {
        isDragging = false
        dragger.removeEventListener('mousedown', handleStart, true)
        dragger.removeEventListener('touchstart', handleStart, true)
        document.removeEventListener('mousemove', handleMove)
        document.removeEventListener('mouseup', handleEnd)
        document.removeEventListener('touchmove', handleMove)
        document.removeEventListener('touchend', handleEnd)
        document.removeEventListener('touchcancel', handleEnd)
        window.removeEventListener('blur', handleEnd)
        document.body.style.cursor = ''
        document.body.style.userSelect = ''
        document.body.style.touchAction = ''
      }
    }

    // Wait for refs to be ready
    if (!checkRefs()) {
      // Set up interval to check periodically until refs are ready
      interval = setInterval(() => {
        if (checkRefs()) {
          clearInterval(interval)
          cleanup = setupResizer()
        }
      }, 100)
    } else {
      // Refs are ready, set up immediately
      cleanup = setupResizer()
    }

    return () => {
      if (interval) {
        clearInterval(interval)
      }
      if (cleanup) {
        cleanup()
      }
    }
  }, [chamberScreenStateNow, isMobile])

  useEffect(() => {
    // CRITICAL GUARD: Don't set menu options or selectedOptionPatientMenu if we're leaving a session
    // This prevents the menu from being re-selected after we've cleared it in finallyCloseBookedEvent()
    // 
    // IMPORTANT: This guard MUST be checked FIRST, before any other logic
    // If this guard is removed or moved, the header will persist after leaving a session
    // 
    // The guard works by checking isLeavingSessionRef.current, which is set to true
    // in finallyCloseBookedEvent() BEFORE clearing selectedOptionPatientMenu
    if (isLeavingSessionRef.current) {
      return
    }
    
    // Additional defensive check: If selectedOptionPatientMenu was just cleared (undefined/null)
    // and we're not in a normal session setup flow, don't auto-select
    // This is a secondary guard in case isLeavingSessionRef gets reset too early
    if (!selectedOptionPatientMenu && !selectedPatientBookedEventData) {
      // Both are cleared - likely we're leaving, don't set menu
      return
    }
    
    if (selectedPatientBookedEventData) {
      const menu = []
      if (allowPrescribing) {
        menu.unshift({ label: 'Vitals', id: 'vitals' })
        menu.unshift({ label: 'Patient History', id: 'patient_history' })
        menu.unshift({ label: 'Prescription', id: 'prescription' })
      }
      if (allowTherapyReport) {
        menu.unshift({ label: 'Patient History', id: 'patient_history' })
        menu.unshift({ label: 'Therapy Report', id: 'therapy_report' })
      }
      if (allowAssessmentReport) {
        menu.unshift({ label: 'Patient History', id: 'patient_history' })
        menu.unshift({ label: 'Assessment Report', id: 'assessment_report' })
      }
      if (allowScreeningReport) {
        menu.unshift({ label: 'Screening Report', id: 'screening_report' })
      }
      // Assessments tab on prescription/therapy/screening sessions (not on Assessment Report page — that page has its own launcher)
      if (allowPrescribing || allowTherapyReport || allowScreeningReport) {
        menu.push({ label: 'Assessments', id: 'assessments' })
      }
      setPatientMenuOptions(menu)
      if (!Boolean(selectedOptionPatientMenu)) {
        setSelectedOptionPatientMenu(menu?.[0]?.id)
      }
    }
  }, [selectedPatientBookedEventData, selectedOptionPatientMenu, allowPrescribing, allowTherapyReport, allowAssessmentReport, allowScreeningReport])

  useEffect(() => {
    setup()
  }, [selectedPatientBookedEventId])

  useEffect(() => {
    if (!selectedPatientBookedEventData?.id || !selectedPatientBookedEventData?.patientId) return

    const hasUsablePatientDob = Boolean(
      selectedPatientBookedEventData?.patientInfoData?.dateOfBirth ||
      selectedPatientBookedEventData?.patientInfo?.dateOfBirth ||
      selectedPatientBookedEventData?.patientDateOfBirth,
    )

    if (hasUsablePatientDob) return

    const enriched = enrichBookedEventWithPatientData(selectedPatientBookedEventData)
    if (enriched !== selectedPatientBookedEventData) {
      setSelectedPatientBookedEventData(enriched)
    }
  }, [bookedSlotsInDay, enrichBookedEventWithPatientData, selectedPatientBookedEventData])

  // Handle URL-based session opening (when URL contains /l/<slug>)
  useEffect(() => {
    // Don't open session if we're leaving
    if (isLeavingSessionRef.current) {
      return
    }
    
    // Don't open session if we just removed this slug
    if (sessionSlug && lastRemovedSlugRef.current === sessionSlug) {
      return
    }
    
    // Check if the current URL actually contains the slug (React Router params might be stale)
    const currentUrlPath = window.location.pathname
    const expectedSlugPath = sessionSlug ? `/l/${sessionSlug}` : ''
    if (sessionSlug && !currentUrlPath.includes(expectedSlugPath)) {
      return
    }
    
    // Use requestAnimationFrame to ensure this runs after render, not during
    if (sessionSlug && clinicBrandId && clinicLocationId && !selectedPatientBookedEventData && !isFetchingEventBySlugRef.current) {
      isFetchingEventBySlugRef.current = true
      requestAnimationFrame(() => {
        // Double-check we're not leaving before fetching
        if (isLeavingSessionRef.current || lastRemovedSlugRef.current === sessionSlug) {
          isFetchingEventBySlugRef.current = false
          return
        }
        
        // Triple-check URL still contains the slug
        const currentUrlPathCheck = window.location.pathname
        if (!currentUrlPathCheck.includes(`/l/${sessionSlug}`)) {
          isFetchingEventBySlugRef.current = false
          return
        }
        
        // URL has a session slug, fetch and open that session
        getEventBySlug(sessionSlug).finally(() => {
          isFetchingEventBySlugRef.current = false
        })
      })
    }
  }, [sessionSlug, clinicBrandId, clinicLocationId, selectedPatientBookedEventData, location.pathname])

  // Update URL when session is opened
  useEffect(() => {
    // Don't update URL if we're in the process of leaving
    if (isLeavingSessionRef.current) {
      return
    }
    
    // Don't update URL if selectedPatientBookedEventData is null/undefined (we've left the session)
    if (!selectedPatientBookedEventData) {
      return
    }
    
    // Get clinicBrandId from props or from chosenClinicData
    const effectiveClinicBrandId = clinicBrandId || chosenClinicData?.clinicBrandId
    
    // Check if current URL is the base path (no /l/) - if so, don't add session slug
    // Use window.location to get the absolute latest pathname (React Router location might be stale)
    const currentPath = window.location.pathname
    const basePath = `/mentor-home/join-chamber-room/${effectiveClinicBrandId}/${clinicLocationId}`
    
    // If we're on the base path (no /l/), don't add session slug - we've left the session
    if (currentPath === basePath || (!currentPath.includes('/l/') && effectiveClinicBrandId && clinicLocationId)) {
      return
    }
    
    // Don't add a slug that was just removed
    if (selectedPatientBookedEventData?.slug && lastRemovedSlugRef.current === selectedPatientBookedEventData.slug) {
      return
    }
    
    if (selectedPatientBookedEventData?.slug && effectiveClinicBrandId && clinicLocationId) {
      // Use requestAnimationFrame to ensure this runs after render, not during
      requestAnimationFrame(() => {
        // Triple-check we're not leaving and data still exists before updating URL
        if (isLeavingSessionRef.current || !selectedPatientBookedEventData) {
          return
        }
        
        // Don't re-add a slug we just removed (check again in case it changed)
        if (lastRemovedSlugRef.current === selectedPatientBookedEventData.slug) {
          return
        }
        
        // Double-check current path hasn't changed to base path
        const currentPathCheck = window.location.pathname
        const basePathCheck = `/mentor-home/join-chamber-room/${effectiveClinicBrandId}/${clinicLocationId}`
        if (currentPathCheck === basePathCheck || !currentPathCheck.includes('/l/')) {
          return
        }
        
        const sessionPath = `${basePathCheck}/l/${selectedPatientBookedEventData.slug}`
        
        // Only update URL if it doesn't already have the session slug
        if (!currentPathCheck.includes(`/l/${selectedPatientBookedEventData.slug}`)) {
          navigate(sessionPath, { replace: true })
          // Clear the removed slug ref since we're adding it back
          lastRemovedSlugRef.current = null
        }
      })
    }
  }, [selectedPatientBookedEventData, selectedPatientBookedEventData?.slug, clinicBrandId, clinicLocationId, chosenClinicData?.clinicBrandId, navigate, location.pathname])
  
  // SIMPLIFIED DESIGN: Parent component is the SINGLE SOURCE OF TRUTH for header state
  // Child components should NOT set headers - they just render their content
  // Parent manages header based on selectedOptionPatientMenu state
  const reportModes = ['prescription', 'therapy_report', 'screening_report', 'assessment_report']
  useEffect(() => {
    const isInReportMode = selectedOptionPatientMenu && reportModes.includes(selectedOptionPatientMenu)
    const hasValidEventData = selectedPatientBookedEventData?.id && selectedPatientBookedEventData?.patientId
    
    // Map report modes to their flowId values
    const flowIdMap = {
      'prescription': 'prescription-making-page',
      'therapy_report': 'therapy-report-making-page',
      'screening_report': 'screening-report-making-page',
      'assessment_report': 'assessment-report-making-page',
    }
    
    if (isInReportMode && hasValidEventData) {
      // We're in a report mode with valid data - set the appropriate header
      const flowId = flowIdMap[selectedOptionPatientMenu]
      if (flowId) {
        setFlowId(flowId)
        setButtonTopOffset(50)
      }
    } else {
      // Not in report mode or no valid event data - show calendar header
      // This should run immediately when selectedOptionPatientMenu is cleared
      setFlowId('mentor-portal')
      setButtonTopOffset(0)
    }
  }, [selectedOptionPatientMenu, selectedPatientBookedEventData?.id, selectedPatientBookedEventData?.patientId, setFlowId, setButtonTopOffset])
  
  // Reconnect to chamber room when returning from live session page
  useEffect(() => {
    const returnFromLiveSession = sessionStorage.getItem('returnFromLiveSession')
    const storedChamberRoomRtcProps = sessionStorage.getItem('chamberRoomRtcProps')
    const storedChamberRoomRtmProps = sessionStorage.getItem('chamberRoomRtmProps')
    const storedChannelName = sessionStorage.getItem('chamberRoomChannelName')
    const storedChamberName = sessionStorage.getItem('chamberRoomChamberName')
    
    if (returnFromLiveSession === 'true' && storedChamberRoomRtcProps && storedChannelName) {
      try {
        const rtcProps = JSON.parse(storedChamberRoomRtcProps)
        const rtmProps = JSON.parse(storedChamberRoomRtmProps)
        
        // Restore chamber room session
        setChamberScreenStateNow(CHAMBER_SCREEN_STATES.SESSION_RUNNING)
        setJoinedChamberName(storedChamberName || 'Chamber Room')
        setJoinedChannelName(storedChannelName)
        setAgoraRtcProps(rtcProps)
        setAgoraRtmProps(rtmProps)
        
        // Clear stored data
        sessionStorage.removeItem('returnFromLiveSession')
        sessionStorage.removeItem('chamberRoomRtcProps')
        sessionStorage.removeItem('chamberRoomRtmProps')
        sessionStorage.removeItem('chamberRoomChannelName')
        sessionStorage.removeItem('chamberRoomChamberName')
        sessionStorage.removeItem('chamberRoomUrl')
      } catch (error) {
        console.error('Error reconnecting to chamber room:', error)
        // If reconnection fails, try to get next action from server
        getAndHandleNextAction()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const refBox = useRef(null) // Right panel (calendar/interaction part)
  const refLeft = useRef(null) // Resizer separator
  const refVideoContainer = useRef(null) // Left panel (video container)
  const refMobileResizer = useRef(null) // Mobile vertical resizer
  
  // Mobile scroll state for floating video
  const [isScrolledDown, setIsScrolledDown] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const calendarScrollContainerRef = useRef(null)
  const videoContainerRef = useRef(null)
  const lastScrollTop = useRef(0)
  
  // Mobile actions menu state
  const [mobileActionsMenuAnchor, setMobileActionsMenuAnchor] = useState(null)
  const mobileActionsMenuOpen = Boolean(mobileActionsMenuAnchor)
  
  // Video container ref (used for finding video elements)
  const videoFullscreenRef = useRef(null)
  
  // Username map for DebugPanel
  const [uidToUsernameMap, setUidToUsernameMap] = useState({})
  const uidToUsernameMapRef = useRef({})
  const [remoteUsers, setRemoteUsers] = useState([])
  const remoteUsersRef = useRef([])
  // Track when each RTC user joined (for mapping RTM data to RTC UIDs)
  const rtcUserJoinTimesRef = useRef(new Map()) // Map<RTC_UID, timestamp>
  // Keep ref for agoraRtcProps to access in callbacks
  const agoraRtcPropsRef = useRef({})
  
  // Keep refs in sync with state
  useEffect(() => {
    uidToUsernameMapRef.current = uidToUsernameMap
    remoteUsersRef.current = remoteUsers
    agoraRtcPropsRef.current = agoraRtcProps
    // Also update window object so CustomVideoPlaceholder can access latest data even if prop is stale
    if (typeof window !== 'undefined') {
      window.__latestUidToUsernameMap = uidToUsernameMap || {}
    }
  }, [uidToUsernameMap, remoteUsers, agoraRtcProps])
  
  // Periodic check to map unmapped RTM data to RTC users
  // This handles cases where RTM data arrives before users join, or timing issues
  useEffect(() => {
    if (chamberScreenStateNow !== CHAMBER_SCREEN_STATES.SESSION_RUNNING) return
    
    const interval = setInterval(() => {
      setUidToUsernameMap((prev) => {
        const currentRemoteUsers = remoteUsersRef.current || []
        const currentAgoraRtcProps = agoraRtcPropsRef.current || {}
        
        // Build set of all existing RTC UIDs (including local user) - in all formats
        const existingRtcUids = new Set()
        currentRemoteUsers.forEach((ru) => {
          const ruUid = ru.uid
          const ruUidNum = typeof ruUid === 'string' ? parseInt(ruUid, 10) : Number(ruUid)
          const ruUidStr = String(ruUid)
          existingRtcUids.add(ruUid)
          existingRtcUids.add(ruUidNum)
          existingRtcUids.add(ruUidStr)
          existingRtcUids.add(String(ruUidNum))
          existingRtcUids.add(Number(ruUidStr))
        })
        if (currentAgoraRtcProps?.uid !== undefined) {
          const localUid = currentAgoraRtcProps.uid
          const localUidNum = typeof localUid === 'string' ? parseInt(localUid, 10) : Number(localUid)
          const localUidStr = String(localUid)
          existingRtcUids.add(localUid)
          existingRtcUids.add(localUidNum)
          existingRtcUids.add(localUidStr)
          existingRtcUids.add(String(localUidNum))
          existingRtcUids.add(Number(localUidStr))
        }
        
        // Find unmapped RTM IDs (keys that don't match any RTC UID)
        // An RTM ID is unmapped if:
        // 1. It doesn't match any RTC UID (as number or string)
        // 2. No RTC UID currently has the username from this RTM ID
        const unmappedRtmIds = Object.keys(prev).filter((key) => {
          const keyNum = Number(key)
          if (isNaN(keyNum)) return false
          
          // Check if this key matches any RTC UID (exact match)
          const matchesRtcUid = existingRtcUids.has(key) || 
                                existingRtcUids.has(keyNum) || 
                                existingRtcUids.has(String(keyNum)) ||
                                existingRtcUids.has(String(key)) ||
                                existingRtcUids.has(Number(key))
          
          if (matchesRtcUid) {
            return false // This key IS a RTC UID, skip it
          }
          
          // Get the username for this RTM ID
          const username = prev[key] || prev[keyNum] || prev[String(keyNum)] || prev[String(key)] || prev[Number(key)]
          if (!username) return false
          
          // Check if any RTC UID already has this exact username (meaning it's already mapped)
          const alreadyMapped = currentRemoteUsers.some((ru) => {
            const ruUid = ru.uid
            const ruUidNum = typeof ruUid === 'string' ? parseInt(ruUid, 10) : Number(ruUid)
            const ruUidStr = String(ruUid)
            const ruUsername = prev[ruUid] || prev[ruUidNum] || prev[ruUidStr] || 
                              prev[String(ruUidNum)] || prev[Number(ruUidStr)]
            return ruUsername === username
          })
          
          // It's unmapped if it doesn't match a RTC UID AND isn't already mapped to one
          return !alreadyMapped
        })
        
        // If we have unmapped RTM data and remote users without usernames, map them
        if (unmappedRtmIds.length > 0 && currentRemoteUsers.length > 0) {
          // Find remote users without usernames
          const usersWithoutUsername = currentRemoteUsers.filter((ru) => {
            const ruUid = ru.uid
            const ruUidNum = typeof ruUid === 'string' ? parseInt(ruUid, 10) : Number(ruUid)
            const ruUidStr = String(ruUid)
            const hasUsername = prev[ruUid] || prev[ruUidNum] || prev[ruUidStr]
            // Skip local user
            if (ruUid === 0 || (currentAgoraRtcProps?.uid !== undefined && ruUid === currentAgoraRtcProps.uid)) {
              return false
            }
            return !hasUsername
          })
          
          // Map unmapped RTM data to users without usernames (one-to-one mapping)
          if (usersWithoutUsername.length > 0 && unmappedRtmIds.length > 0) {
            const updated = { ...prev }
            
            // Map first unmapped RTM ID to first user without username
            const rtmId = unmappedRtmIds[0]
            const username = prev[rtmId] || prev[Number(rtmId)] || prev[String(rtmId)]
            const user = usersWithoutUsername[0]
            
            if (username && user) {
              const rtcUid = user.uid
              const rtcUidNum = typeof rtcUid === 'string' ? parseInt(rtcUid, 10) : Number(rtcUid)
              const rtcUidStr = String(rtcUid)
              
              // Check if this mapping already exists (avoid unnecessary updates)
              const alreadyMapped = updated[rtcUid] === username || 
                                   updated[rtcUidNum] === username || 
                                   updated[rtcUidStr] === username
              
              if (!alreadyMapped) {
                updated[rtcUid] = username
                updated[rtcUidNum] = username
                updated[rtcUidStr] = username
                
                // Update window object immediately
                if (typeof window !== 'undefined') {
                  window.__latestUidToUsernameMap = updated
                }
              }
            }
            
            // Always return updated to ensure state change
            return updated
          }
        }
        
        return prev
      })
    }, 1000) // Check every second
    
    return () => clearInterval(interval)
  }, [chamberScreenStateNow])
  
  // Memoized wrapper for CustomVideoPlaceholder that uses latest uidToUsernameMap state
  // This ensures the component re-renders when the map updates
  const customVideoPlaceholderWrapper = useMemo(() => {
    const rtmUsername = buildMentorRtmUsername(mentorProfileData)
    return (props) => (
      <CustomVideoPlaceholder 
        {...props} 
        uidToUsernameMap={uidToUsernameMap} // Use state directly, not ref - ensures re-render on update
        localRtmUsername={rtmUsername}
      />
    )
  }, [mentorProfileData, uidToUsernameMap]) // Recreate when map or mentor data changes
  
  // Update agoraRtcProps when customVideoPlaceholderWrapper changes (when uidToUsernameMap updates)
  // This ensures the placeholder component always has the latest map data
  useEffect(() => {
    // Don't update if we're in a booked event session (to prevent overriding the channel)
    if (isInBookedEventSession) {
      return
    }
    if (agoraRtcProps?.channel && agoraRtcProps?.appId) {
      // Only update if we're already in a session
      setAgoraRtcProps((prev) => ({
        ...prev,
        CustomVideoPlaceholder: customVideoPlaceholderWrapper,
      }))
    }
  }, [customVideoPlaceholderWrapper, agoraRtcProps?.channel, agoraRtcProps?.appId, isInBookedEventSession])

  // Update agoraRtcProps when videoLayoutMode changes
  useEffect(() => {
    // Don't update if we're in a booked event session (to prevent overriding the channel)
    if (isInBookedEventSession) {
      return
    }
    if (agoraRtcProps?.channel && agoraRtcProps?.appId) {
      // Only update if we're already in a session
      setAgoraRtcProps((prev) => ({
        ...prev,
        layout: videoLayoutMode,
      }))
    }
  }, [videoLayoutMode, agoraRtcProps?.channel, agoraRtcProps?.appId, isInBookedEventSession])
  
  // Helper function to find RTM username for a user uid
  // This handles cases where keys might be stored as strings or numbers
  const findRtmUsername = (uid, usernameMap) => {
    if (!usernameMap || uid === undefined || uid === null) return null
    
    // Try direct lookups first
    let rawUsername = usernameMap[uid] || 
                      usernameMap[String(uid)] || 
                      usernameMap[Number(uid)]
    
    // If still not found, iterate through map keys to find match
    // This handles cases where keys might be stored in unexpected formats
    if (!rawUsername) {
      const uidNum = Number(uid)
      const uidStr = String(uid)
      
      for (const [key, value] of Object.entries(usernameMap)) {
        const keyNum = Number(key)
        const keyStr = String(key)
        
        // Match if key (as number or string) matches uid (as number or string)
        if (keyNum === uidNum || keyStr === uidStr || key === uidStr || key === uidNum) {
          rawUsername = value
          break
        }
      }
    }
    
    return rawUsername
  }
  
  // Helper function to extract display name from RTM username
  const getDisplayNameFromRtm = (rawUsername, fallbackUid) => {
    if (!rawUsername) return null
    
    try {
      const parsed = JSON.parse(rawUsername)
      if (parsed && parsed.name && typeof parsed.name === 'string' && parsed.name !== 'Unknown') {
        return parsed.name
      }
    } catch (e) {
      // If parsing fails, try to extract name with regex as fallback
      if (rawUsername.includes('"name"')) {
        const nameMatch = rawUsername.match(/"name"\s*:\s*"([^"]+)"/)
        if (nameMatch && nameMatch[1] && nameMatch[1] !== 'Unknown') {
          return nameMatch[1]
        }
      }
    }
    
    return null
  }
  
  // Helper function to parse RTM username and get all data
  const parseRtmUsername = (rawUsername) => {
    if (!rawUsername) return { role: null, name: null, profilePicId: null }
    
    try {
      const parsed = JSON.parse(rawUsername)
      return {
        role: parsed?.role || null,
        name: parsed?.name || null,
        profilePicId: parsed?.profilePicId || null,
      }
    } catch (e) {
      return { role: null, name: null, profilePicId: null }
    }
  }
  
  // Helper function to get profile picture URL
  const getProfilePictureUrl = (profilePicId) => {
    if (!profilePicId) return null
    
    // Check if it's already a full URL
    if (profilePicId.startsWith('http://') || profilePicId.startsWith('https://')) {
      return profilePicId
    }
    
    // Construct URL using mediaURL prefix
    return `https://media.aumhum.com/images/prod/${profilePicId}`
  }
  
  // Helper function to get initials from name
  const getInitials = (name) => {
    if (!name || name === 'Loading...' || name === 'You' || name === 'Guest') {
      return 'U'
    }
    
    const trimmedName = name.trim()
    const words = trimmedName.split(/\s+/).filter(w => w.length > 0)
    
    if (words.length > 1) {
      // Multiple words: use first letter of first and last word
      return (words[0][0] + words[words.length - 1][0]).toUpperCase()
    } else if (trimmedName.length > 0) {
      // Single word: use first letter
      return trimmedName.charAt(0).toUpperCase()
    }
    
    return 'U'
  }
  
  // State to track which user is currently in focus
  const [focusedUserId, setFocusedUserId] = useState(null)
  
  // Helper function to get all users for focus menu (local + remote), sorted by role priority
  const getFocusMenuUsers = useMemo(() => {
    const users = []
    
    // Add local user if we have RTM data
    if (agoraRtcProps?.uid !== undefined) {
      const localUid = agoraRtcProps.uid
      const localUidNum = typeof localUid === 'string' ? parseInt(localUid, 10) : Number(localUid)
      const localUidStr = String(localUid)
      const localUsername = uidToUsernameMap[localUid] || 
                           uidToUsernameMap[localUidNum] || 
                           uidToUsernameMap[localUidStr] ||
                           agoraRtmProps?.username
      
      if (localUsername) {
        const parsed = parseRtmUsername(localUsername)
        // Only add if role is not auditor/panelist
        if (parsed.role !== 'auditor' && parsed.role !== 'panelist') {
          users.push({
            uid: localUid,
            isLocal: true,
            name: parsed.name || 'You',
            role: parsed.role,
            profilePicId: parsed.profilePicId,
            rawUsername: localUsername,
          })
        }
      }
    }
    
    // Add remote users
    Object.keys(uidToUsernameMap).forEach((mapUid) => {
      // Skip if this is the local user (already added)
      const mapUidNum = Number(mapUid)
      if (agoraRtcProps?.uid !== undefined && 
          (mapUidNum === agoraRtcProps.uid || String(mapUid) === String(agoraRtcProps.uid))) {
        return
      }
      
      // Find the corresponding user in remoteUsers
      const user = remoteUsers.find((u) => 
        u.uid === Number(mapUid) || 
        u.uid === String(mapUid) || 
        String(u.uid) === String(mapUid) ||
        Number(u.uid) === Number(mapUid)
      )
      
      if (!user) return // User not in remoteUsers yet
      
      const rawUsername = uidToUsernameMap[mapUid]
      if (!rawUsername) return
      
      const parsed = parseRtmUsername(rawUsername)
      const displayName = parsed.name
      if (!displayName || displayName === 'Unknown') return
      
      // Filter based on role - only show mentor, patient, and chamber-room (hide auditor/panelist)
      if (parsed.role === 'auditor' || parsed.role === 'panelist') return
      
      users.push({
        uid: user.uid,
        isLocal: false,
        name: displayName,
        role: parsed.role,
        profilePicId: parsed.profilePicId,
        rawUsername,
      })
    })
    
    // Sort by role priority: mentor first, then patient, then others
    const rolePriority = { mentor: 1, patient: 2, 'chamber-room': 3 }
    users.sort((a, b) => {
      const aPriority = rolePriority[a.role] || 99
      const bPriority = rolePriority[b.role] || 99
      if (aPriority !== bPriority) return aPriority - bPriority
      // If same priority, sort by name
      return a.name.localeCompare(b.name)
    })
    
    return users
  }, [uidToUsernameMap, remoteUsers, agoraRtcProps?.uid, agoraRtmProps?.username])
  
  // Focus/swap menu state
  const [focusMenuAnchor, setFocusMenuAnchor] = useState(null)
  const focusMenuOpen = Boolean(focusMenuAnchor)
  
  // Auto-focus on highest priority user based on role (mentor > patient > others)
  useEffect(() => {
    if (chamberScreenStateNow !== CHAMBER_SCREEN_STATES.SESSION_RUNNING) {
      setFocusedUserId(null)
      return
    }
    
    // If we already have a focused user, check if they're still in the call
    if (focusedUserId !== null) {
      const focusedUserStillExists = getFocusMenuUsers.some((u) => 
        u.uid === focusedUserId || 
        String(u.uid) === String(focusedUserId) ||
        Number(u.uid) === Number(focusedUserId)
      )
      if (focusedUserStillExists) {
        return // Keep current focus
      }
    }
    
    // Auto-focus on highest priority user
    if (getFocusMenuUsers.length > 0) {
      const highestPriorityUser = getFocusMenuUsers[0] // Already sorted by priority
      const targetUid = highestPriorityUser.isLocal ? (agoraRtcProps?.uid || 0) : highestPriorityUser.uid
      setFocusedUserId(targetUid)
      
      // Also try to actually focus the video element
      setTimeout(() => {
        try {
          const videoContainer = videoFullscreenRef.current || videoContainerRef.current
          if (videoContainer) {
            const videoElement = videoContainer.querySelector(`[data-uid="${targetUid}"]`) || 
              videoContainer.querySelector(`div[style*="position"][data-uid="${targetUid}"]`)
            if (videoElement) {
              videoElement.click()
            }
          }
        } catch (error) {
          // Silently fail - focus state is still set
        }
      }, 500) // Small delay to ensure DOM is ready
    } else {
      setFocusedUserId(null)
    }
  }, [getFocusMenuUsers, chamberScreenStateNow, agoraRtcProps?.uid, focusedUserId])
  
  // Idle popup state - only count when there are no other participants
  const [isIdle, setIsIdle] = useState(false)
  const idleTimerRef = useRef(null)
  const IDLE_TIME = 180000 // 3 minutes
  
  // Custom idle detection that only counts when alone in the call
  useEffect(() => {
    // Only count idle time when session is running and there are no remote users
    const shouldCountIdle = 
      chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING && 
      remoteUsers.length === 0
    
    // Clear existing timer and reset idle state
    if (idleTimerRef.current) {
      clearTimeout(idleTimerRef.current)
      idleTimerRef.current = null
    }
    
    // Reset idle state when participants join or session not running
    if (remoteUsers.length > 0 || chamberScreenStateNow !== CHAMBER_SCREEN_STATES.SESSION_RUNNING) {
      setIsIdle(false)
      return
    }
    
    // Only start timer if we should count idle
    if (!shouldCountIdle) {
      setIsIdle(false)
      return
    }
    
    // Start idle timer
    idleTimerRef.current = setTimeout(() => {
      setIsIdle(true)
    }, IDLE_TIME)
    
    // Reset timer on user activity
    const resetTimer = () => {
      if (idleTimerRef.current && shouldCountIdle) {
        clearTimeout(idleTimerRef.current)
        setIsIdle(false)
        idleTimerRef.current = setTimeout(() => {
          setIsIdle(true)
        }, IDLE_TIME)
      }
    }
    
    const events = ['mousemove', 'keydown', 'scroll', 'click', 'touchstart']
    events.forEach((event) => window.addEventListener(event, resetTimer))
    
    return () => {
      if (idleTimerRef.current) {
        clearTimeout(idleTimerRef.current)
        idleTimerRef.current = null
      }
      events.forEach((event) => window.removeEventListener(event, resetTimer))
    }
  }, [chamberScreenStateNow, remoteUsers.length])
  
  // Parse and update usernames in video cards (both mobile and desktop)
  useEffect(() => {
    if (chamberScreenStateNow !== CHAMBER_SCREEN_STATES.SESSION_RUNNING) return
    
    const parseAndUpdateUsernames = () => {
      const videoContainer = videoFullscreenRef.current || videoContainerRef.current
      if (!videoContainer) {
        return
      }
      
      // Find all potential username elements
      const usernameSelectors = [
        'p[style*="background"]',
        'span[style*="background"]',
        'div[style*="background"]',
        '[class*="username"]',
        '[class*="Username"]',
      ]
      
      // Track RTM usernames found in DOM to add to uidToUsernameMap
      const rtmUsernamesFound = new Map() // Map<uid, username>
      
      usernameSelectors.forEach((selector) => {
        try {
          const elements = videoContainer.querySelectorAll(selector)
          
          elements.forEach((el) => {
            const text = el.textContent || el.innerText || ''
            const innerHTML = el.innerHTML || ''
            
            // Check if text OR innerHTML looks like JSON (innerHTML might still have JSON even if textContent doesn't)
            const jsonText = (text.includes('{') && text.includes('"name"')) ? text : 
                            (innerHTML.includes('{') && innerHTML.includes('"name"')) ? innerHTML : null
            
            if (jsonText) {
              try {
                const parsed = JSON.parse(jsonText)
                if (parsed && parsed.name && typeof parsed.name === 'string') {
                  // Find the parent video card to get the UID - try multiple methods
                  let videoCard = el.closest('[data-uid]')
                  let uid = videoCard ? videoCard.getAttribute('data-uid') : null
                  
                  // If not found, try searching up the tree more aggressively
                  if (!uid) {
                    let parent = el.parentElement
                    let depth = 0
                    while (parent && depth < 10) {
                      if (parent.hasAttribute('data-uid')) {
                        uid = parent.getAttribute('data-uid')
                        videoCard = parent
                        break
                      }
                      parent = parent.parentElement
                      depth++
                    }
                  }
                  
                  // If still not found, try searching the entire container for a video card that contains this element
                  if (!uid && videoContainer) {
                    const allVideoCards = videoContainer.querySelectorAll('[data-uid]')
                    for (const card of allVideoCards) {
                      if (card.contains(el)) {
                        uid = card.getAttribute('data-uid')
                        videoCard = card
                        break
                      }
                    }
                  }
                  
                  // If still not found, search the entire document (not just container)
                  if (!uid) {
                    const allVideoCardsInDocument = document.querySelectorAll('[data-uid]')
                    for (const card of allVideoCardsInDocument) {
                      if (card.contains(el)) {
                        uid = card.getAttribute('data-uid')
                        videoCard = card
                        break
                      }
                    }
                  }
                  
                  // If still not found, use timing-based matching (similar to onUsernameMapUpdate)
                  // Map to the most recently joined user without a username
                  // This is our primary fallback when DOM structure doesn't have [data-uid] attributes
                  if (!uid && parsed && parsed.name) {
                    const currentRemoteUsers = remoteUsersRef.current || []
                    const currentAgoraRtcProps = agoraRtcPropsRef.current || {}
                    
                    // Check if this RTM data is for the local user
                    // Compare with local user's existing RTM data in the map
                    let isLocalUserRtmData = false
                    if (currentAgoraRtcProps?.uid !== undefined) {
                      const localUid = currentAgoraRtcProps.uid
                      const localUidNum = typeof localUid === 'string' ? parseInt(localUid, 10) : Number(localUid)
                      const localUidStr = String(localUid)
                      const localUsername = uidToUsernameMapRef.current?.[localUid] || 
                                          uidToUsernameMapRef.current?.[localUidNum] || 
                                          uidToUsernameMapRef.current?.[localUidStr]
                      
                      // If local user already has RTM data, compare it
                      if (localUsername) {
                        try {
                          const localParsed = JSON.parse(localUsername)
                          // If name and role match, it's probably the local user
                          isLocalUserRtmData = localParsed.name === parsed.name && localParsed.role === parsed.role
                        } catch (e) {
                          // If local username is not JSON, compare as string
                          isLocalUserRtmData = localUsername === jsonText
                        }
                      }
                    }
                    
                    // Find remote users without usernames, sorted by join time (most recent first)
                    const usersWithoutUsername = currentRemoteUsers
                      .filter((ru) => {
                        const ruUid = ru.uid
                        // Skip local user
                        if (ruUid === 0 || (currentAgoraRtcProps?.uid !== undefined && ruUid === currentAgoraRtcProps.uid)) {
                          return false
                        }
                        const ruUidNum = typeof ruUid === 'string' ? parseInt(ruUid, 10) : Number(ruUid)
                        const ruUidStr = String(ruUid)
                        const hasUsername = uidToUsernameMapRef.current?.[ruUid] || 
                                          uidToUsernameMapRef.current?.[ruUidNum] || 
                                          uidToUsernameMapRef.current?.[ruUidStr]
                        return !hasUsername
                      })
                      .map((ru) => ({
                        user: ru,
                        joinTime: rtcUserJoinTimesRef.current.get(ru.uid) || 
                                 rtcUserJoinTimesRef.current.get(Number(ru.uid)) || 
                                 rtcUserJoinTimesRef.current.get(String(ru.uid)) || 
                                 0
                      }))
                      .sort((a, b) => b.joinTime - a.joinTime) // Most recent first
                    
                    // Only use timing-based matching if:
                    // 1. It's not local user RTM data
                    // 2. There are users without usernames
                    // 3. The role is not auditor or panelist (those are hidden anyway)
                    if (!isLocalUserRtmData && 
                        usersWithoutUsername.length > 0 && 
                        parsed.role !== 'auditor' && 
                        parsed.role !== 'panelist') {
                      // Map to the most recently joined user without a username
                      // But verify that this user is actually in the currentRemoteUsers list
                      const mostRecentUser = usersWithoutUsername[0].user
                      const mappedUid = String(mostRecentUser.uid)
                      
                      // Verify this UID is actually a current remote user
                      const isValidRemoteUser = currentRemoteUsers.some((ru) => {
                        const ruUid = String(ru.uid)
                        const ruUidNum = Number(ru.uid)
                        return ruUid === mappedUid || ruUidNum === Number(mappedUid)
                      })
                      
                      if (isValidRemoteUser) {
                        uid = mappedUid
                      }
                    }
                  }
                  
                  // If we found a UID, store the RTM username for later addition to map
                  if (uid) {
                    rtmUsernamesFound.set(uid, jsonText) // Store the original JSON string
                    const uidNum = Number(uid)
                    if (!isNaN(uidNum)) {
                      rtmUsernamesFound.set(uidNum, jsonText)
                      rtmUsernamesFound.set(String(uidNum), jsonText)
                    }
                    rtmUsernamesFound.set(String(uid), jsonText)
                  }
                  
                  // Follow role-based rules: only show name if role is not auditor or panelist
                  const role = parsed.role
                  const shouldShowName = !role || role === 'mentor' || role === 'patient'
                  const shouldHide = role === 'auditor' || role === 'panelist'
                  
                  if (shouldHide) {
                    el.textContent = ''
                    el.innerText = ''
                    el.style.display = 'none'
                  } else if (shouldShowName) {
                    el.textContent = parsed.name
                    el.innerText = parsed.name
                    el.style.display = ''
                  } else {
                    // Other roles - show name
                    el.textContent = parsed.name
                    el.innerText = parsed.name
                    el.style.display = ''
                  }
                }
              } catch (e) {
                // Try regex extraction as fallback
                const nameMatch = text.match(/"name"\s*:\s*"([^"]+)"/)
                if (nameMatch && nameMatch[1]) {
                  el.textContent = nameMatch[1]
                  el.innerText = nameMatch[1]
                }
              }
            }
          })
        } catch (e) {
          // Selector failed, continue
        }
      })
      
      // Add found RTM usernames to uidToUsernameMap
      if (rtmUsernamesFound.size > 0) {
        setUidToUsernameMap((prev) => {
          let updated = false
          const updatedMap = { ...prev }
          
          // Get current remote users to validate mappings
          const currentRemoteUsers = remoteUsersRef.current || []
          const currentAgoraRtcProps = agoraRtcPropsRef.current || {}
          const currentRemoteUserUids = new Set(
            currentRemoteUsers.map(ru => [String(ru.uid), Number(ru.uid)]).flat()
          )
          if (currentAgoraRtcProps?.uid !== undefined) {
            currentRemoteUserUids.add(String(currentAgoraRtcProps.uid))
            currentRemoteUserUids.add(Number(currentAgoraRtcProps.uid))
          }
          
          rtmUsernamesFound.forEach((username, uid) => {
            const uidStr = String(uid)
            const uidNum = Number(uid)
            
            // Check if this UID is a valid current remote user
            const isValidUid = currentRemoteUserUids.has(uid) || 
                              currentRemoteUserUids.has(uidStr) || 
                              currentRemoteUserUids.has(uidNum) ||
                              currentRemoteUserUids.has(String(uidNum))
            
            // If UID is not valid, try to remap to a current remote user without username
            let finalUid = uid
            if (!isValidUid) {
              const usersWithoutUsername = currentRemoteUsers
                .filter((ru) => {
                  const ruUid = ru.uid
                  if (ruUid === 0 || (currentAgoraRtcProps?.uid !== undefined && ruUid === currentAgoraRtcProps.uid)) {
                    return false
                  }
                  const ruUidNum = typeof ruUid === 'string' ? parseInt(ruUid, 10) : Number(ruUid)
                  const ruUidStr = String(ruUid)
                  const hasUsername = updatedMap[ruUid] || updatedMap[ruUidNum] || updatedMap[ruUidStr] || 
                                    prev[ruUid] || prev[ruUidNum] || prev[ruUidStr]
                  return !hasUsername
                })
              
              // If there's exactly one user without username, remap to them
              if (usersWithoutUsername.length === 1) {
                finalUid = String(usersWithoutUsername[0].uid)
              } else if (usersWithoutUsername.length > 1) {
                // Multiple users without username - use most recently joined
                const sorted = usersWithoutUsername
                  .map((ru) => ({
                    user: ru,
                    joinTime: rtcUserJoinTimesRef.current.get(ru.uid) || 
                             rtcUserJoinTimesRef.current.get(Number(ru.uid)) || 
                             rtcUserJoinTimesRef.current.get(String(ru.uid)) || 
                             0
                  }))
                  .sort((a, b) => b.joinTime - a.joinTime)
                finalUid = String(sorted[0].user.uid)
              } else {
                // No users without username - skip this mapping
                return // Skip this entry
              }
            }
            
            // Only add if not already present (to avoid unnecessary updates)
            const finalUidStr = String(finalUid)
            const finalUidNum = Number(finalUid)
            const hasExisting = updatedMap[finalUid] || updatedMap[finalUidStr] || updatedMap[finalUidNum]
            
            if (!hasExisting || hasExisting !== username) {
              updatedMap[finalUid] = username
              updatedMap[finalUidStr] = username
              if (!isNaN(finalUidNum)) {
                updatedMap[finalUidNum] = username
                updatedMap[String(finalUidNum)] = username
              }
              updated = true
            }
          })
          
          // Update window object immediately if we made changes
          if (updated && typeof window !== 'undefined') {
            window.__latestUidToUsernameMap = updatedMap
          }
          
          return updated ? updatedMap : prev
        })
      }
    }
    
    // Initial parse
    parseAndUpdateUsernames()
    
    // Set up MutationObserver to watch for new username elements
    const observer = new MutationObserver(() => {
      parseAndUpdateUsernames()
    })
    
    const videoContainer = videoFullscreenRef.current || videoContainerRef.current
    if (videoContainer) {
      observer.observe(videoContainer, {
        childList: true,
        subtree: true,
        characterData: true,
      })
    }
    
    // Also parse when username map updates
    const interval = setInterval(parseAndUpdateUsernames, 500)
    
    return () => {
      observer.disconnect()
      clearInterval(interval)
    }
  }, [chamberScreenStateNow, uidToUsernameMap])
  

  // Compute video container styles for mobile floating
  const videoContainerSx = useMemo(() => {
    const baseStyles = {
      flex: { xs: '1 1 0', md: '1 1 0' }, // Take full space on mobile
      flexShrink: { xs: 0, md: 1 },
      flexBasis: { xs: '100%', md: 0 }, // Full width/height on mobile
      display: 'flex', 
      flexDirection: 'column',
      background: 'linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(241, 245, 249, 0.98) 100%)',
      borderRadius: '0',
      overflow: { xs: 'hidden', md: 'hidden' }, // Hidden on both to prevent scroll
      overflowY: { xs: 'hidden', md: 'hidden' }, // Hidden vertical scroll on both
      position: { 
        xs: 'relative', // Always relative on mobile for full height
        md: 'relative' 
      },
      transition: 'all 0.3s ease',
      boxShadow: { 
        xs: 'none', // No shadow on mobile
        md: 'none' 
      },
    }

    // Mobile: Switch between portrait (full height) and landscape (full width) modes
    if (isMobile) {
      if (isVideoLandscape) {
        // Landscape mode: Full width (100vw), height calculated from 16:9 aspect ratio
        // Height = width * (9/16) = 100vw * 0.5625 = 56.25vw
      return {
        ...baseStyles,
          width: '100vw', // Full viewport width
          maxWidth: '100vw',
          height: '56.25vw', // 16:9 aspect ratio (9/16 = 0.5625)
          minHeight: 0,
          maxHeight: '100vh', // Don't exceed viewport height
          flex: '0 0 auto', // Don't grow/shrink
          margin: '0 auto',
          alignSelf: 'center',
        }
      } else {
        // Portrait mode: Full height (current behavior)
        return {
          ...baseStyles,
          minWidth: '100%',
          minHeight: '100vh',
          height: '100vh',
          maxHeight: '100vh',
        width: '100%',
        }
      }
    }

    // Desktop: Return base styles
    return {
      ...baseStyles,
      minWidth: '400px',
      minHeight: 0,
      height: '100%',
      maxHeight: '100%',
      width: undefined,
    }
  }, [isMobile, isVideoLandscape])

  // Detect mobile screen size
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }
    
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  // Handle scroll detection for mobile floating video
  useEffect(() => {
    if (!isMobile || chamberScreenStateNow !== CHAMBER_SCREEN_STATES.SESSION_RUNNING) {
      setIsScrolledDown(false)
      return
    }

    const handleScroll = () => {
      if (!calendarScrollContainerRef.current) return
      
      const scrollTop = calendarScrollContainerRef.current.scrollTop
      const scrollThreshold = 100 // Start floating after 100px scroll
      
      if (scrollTop > scrollThreshold && scrollTop > lastScrollTop.current) {
        // Scrolling down
        setIsScrolledDown(true)
      } else if (scrollTop <= scrollThreshold || scrollTop < lastScrollTop.current) {
        // Scrolling up or near top
        setIsScrolledDown(false)
      }
      
      lastScrollTop.current = scrollTop
    }

    const container = calendarScrollContainerRef.current
    if (container) {
      container.addEventListener('scroll', handleScroll, { passive: true })
      return () => {
        container.removeEventListener('scroll', handleScroll)
      }
    }
  }, [isMobile, chamberScreenStateNow, selectedTab])
  
  // Mobile vertical resizer logic
  useEffect(() => {
    if (!isMobile || chamberScreenStateNow !== CHAMBER_SCREEN_STATES.SESSION_RUNNING) return
    
    const resizer = refMobileResizer.current
    const videoContainer = videoContainerRef.current
    const calendarContainer = calendarScrollContainerRef.current
    
    if (!resizer || !videoContainer || !calendarContainer) return
    
    let startY = 0
    let startVideoHeight = 0
    
    const handleTouchMove = (e) => {
      e.preventDefault()
      const deltaY = e.touches[0].clientY - startY
      
      // Calculate new heights with minimum constraints
      const newVideoHeight = Math.max(150, startVideoHeight + deltaY)
      
      // Apply new heights
      videoContainer.style.height = `${newVideoHeight}px`
      videoContainer.style.maxHeight = `${newVideoHeight}px`
      calendarContainer.style.height = `calc(100% - ${newVideoHeight}px - 8px)` // 8px for resizer
    }
    
    const handleMouseMove = (e) => {
      const deltaY = e.clientY - startY
      
      // Calculate new heights with minimum constraints
      const newVideoHeight = Math.max(150, startVideoHeight + deltaY)
      
      // Apply new heights
      videoContainer.style.height = `${newVideoHeight}px`
      videoContainer.style.maxHeight = `${newVideoHeight}px`
      calendarContainer.style.height = `calc(100% - ${newVideoHeight}px - 8px)` // 8px for resizer
    }
    
    const handleEnd = () => {
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleEnd)
      document.removeEventListener('touchmove', handleTouchMove, { passive: false })
      document.removeEventListener('touchend', handleEnd)
      document.body.style.cursor = ''
      document.body.style.userSelect = ''
    }
    
    const handleStart = (e) => {
      e.preventDefault()
      
      // Get initial state
      const clientY = e.type === 'touchstart' ? e.touches[0].clientY : e.clientY
      startY = clientY
      startVideoHeight = videoContainer.offsetHeight
      
      // Set drag cursor and disable text selection
      document.body.style.cursor = 'row-resize'
      document.body.style.userSelect = 'none'
      
      // Add document-level event listeners
      if (e.type === 'touchstart') {
        document.addEventListener('touchmove', handleTouchMove, { passive: false })
        document.addEventListener('touchend', handleEnd)
      } else {
        document.addEventListener('mousemove', handleMouseMove)
        document.addEventListener('mouseup', handleEnd)
      }
    }
    
    resizer.addEventListener('mousedown', handleStart)
    resizer.addEventListener('touchstart', handleStart, { passive: false })
    
    return () => {
      resizer.removeEventListener('mousedown', handleStart)
      resizer.removeEventListener('touchstart', handleStart)
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleEnd)
      document.removeEventListener('touchmove', handleTouchMove)
      document.removeEventListener('touchend', handleEnd)
    }
  }, [isMobile, chamberScreenStateNow])

  const handleAssessmentReportSaved = useCallback(() => {
    getAndSetPatientBookedEventDetails?.()
    const pid = selectedPatientBookedEventData?.patientId
    const refId = selectedPatientBookedEventData?.id
    if (pid != null && refId != null) {
      store.dispatch(getPastPatientReports({ patientId: pid, referenceBookedEventId: refId }))
    }
  }, [selectedPatientBookedEventData?.patientId, selectedPatientBookedEventData?.id, getAndSetPatientBookedEventDetails])

  return (
    <div 
      className="w-100 d-flex flex-column full-width-child-resizable-box-print-only"
      style={{
        // Mobile: Full viewport height. Desktop: 100vh
        height: isMobile ? '100vh' : '100vh',
        overflow: isMobile ? 'visible' : 'hidden', // Allow overflow on mobile so fixed controls aren't clipped
      }}
    >
      <ScreeningSectionsProvider>
        <SplitScreenHeader
          chosenClinicData={chosenClinicData}
          chamberScreenStateNow={chamberScreenStateNow}
          leaveThisSession={leaveThisSession}
          serverGivenNextAction={serverGivenNextAction}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          onPrevClick={onPrevClick}
          onNextClick={onNextClick}
          handleGoToToday={handleGoToToday}
          isToday={isToday}
          clinicSchedules={clinicSchedules}
          onOpenPatientSearch={handleOpenPatientSearch}
          onOpenBookedSlotsDrawer={handleOpenBookedSlotsDrawer}
          onRefreshBookings={handleRefreshBookings}
          isRefreshing={isRefreshingBookings}
          eachSlotDurationInMins={eachSlotDurationInMins}
          setEachSlotDurationInMins={setEachSlotDurationInMins}
          onOpenCalendarDrawer={() => setCalendarDrawerOpen(true)} // Calendar drawer callback for mobile
          // Report mode props - when a report page is open
          selectedOptionPatientMenu={selectedOptionPatientMenu}
          selectedPatientBookedEventData={selectedPatientBookedEventData}
          auxiliaryData={auxiliaryData}
          // Chamber screen status props
          chamberScreenStatus={chamberScreenStatus}
          joinedChamberName={joinedChamberName}
          onSaveReport={async () => {
            if (selectedOptionPatientMenu === 'screening_report') {
              await screeningReportRef?.current?.saveScreeningReport()
            } else if (selectedOptionPatientMenu === 'prescription') {
              await prescriptionRef?.current?.savePrescriptionData()
            } else if (selectedOptionPatientMenu === 'therapy_report') {
              await therapyReportRef?.current?.saveTherapyReport()
            }
          }}
          onLeaveSession={async (markAsCompleted = false) => {
            setIsLeavingSession(true)
            showNotification.info('Saving and returning to calendar...')
            try {
              await closeBookedEvent(markAsCompleted)
            } finally {
              setIsLeavingSession(false)
            }
          }}
          onCompleteSession={async () => {
            // Use closeBookedEvent with markAsCompleted=true for all report types
            // This ensures proper cleanup and state reset
            await closeBookedEvent(true)
          }}
          isSavingReport={
            selectedOptionPatientMenu === 'screening_report' ? screeningReportRef?.current?.isSaving :
            selectedOptionPatientMenu === 'prescription' ? prescriptionRef?.current?.isSaving :
            selectedOptionPatientMenu === 'therapy_report' ? therapyReportRef?.current?.isSaving :
            false
          }
          isLeavingSession={isLeavingSession}
        />
        <PractitionerAssessmentDrawer
          open={assessmentDrawerOpen}
          onClose={() => setAssessmentDrawerOpen(false)}
          bookedEventId={selectedPatientBookedEventId}
          bookedEventInfo={selectedPatientBookedEventData}
          onRunSubmitted={() => getAndSetPatientBookedEventDetails?.()}
          patientId={selectedPatientBookedEventData?.patientId}
          mentorId={mentorProfileData?.id}
          onAssessmentReportSaved={handleAssessmentReportSaved}
        />
        <NerdStatComponent serverGivenNextAction={serverGivenNextAction} />
        {/* Mobile: Full screen video (calendar in drawer) | Desktop: Horizontal layout (side by side) */}
        <Box
          className="d-flex flex-grow-1"
          sx={{
            // Mobile: Full viewport height (header overlays). Desktop: Subtract header height
            marginTop: { xs: 0, sm: 0, md: '36px' },
            height: { xs: '100vh', sm: '100vh', md: 'calc(100vh - 36px)' },
            maxHeight: { xs: '100vh', sm: '100vh', md: 'calc(100vh - 36px)' }, // Constrain height
            overflow: 'hidden', // Prevent outer container from scrolling - children handle their own scroll
            flexDirection: { xs: 'column', md: 'row' },
            position: 'relative',
            display: 'flex', // Ensure flex is enabled
            // Mobile: Center video in landscape mode
            alignItems: { xs: isVideoLandscape ? 'center' : 'stretch', md: 'stretch' },
            justifyContent: { xs: isVideoLandscape ? 'center' : 'flex-start', md: 'flex-start' },
            minHeight: 0, // Critical for flex children to allow scrolling
          }}
        >
        {chamberScreenStateNow === CHAMBER_SCREEN_STATES.IDLING && (
          <Box sx={{ 
            width: '100%', 
            // Mobile: Show with proper sizing. Desktop: Show normally
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            p: { xs: 2, sm: 2, md: 2 }, 
            position: 'relative',
            flex: { xs: '1 1 0', md: '1 1 0' },
            overflowY: 'auto',
            overflowX: 'hidden',
            minHeight: 0,
          }}>
            <Box sx={{ 
              maxWidth: { xs: '100%', sm: '400px', md: '420px', lg: '480px' }, 
              width: '100%',
              px: { xs: 1, sm: 2 },
            }} className="hide-on-print-only">
              {/* Subtle status indicator with reconnect button */}
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                gap: { xs: 0.75, sm: 1 }, 
                mb: { xs: 1.5, sm: 2 },
                flexWrap: 'wrap',
              }}>
                {joinedChamberName && (
                  <Typography variant="caption" sx={{ 
                    textAlign: 'center', 
                    color: 'rgba(107, 114, 128, 0.6)', 
                    fontSize: { xs: '12px', sm: '11px' }, 
                    fontWeight: 400,
                    flex: { xs: '1 1 100%', sm: '0 0 auto' },
                    mb: { xs: 0.5, sm: 0 },
                  }}>
                    Joining {joinedChamberName}
                  </Typography>
                )}
                {!joinedChamberName && (
                  <Typography variant="caption" sx={{ 
                    textAlign: 'center', 
                    color: 'rgba(107, 114, 128, 0.5)', 
                    fontSize: { xs: '12px', sm: '11px' }, 
                    fontWeight: 400,
                    flex: { xs: '1 1 100%', sm: '0 0 auto' },
                    mb: { xs: 0.5, sm: 0 },
                  }}>
                    Waiting for connection...
                  </Typography>
                )}
                <IconButton
                  onClick={() => {
                    if (chamberRoomId) {
                      getAndHandleNextAction()
                    }
                  }}
                  size="small"
                  sx={{
                    padding: { xs: '6px', sm: '4px' },
                    backgroundColor: 'rgba(103, 121, 227, 0.08)',
                    color: '#6779e3',
                    border: '1px solid rgba(103, 121, 227, 0.2)',
                    '&:hover': {
                      backgroundColor: 'rgba(103, 121, 227, 0.15)',
                      borderColor: 'rgba(103, 121, 227, 0.4)',
                    },
                  }}
                  title="Reconnect to server"
                >
                  <RefreshIcon sx={{ fontSize: { xs: 18, sm: 16 } }} />
                </IconButton>
              </Box>

              {/* Device Preview Section - Compact and Subtle */}
              <Paper
                elevation={1}
                sx={{
                  p: { xs: 1.5, sm: 2, md: 2 },
                  borderRadius: '12px',
                  background: 'rgba(255, 255, 255, 0.85)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(0, 0, 0, 0.08)',
                  mb: { xs: 1.5, sm: 2 },
                  width: '100%',
                  boxSizing: 'border-box',
                }}
              >
                <Typography variant="caption" sx={{ 
                  mb: { xs: 1.5, sm: 2 }, 
                  color: 'rgba(107, 114, 128, 0.7)', 
                  fontWeight: 500, 
                  fontSize: { xs: '12px', sm: '11px' }, 
                  display: 'block' 
                }}>
                  Device Settings
                </Typography>

                {/* Compact Video Preview */}
                <Box sx={{ 
                  mb: { xs: 1.5, sm: 2 }, 
                  display: 'flex', 
                  justifyContent: 'center',
                  width: '100%',
                }}>
                  <Box
                    sx={{
                      width: '100%',
                      maxWidth: { xs: '100%', sm: '240px', md: '280px', lg: '320px' },
                      aspectRatio: '16/9',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      background: '#000',
                      position: 'relative',
                      border: '1px solid rgba(0, 0, 0, 0.1)',
                    }}
                  >
                    <video
                      ref={previewVideoRef}
                      autoPlay
                      playsInline
                      muted
            style={{ 
                        width: '100%',
              height: '100%', 
                        objectFit: 'cover',
                      }}
                    />
                    {!isCameraOpen && (
                      <Box
                        sx={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
              display: 'flex', 
                          alignItems: 'center',
                          justifyContent: 'center',
                          background: 'rgba(0, 0, 0, 0.6)',
                          color: 'rgba(255, 255, 255, 0.7)',
                        }}
                      >
                        <Typography variant="caption" sx={{ fontSize: '10px' }}>Camera Off</Typography>
                      </Box>
                    )}
                  </Box>
                </Box>

                {/* Camera Toggle - Compact */}
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: { xs: 0.75, sm: 1 }, 
                  mb: { xs: 1.25, sm: 1.5 },
                  flexWrap: { xs: 'wrap', sm: 'nowrap' },
                }}>
                  <IconButton
                    onClick={async () => {
                      const newCameraState = !isCameraOpen
                      setIsCameraOpen(newCameraState)
                      
                      // Load devices if not already loaded and camera is being turned on
                      if (newCameraState && availableCameras.length === 0) {
                        try {
                          // Request camera permission first
                          await navigator.mediaDevices.getUserMedia({ video: true, audio: false })
                          // Then load devices
                          await getAndSetCameras({ setAvailableCameras, setSelectedCamera })
                        } catch (error) {
                          console.error('Error loading cameras:', error)
                          setIsCameraOpen(false) // Revert if permission denied
                        }
                      }
                    }}
                    size="small"
                    sx={{
                      backgroundColor: isCameraOpen ? 'rgba(16, 185, 129, 0.08)' : 'rgba(239, 68, 68, 0.08)',
                      color: isCameraOpen ? 'rgba(16, 185, 129, 0.8)' : 'rgba(239, 68, 68, 0.8)',
                      border: `1px solid ${isCameraOpen ? 'rgba(16, 185, 129, 0.2)' : 'rgba(239, 68, 68, 0.2)'}`,
                      padding: { xs: '6px', sm: '4px' },
                      flexShrink: 0,
                      '&:hover': {
                        backgroundColor: isCameraOpen ? 'rgba(16, 185, 129, 0.15)' : 'rgba(239, 68, 68, 0.15)',
                      },
                    }}
                  >
                    {isCameraOpen ? <VideocamIcon sx={{ fontSize: { xs: 18, sm: 16 } }} /> : <VideocamOffIcon sx={{ fontSize: { xs: 18, sm: 16 } }} />}
                  </IconButton>
                  <Typography variant="caption" sx={{ 
                    flex: { xs: '1 1 auto', sm: 1 }, 
                    fontWeight: 400, 
                    color: 'rgba(107, 114, 128, 0.7)', 
                    fontSize: { xs: '12px', sm: '11px' },
                    minWidth: { xs: '60px', sm: 'auto' },
                  }}>
                    Camera
                  </Typography>
                  <FormControl size="small" sx={{ 
                    minWidth: { xs: '100%', sm: 140 },
                    width: { xs: '100%', sm: 'auto' },
                    flex: { xs: '1 1 100%', sm: '0 0 auto' },
                  }}>
                    <Select
                      value={selectedCamera}
                      onChange={(e) => setSelectedCamera(e.target.value)}
                      disabled={!isCameraOpen}
                      sx={{
                        fontSize: { xs: '12px', sm: '11px' },
                        height: { xs: '32px', sm: '28px' },
                        '& .MuiSelect-select': {
                          padding: { xs: '6px 10px', sm: '4px 8px' },
                        },
                      }}
                    >
                      {availableCameras.map((camera) => (
                        <MenuItem key={camera.deviceId} value={camera.deviceId} sx={{ fontSize: { xs: '12px', sm: '11px' } }}>
                          {camera.label || `Camera ${camera.deviceId.slice(0, 8)}`}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>

                {/* Microphone Toggle - Compact */}
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: { xs: 0.75, sm: 1 }, 
                  mb: { xs: 1.25, sm: 1.5 },
                  flexWrap: { xs: 'wrap', sm: 'nowrap' },
                }}>
                  <IconButton
                    onClick={async () => {
                      const newAudioState = !isAudioOpen
                      setIsAudioOpen(newAudioState)
                      
                      // Load devices if not already loaded and audio is being turned on
                      if (newAudioState && availableMicrophones.length === 0) {
                        try {
                          // Request microphone permission first
                          await navigator.mediaDevices.getUserMedia({ video: false, audio: true })
                          // Then load devices
                          await getAndSetMicrophones({ setAvailableMicrophones, setSelectedMicrophone })
                          await getAndSetSpeakers({ setAvailableSpeakers, setSelectedSpeaker })
                        } catch (error) {
                          console.error('Error loading microphones:', error)
                          setIsAudioOpen(false) // Revert if permission denied
                        }
                      }
                    }}
                    size="small"
                    sx={{
                      backgroundColor: isAudioOpen ? 'rgba(16, 185, 129, 0.08)' : 'rgba(239, 68, 68, 0.08)',
                      color: isAudioOpen ? 'rgba(16, 185, 129, 0.8)' : 'rgba(239, 68, 68, 0.8)',
                      border: `1px solid ${isAudioOpen ? 'rgba(16, 185, 129, 0.2)' : 'rgba(239, 68, 68, 0.2)'}`,
                      padding: { xs: '6px', sm: '4px' },
                      flexShrink: 0,
                      '&:hover': {
                        backgroundColor: isAudioOpen ? 'rgba(16, 185, 129, 0.15)' : 'rgba(239, 68, 68, 0.15)',
                      },
                    }}
                  >
                    {isAudioOpen ? <MicIcon sx={{ fontSize: { xs: 18, sm: 16 } }} /> : <MicOffIcon sx={{ fontSize: { xs: 18, sm: 16 } }} />}
                  </IconButton>
                  <Typography variant="caption" sx={{ 
                    flex: { xs: '1 1 auto', sm: 1 }, 
                    fontWeight: 400, 
                    color: 'rgba(107, 114, 128, 0.7)', 
                    fontSize: { xs: '12px', sm: '11px' },
                    minWidth: { xs: '60px', sm: 'auto' },
                  }}>
                    Mic
                  </Typography>
                  <FormControl size="small" sx={{ 
                    minWidth: { xs: '100%', sm: 140 },
                    width: { xs: '100%', sm: 'auto' },
                    flex: { xs: '1 1 100%', sm: '0 0 auto' },
                  }}>
                    <Select
                      value={selectedMicrophone}
                      onChange={(e) => setSelectedMicrophone(e.target.value)}
                      disabled={!isAudioOpen}
                      sx={{
                        fontSize: { xs: '12px', sm: '11px' },
                        height: { xs: '32px', sm: '28px' },
                        '& .MuiSelect-select': {
                          padding: { xs: '6px 10px', sm: '4px 8px' },
                        },
                      }}
                    >
                      {availableMicrophones.map((mic) => (
                        <MenuItem key={mic.deviceId} value={mic.deviceId} sx={{ fontSize: { xs: '12px', sm: '11px' } }}>
                          {mic.label || `Mic ${mic.deviceId.slice(0, 8)}`}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>

                {/* Speaker Selection - Compact */}
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: { xs: 0.75, sm: 1 },
                  flexWrap: { xs: 'wrap', sm: 'nowrap' },
                }}>
                  <IconButton
                    disabled
                    size="small"
                    sx={{
                      backgroundColor: 'rgba(107, 114, 128, 0.08)',
                      color: 'rgba(107, 114, 128, 0.6)',
                      border: '1px solid rgba(107, 114, 128, 0.2)',
                      padding: { xs: '6px', sm: '4px' },
                      flexShrink: 0,
                    }}
                  >
                    <VolumeUpIcon sx={{ fontSize: { xs: 18, sm: 16 } }} />
                  </IconButton>
                  <Typography variant="caption" sx={{ 
                    flex: { xs: '1 1 auto', sm: 1 }, 
                    fontWeight: 400, 
                    color: 'rgba(107, 114, 128, 0.7)', 
                    fontSize: { xs: '12px', sm: '11px' },
                    minWidth: { xs: '60px', sm: 'auto' },
                  }}>
                    Speaker
                  </Typography>
                  <FormControl size="small" sx={{ 
                    minWidth: { xs: '100%', sm: 140 },
                    width: { xs: '100%', sm: 'auto' },
                    flex: { xs: '1 1 100%', sm: '0 0 auto' },
                  }}>
                    <Select
                      value={selectedSpeaker}
                      onChange={(e) => setSelectedSpeaker(e.target.value)}
                      sx={{
                        fontSize: { xs: '12px', sm: '11px' },
                        height: { xs: '32px', sm: '28px' },
                        '& .MuiSelect-select': {
                          padding: { xs: '6px 10px', sm: '4px 8px' },
                        },
                      }}
                    >
                      {availableSpeakers.map((speaker) => (
                        <MenuItem key={speaker.deviceId} value={speaker.deviceId} sx={{ fontSize: { xs: '12px', sm: '11px' } }}>
                          {speaker.label || `Speaker ${speaker.deviceId.slice(0, 8)}`}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Paper>

              {/* Exit Button */}
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <CheckoutButtonComponent
                  text="Exit"
                  exitButtonText="Exit"
                  showExitButtonIfNotCheckedIn={true}
                  styleProp={{
                    fontSize: '11px',
                    fontWeight: 500,
                    padding: '6px 12px',
                    backgroundColor: 'rgba(239, 68, 68, 0.08)',
                    color: 'rgba(220, 38, 38, 0.8)',
                    border: '1px solid rgba(239, 68, 68, 0.15)',
                    borderRadius: '8px',
                    boxShadow: 'none',
                    '&:hover': {
                      background: 'rgba(239, 68, 68, 0.12)',
                      borderColor: 'rgba(239, 68, 68, 0.25)',
                    },
                    transition: 'all 0.2s ease',
                  }}
                  buttonColor="error"
                  buttonVariant="outlined"
                />
              </Box>
            </Box>
          </Box>
        )}
        {chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING && (
          <Box
            ref={videoContainerRef}
            sx={videoContainerSx}
            className="hide-on-print-only mobile-video-container"
          >
            {/* Desktop: Signal actions as fixed sidebar - Hidden on mobile */}
            {!isMobile && (
            <ChamberScreenSignallingActions
              chamberRoomId={serverGivenNextAction?.channel?.chamberRoomId}
            />
            )}
            
            {/* Mobile: Floating buttons on top right - View toggle, Focus, then Bolt */}
            {isMobile && (
              <Box
                sx={{
                  position: 'fixed',
                  top: '80px',
                  right: '16px',
                  zIndex: 1400,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '12px',
                }}
              >
                {/* View Toggle Button - Portrait/Landscape */}
                <Tooltip title={isVideoLandscape ? "Switch to Portrait View" : "Switch to Landscape View"} arrow>
                  <IconButton
                    onClick={() => setIsVideoLandscape(!isVideoLandscape)}
                    size="small"
                    sx={{
                      backgroundColor: 'rgba(103, 121, 227, 0.2)',
                      backdropFilter: 'blur(12px) saturate(180%)',
                      WebkitBackdropFilter: 'blur(12px) saturate(180%)',
                      border: '1px solid rgba(103, 121, 227, 0.4)',
                      color: '#6779e3',
                      width: { xs: '40px', sm: '44px' },
                      height: { xs: '40px', sm: '44px' },
                      boxShadow: '0 4px 16px rgba(103, 121, 227, 0.2)',
                      '&:hover': {
                        backgroundColor: 'rgba(103, 121, 227, 0.3)',
                        borderColor: 'rgba(103, 121, 227, 0.6)',
                        transform: 'scale(1.1)',
                        boxShadow: '0 6px 20px rgba(103, 121, 227, 0.3)',
                      },
                      transition: 'all 0.2s ease',
                    }}
                  >
                    {isVideoLandscape ? (
                      <CropPortraitIcon sx={{ fontSize: { xs: 20, sm: 22 } }} />
                    ) : (
                      <CropLandscapeIcon sx={{ fontSize: { xs: 20, sm: 22 } }} />
                    )}
                  </IconButton>
                </Tooltip>
                
                {/* Layout Toggle Button - Grid/Pin */}
                <Tooltip title={videoLayoutMode === layout.grid ? "Switch to Pin Layout" : "Switch to Grid Layout"} arrow>
                <IconButton
                    onClick={() => setVideoLayoutMode(videoLayoutMode === layout.grid ? layout.pin : layout.grid)}
                  size="small"
                  sx={{
                      backgroundColor: 'rgba(103, 121, 227, 0.2)',
                      backdropFilter: 'blur(12px) saturate(180%)',
                      WebkitBackdropFilter: 'blur(12px) saturate(180%)',
                      border: '1px solid rgba(103, 121, 227, 0.4)',
                    color: '#6779e3',
                    width: { xs: '40px', sm: '44px' },
                    height: { xs: '40px', sm: '44px' },
                      boxShadow: '0 4px 16px rgba(103, 121, 227, 0.2)',
                    '&:hover': {
                        backgroundColor: 'rgba(103, 121, 227, 0.3)',
                        borderColor: 'rgba(103, 121, 227, 0.6)',
                      transform: 'scale(1.1)',
                        boxShadow: '0 6px 20px rgba(103, 121, 227, 0.3)',
                    },
                    transition: 'all 0.2s ease',
                  }}
                >
                    {videoLayoutMode === layout.grid ? (
                      <ViewComfyIcon sx={{ fontSize: { xs: 20, sm: 22 } }} />
                    ) : (
                      <ViewModuleIcon sx={{ fontSize: { xs: 20, sm: 22 } }} />
                    )}
                </IconButton>
                </Tooltip>
                
                {/* Focus button - Third */}
                <Tooltip title="Select video to focus" arrow>
                  <IconButton
                    onClick={(e) => setFocusMenuAnchor(e.currentTarget)}
                    size="small"
                    sx={{
                      backgroundColor: 'rgba(103, 121, 227, 0.2)',
                      backdropFilter: 'blur(12px) saturate(180%)',
                      WebkitBackdropFilter: 'blur(12px) saturate(180%)',
                      border: '1px solid rgba(103, 121, 227, 0.4)',
                      color: '#6779e3',
                      width: { xs: '40px', sm: '44px' },
                      height: { xs: '40px', sm: '44px' },
                      boxShadow: '0 4px 16px rgba(103, 121, 227, 0.2)',
                      '&:hover': {
                        backgroundColor: 'rgba(103, 121, 227, 0.3)',
                        borderColor: 'rgba(103, 121, 227, 0.6)',
                        transform: 'scale(1.1)',
                        boxShadow: '0 6px 20px rgba(103, 121, 227, 0.3)',
                      },
                      transition: 'all 0.2s ease',
                    }}
                  >
                    <CenterFocusStrongIcon sx={{ fontSize: { xs: 20, sm: 22 } }} />
                  </IconButton>
                </Tooltip>
                
                {/* Bolt button - Second */}
                <IconButton
                  size="small"
                  onClick={(e) => setMobileActionsMenuAnchor(e.currentTarget)}
                  sx={{
                    backgroundColor: 'rgba(103, 121, 227, 0.15)',
                    border: '2px solid rgba(103, 121, 227, 0.3)',
                    color: '#6779e3',
                    width: { xs: '40px', sm: '44px' },
                    height: { xs: '40px', sm: '44px' },
                    boxShadow: '0 4px 12px rgba(103, 121, 227, 0.25)',
                    '&:hover': {
                      backgroundColor: 'rgba(103, 121, 227, 0.25)',
                      borderColor: 'rgba(103, 121, 227, 0.5)',
                      transform: 'scale(1.1)',
                      boxShadow: '0 6px 16px rgba(103, 121, 227, 0.35)',
                    },
                    transition: 'all 0.2s ease',
                  }}
                >
                  <BoltIcon sx={{ fontSize: { xs: 20, sm: 22 } }} />
                </IconButton>
                
                {/* Assessments - full-page /l/* when no split (right panel hidden); only when patient in session */}
                {patientSelected && (
                  <Tooltip title="Conduct assessment" arrow>
                    <IconButton
                      size="small"
                      onClick={() => setAssessmentDrawerOpen(true)}
                      sx={{
                        backgroundColor: 'rgba(103, 121, 227, 0.2)',
                        backdropFilter: 'blur(12px) saturate(180%)',
                        WebkitBackdropFilter: 'blur(12px) saturate(180%)',
                        border: '1px solid rgba(103, 121, 227, 0.4)',
                        color: '#6779e3',
                        width: { xs: '40px', sm: '44px' },
                        height: { xs: '40px', sm: '44px' },
                        boxShadow: '0 4px 16px rgba(103, 121, 227, 0.2)',
                        '&:hover': {
                          backgroundColor: 'rgba(103, 121, 227, 0.3)',
                          borderColor: 'rgba(103, 121, 227, 0.6)',
                          transform: 'scale(1.1)',
                          boxShadow: '0 6px 20px rgba(103, 121, 227, 0.3)',
                        },
                        transition: 'all 0.2s ease',
                      }}
                    >
                      <AssignmentIcon sx={{ fontSize: { xs: 20, sm: 22 } }} />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            )}
            
            {/* Mobile: Focus/Swap Menu */}
            {isMobile && (
              <Menu
                anchorEl={focusMenuAnchor}
                open={focusMenuOpen}
                onClose={() => setFocusMenuAnchor(null)}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                PaperProps={{
                  sx: {
                    mt: 1,
                    minWidth: 240,
                    maxHeight: 400,
                    borderRadius: '12px',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                    border: '1px solid rgba(103, 121, 227, 0.1)',
                    overflow: 'auto',
                  },
                }}
              >
                {getFocusMenuUsers.length > 0 ? (
                  getFocusMenuUsers.map((userInfo) => {
                    const isFocused = focusedUserId !== null && (
                      focusedUserId === userInfo.uid ||
                      String(focusedUserId) === String(userInfo.uid) ||
                      Number(focusedUserId) === Number(userInfo.uid)
                    )
                    const profilePicUrl = getProfilePictureUrl(userInfo.profilePicId)
                    const initials = getInitials(userInfo.name)
                    
                    return (
                      <MenuItem
                        key={userInfo.uid}
                        onClick={() => {
                          // Focus on this user's video
                          try {
                            const videoContainer = videoFullscreenRef.current || videoContainerRef.current
                            if (videoContainer) {
                              // For local user, use uid 0 or agoraRtcProps.uid
                              const targetUid = userInfo.isLocal ? (agoraRtcProps?.uid || 0) : userInfo.uid
                              
                              const videoElement = videoContainer.querySelector(`[data-uid="${targetUid}"]`) || 
                                videoContainer.querySelector(`div[style*="position"][data-uid="${targetUid}"]`)
                              if (videoElement) {
                                videoElement.click()
                                setFocusedUserId(targetUid)
                              } else {
                                // Try alternative method
                                const allVideos = videoContainer.querySelectorAll('div[style*="position"]')
                                allVideos.forEach((videoDiv) => {
                                  const uidAttr = videoDiv.getAttribute('data-uid')
                                  if (uidAttr && (parseInt(uidAttr) === parseInt(targetUid) || String(uidAttr) === String(targetUid))) {
                                    videoDiv.click()
                                    setFocusedUserId(targetUid)
                                  }
                                })
                              }
                            }
                          } catch (error) {
                            console.error('Error focusing user:', error)
                          }
                          setFocusMenuAnchor(null)
                        }}
                        sx={{
                          '&:hover': {
                            backgroundColor: 'rgba(103, 121, 227, 0.1)',
                          },
                          backgroundColor: isFocused ? 'rgba(103, 121, 227, 0.15)' : 'transparent',
                          borderLeft: isFocused ? '3px solid #6779e3' : '3px solid transparent',
                        }}
                      >
                        <Avatar
                          src={profilePicUrl || undefined}
                          sx={{
                            width: 32,
                            height: 32,
                            mr: 1.5,
                            fontSize: '14px',
                            bgcolor: profilePicUrl ? 'transparent' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          }}
                        >
                          {!profilePicUrl && initials}
                        </Avatar>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              fontSize: '14px',
                              fontWeight: isFocused ? 600 : 400,
                              color: isFocused ? '#6779e3' : 'inherit',
                            }}
                          >
                            {userInfo.name}
                            {userInfo.isLocal && (
                              <Typography component="span" variant="caption" sx={{ ml: 0.5, color: 'text.secondary', fontSize: '11px' }}>
                                (You)
                              </Typography>
                            )}
                          </Typography>
                          {userInfo.role && (
                            <Typography variant="caption" sx={{ fontSize: '11px', color: 'text.secondary', display: 'block' }}>
                              {userInfo.role === 'mentor' ? 'Mentor' : 
                               userInfo.role === 'patient' ? 'Patient' : 
                               userInfo.role === 'chamber-room' ? 'Chamber Room' : 
                               userInfo.role}
                            </Typography>
                          )}
                        </Box>
                        {isFocused && (
                          <CenterFocusStrongIcon sx={{ fontSize: 18, color: '#6779e3', ml: 1 }} />
                        )}
                      </MenuItem>
                    )
                  })
                ) : (
                  <MenuItem disabled>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.5)' }}>
                      No participants available
                    </Typography>
                  </MenuItem>
                )}
              </Menu>
            )}
            
            {/* Mobile: Menu for room screen actions */}
            {isMobile && (
                <Menu
                  anchorEl={mobileActionsMenuAnchor}
                  open={mobileActionsMenuOpen}
                  onClose={() => setMobileActionsMenuAnchor(null)}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  PaperProps={{
                    sx: {
                      mt: 1,
                      minWidth: 200,
                      borderRadius: '12px',
                      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                      border: '1px solid rgba(103, 121, 227, 0.1)',
                    },
                  }}
                >
                  <MenuItem
                    onClick={async () => {
                      await sendShowImageCommandToChamberScreen(serverGivenNextAction?.channel?.chamberRoomId, 'payment-qr')
                      setMobileActionsMenuAnchor(null)
                    }}
                  >
                    <QrCodeScannerIcon sx={{ fontSize: 18, mr: 1.5, color: 'rgba(103, 121, 227, 0.7)' }} />
                    Show Payment QR
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      askCheckedInChamberScreenToPollNextAction(serverGivenNextAction?.channel?.chamberRoomId)
                      setMobileActionsMenuAnchor(null)
                    }}
                  >
                    <LoginIcon sx={{ fontSize: 18, mr: 1.5, color: 'rgba(103, 121, 227, 0.7)' }} />
                    Fast-track Connect
                  </MenuItem>
                  <MenuItem
                    onClick={async () => {
                      sendShowImageCommandToChamberScreen(serverGivenNextAction?.channel?.chamberRoomId, 'clear-screen')
                      setMobileActionsMenuAnchor(null)
                    }}
                  >
                    <LayersClearIcon sx={{ fontSize: 18, mr: 1.5, color: 'rgba(103, 121, 227, 0.7)' }} />
                    Clear Screen
                  </MenuItem>
                  <MenuItem
                    onClick={async () => {
                      await sendReloadChamberRoomScreenSignal(serverGivenNextAction?.channel?.chamberRoomId)
                      setMobileActionsMenuAnchor(null)
                    }}
                  >
                    <ReplayIcon sx={{ fontSize: 18, mr: 1.5, color: 'rgba(103, 121, 227, 0.7)' }} />
                    Refresh Screen
                  </MenuItem>
                </Menu>
            )}
            
            <Box
              ref={(node) => {
                videoFullscreenRef.current = node
                refVideoContainer.current = node
              }}
              data-video-container="left-frame"
              sx={{
                position: 'relative',
                // Mobile: Full screen (calendar is in drawer). Desktop: Resizable
                flexGrow: isMobile && isVideoLandscape ? 0 : 1, // Don't grow in landscape mode
                flexShrink: isMobile ? (isVideoLandscape ? 1 : 0) : 1, // Allow shrink in landscape mode
                flexBasis: isMobile ? (isVideoLandscape ? 'auto' : '100%') : 0, // Auto basis in landscape, full width in portrait
                width: isMobile ? (isVideoLandscape ? '100vw' : '100%') : undefined, // Full viewport width in landscape, full width in portrait
                // Mobile: Landscape mode uses calculated height (56.25vw), Portrait uses full viewport height. Desktop: 100% of parent
                height: isMobile ? (isVideoLandscape ? '56.25vw' : '100vh') : '100%',
                minHeight: isMobile ? (isVideoLandscape ? 0 : '100vh') : 0, // No min height in landscape, full height in portrait
                display: 'flex',
                flexDirection: 'column',
                overflow: isMobile ? 'visible' : 'hidden', // Allow overflow on mobile so fixed controls aren't clipped
                zIndex: 100,
                maxHeight: isMobile ? (isVideoLandscape ? '100vh' : '100vh') : '100%', // Don't exceed viewport on mobile
              }}
            >
            <AgoraVideoComponent
              key={`agora-video-${agoraRtcProps?.channel || 'none'}-${isInBookedEventSession ? 'booked' : 'chamber'}`}
              agoraRtcProps={agoraRtcProps}
              agoraRtmProps={agoraRtmProps}
              handleLeaveRoom={() => {
                leaveThisSession()
              }}
                onUserJoin={(user) => {
                  // Track join time for this RTC user (for mapping RTM data later)
                  const rtcUid = user.uid
                  const rtcUidNum = typeof rtcUid === 'string' ? parseInt(rtcUid, 10) : Number(rtcUid)
                  rtcUserJoinTimesRef.current.set(rtcUid, Date.now())
                  rtcUserJoinTimesRef.current.set(rtcUidNum, Date.now())
                  rtcUserJoinTimesRef.current.set(String(rtcUid), Date.now())
                  
                  // Debug: log user join to see if user object contains any RTM data
                  const currentAgoraRtcProps = agoraRtcPropsRef.current || {}
                  const isLocalUser = rtcUid === 0 || (currentAgoraRtcProps?.uid !== undefined && rtcUid === currentAgoraRtcProps.uid)
                  if (!isLocalUser) {
                    // Expand user object to see all properties
                    const userObjectDetails = {}
                    if (user) {
                      Object.keys(user).forEach((key) => {
                        userObjectDetails[key] = user[key]
                      })
                    }
                  }
                  
                  setRemoteUsers((prev) => {
                    const exists = prev.find((u) => u.uid === user.uid)
                    if (exists) return prev
                    return [...prev, user]
                  })
                  
                  // REVERSE MAPPING: When a new RTC user joins, check if there's unmapped RTM data
                  // This handles the case where RTM data arrived before the user joined
                  setUidToUsernameMap((prev) => {
                    const rtcUid = user.uid
                    const rtcUidNum = typeof rtcUid === 'string' ? parseInt(rtcUid, 10) : Number(rtcUid)
                    const rtcUidStr = String(rtcUid)
                    
                    // Check if this RTC UID already has a username
                    const hasUsername = prev[rtcUid] || prev[rtcUidNum] || prev[rtcUidStr]
                    if (hasUsername) return prev // Already mapped
                    
                    // Skip local user
                    const currentAgoraRtcProps = agoraRtcPropsRef.current || {}
                    if (rtcUid === 0 || (currentAgoraRtcProps?.uid !== undefined && rtcUid === currentAgoraRtcProps.uid)) {
                      return prev
                    }
                    
                    // Find unmapped RTM data: RTM IDs that don't match any existing RTC UID
                    const currentRemoteUsers = remoteUsersRef.current || []
                    const existingRtcUids = new Set()
                    // Include all existing remote users
                    currentRemoteUsers.forEach((ru) => {
                      existingRtcUids.add(ru.uid)
                      existingRtcUids.add(Number(ru.uid))
                      existingRtcUids.add(String(ru.uid))
                    })
                    // Also add the newly joined user (since remoteUsers state hasn't updated yet)
                    existingRtcUids.add(rtcUid)
                    existingRtcUids.add(rtcUidNum)
                    existingRtcUids.add(rtcUidStr)
                    // Also add local user's RTC UID
                    if (currentAgoraRtcProps?.uid !== undefined) {
                      existingRtcUids.add(currentAgoraRtcProps.uid)
                      existingRtcUids.add(Number(currentAgoraRtcProps.uid))
                      existingRtcUids.add(String(currentAgoraRtcProps.uid))
                    }
                    
                    // Find RTM IDs (keys in map) that don't match any RTC UID
                    const unmappedRtmIds = Object.keys(prev).filter((key) => {
                      const keyNum = Number(key)
                      if (isNaN(keyNum)) return false
                      // If this key doesn't match any existing RTC UID, it's likely an unmapped RTM ID
                      return !existingRtcUids.has(key) && 
                             !existingRtcUids.has(keyNum) && 
                             !existingRtcUids.has(String(keyNum))
                    })
                    
                    // If we found unmapped RTM data, map it to this newly joined RTC user
                    if (unmappedRtmIds.length > 0) {
                      // Use the first unmapped RTM ID (or we could use the most recent one)
                      const rtmId = unmappedRtmIds[0]
                      const username = prev[rtmId] || prev[Number(rtmId)] || prev[String(rtmId)]
                      
                      if (username) {
                        // Map this RTM username to the newly joined RTC user
                        const updated = {
                          ...prev,
                          [rtcUid]: username,
                          [rtcUidNum]: username,
                          [rtcUidStr]: username,
                        }
                        
                        // Update window object immediately so CustomVideoPlaceholder can access it right away
                        if (typeof window !== 'undefined') {
                          window.__latestUidToUsernameMap = updated
                        }
                        
                        return updated
                      }
                    }
                    
                    return prev
                  })
                }}
                onUserLeave={(user) => {
                  // Clean up join time tracking
                  const rtcUid = user.uid
                  const rtcUidNum = typeof rtcUid === 'string' ? parseInt(rtcUid, 10) : Number(rtcUid)
                  rtcUserJoinTimesRef.current.delete(rtcUid)
                  rtcUserJoinTimesRef.current.delete(rtcUidNum)
                  rtcUserJoinTimesRef.current.delete(String(rtcUid))
                  
                  setRemoteUsers((prev) => prev.filter((u) => u.uid !== user.uid))
              }}
              callContainerStyles={{
                flexGrow: 1,
                borderRadius: '0',
                height: '100%',
                maxHeight: '100%',
                width: '100%',
                overflow: 'hidden', // Prevent scroll within video call container
              }}
              agoraKitStyleProps={{
                // 🔴 End Call Button (larger, prominent red gradient)
                endCall: {
                  width: '52px',
                  height: '52px',
                  minWidth: '52px',
                  minHeight: '52px',
                  maxWidth: '52px',
                  maxHeight: '52px',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.95) 0%, rgba(220, 38, 38, 1) 100%)',
                  border: '1.5px solid rgba(255, 255, 255, 0.4)',
                  boxShadow: '0 6px 24px rgba(239, 68, 68, 0.6), 0 2px 8px rgba(0, 0, 0, 0.3), inset 0 1px 1px rgba(255, 255, 255, 0.35)',
                  backdropFilter: 'blur(12px)',
                  WebkitBackdropFilter: 'blur(12px)',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                },
                // Main container with subtle purple-tinted background for modern look
                UIKitContainer: {
                  background: 'linear-gradient(135deg, rgba(248, 250, 252, 1) 0%, rgba(243, 244, 255, 1) 100%)',
                  border: '1px solid rgba(139, 92, 246, 0.1)',
                  boxShadow: 'inset 0 0 20px rgba(139, 92, 246, 0.03)',
                  height: '100%',
                  maxHeight: '100%',
                  overflow: 'hidden', // Prevent scroll, fit content within viewport
                },
                // Beautiful username display on video - transparent glass - FLEXIBLE WIDTH
                usernameText: {
                  background: 'rgba(0, 0, 0, 0.3)',
                  backdropFilter: 'blur(8px)',
                  WebkitBackdropFilter: 'blur(8px)',
                  color: '#ffffff',
                  fontSize: '14px',
                  fontWeight: 500,
                  padding: '6px 12px',
                  borderRadius: '12px',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  textShadow: '0 1px 2px rgba(0, 0, 0, 0.5)',
                  letterSpacing: '0.3px',
                  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  // Position at top-left with flexible width
                  position: 'absolute',
                  top: '8px',
                  left: '8px',
                  right: 'auto',
                  margin: '0',
                  // Flexible width - expands to fit content, but respects max-width
                  width: 'auto',
                  maxWidth: 'calc(100% - 16px)', // Leave some padding on both sides
                  minWidth: 'fit-content',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                },
                // Button container styling - dark glass background for visibility
                localBtnContainer: {
                  background: 'rgba(15, 15, 15, 0.75)',
                  backdropFilter: 'blur(20px) saturate(180%)',
                  WebkitBackdropFilter: 'blur(20px) saturate(180%)',
                  border: '1.5px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '16px',
                  padding: '12px 16px',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.6), 0 4px 16px rgba(139, 92, 246, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.05)',
                  display: 'flex',
                  visibility: 'visible',
                  opacity: 1,
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '8px',
                  position: 'absolute',
                  bottom: '16px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  zIndex: 10000,
                  pointerEvents: 'none',
                },
                // Global button template styles - white glass effect for clean look
                BtnTemplateStyles: {
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(255, 255, 255, 0.95)',
                  backdropFilter: 'blur(16px) saturate(180%)',
                  WebkitBackdropFilter: 'blur(16px) saturate(180%)',
                  border: '1.5px solid rgba(255, 255, 255, 0.8)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(139, 92, 246, 0.1), inset 0 1px 0 rgba(255, 255, 255, 1)',
                  pointerEvents: 'auto',
                  color: '#1f2937',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 1)',
                    borderColor: 'rgba(139, 92, 246, 0.6)',
                    transform: 'translateY(-2px) scale(1.05)',
                    boxShadow: '0 12px 32px rgba(0, 0, 0, 0.2), 0 6px 16px rgba(139, 92, 246, 0.25), inset 0 1px 0 rgba(255, 255, 255, 1), 0 0 20px rgba(139, 92, 246, 0.3)',
                  },
                },
                // Individual button customizations - white glass with subtle color accents
                localBtnStyles: {
                  muteLocalAudio: {
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(16px) saturate(180%)',
                    WebkitBackdropFilter: 'blur(16px) saturate(180%)',
                    border: '1.5px solid rgba(139, 92, 246, 0.2)',
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(139, 92, 246, 0.1)',
                    color: '#1f2937',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 1)',
                      borderColor: 'rgba(139, 92, 246, 0.6)',
                      boxShadow: '0 12px 32px rgba(0, 0, 0, 0.2), 0 6px 16px rgba(139, 92, 246, 0.25), 0 0 20px rgba(139, 92, 246, 0.3)',
                    },
                  },
                  muteLocalVideo: {
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(16px) saturate(180%)',
                    WebkitBackdropFilter: 'blur(16px) saturate(180%)',
                    border: '1.5px solid rgba(139, 92, 246, 0.2)',
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(139, 92, 246, 0.1)',
                    color: '#1f2937',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 1)',
                      borderColor: 'rgba(139, 92, 246, 0.6)',
                      boxShadow: '0 12px 32px rgba(0, 0, 0, 0.2), 0 6px 16px rgba(139, 92, 246, 0.25), 0 0 20px rgba(139, 92, 246, 0.3)',
                    },
                  },
                  screenshare: {
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(16px) saturate(180%)',
                    WebkitBackdropFilter: 'blur(16px) saturate(180%)',
                    border: '1.5px solid rgba(56, 189, 248, 0.2)',
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(56, 189, 248, 0.1)',
                    color: '#1f2937',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 1)',
                      borderColor: 'rgba(56, 189, 248, 0.6)',
                      boxShadow: '0 12px 32px rgba(0, 0, 0, 0.2), 0 6px 16px rgba(56, 189, 248, 0.25), 0 0 20px rgba(56, 189, 248, 0.3)',
                    },
                  },
                  settings: {
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(16px) saturate(180%)',
                    WebkitBackdropFilter: 'blur(16px) saturate(180%)',
                    border: '1.5px solid rgba(168, 85, 247, 0.2)',
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(168, 85, 247, 0.1)',
                    color: '#1f2937',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 1)',
                      borderColor: 'rgba(168, 85, 247, 0.6)',
                      boxShadow: '0 12px 32px rgba(0, 0, 0, 0.2), 0 6px 16px rgba(168, 85, 247, 0.25), 0 0 20px rgba(168, 85, 247, 0.3)',
                    },
                  },
                  endCall: {
                    width: '52px',
                    height: '52px',
                    backgroundColor: 'rgba(220, 38, 38, 0.95)',
                    backdropFilter: 'blur(16px) saturate(180%)',
                    WebkitBackdropFilter: 'blur(16px) saturate(180%)',
                    border: '1.5px solid rgba(239, 68, 68, 0.6)',
                    boxShadow: '0 8px 24px rgba(220, 38, 38, 0.5), 0 4px 12px rgba(239, 68, 68, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
                    color: '#ffffff',
                    '&:hover': {
                      backgroundColor: 'rgba(239, 68, 68, 0.35)',
                      borderColor: 'rgba(239, 68, 68, 0.7)',
                    },
                  },
                },
                // Remote user button styles - glass effect for mic/camera status icons
                remoteBtnStyles: {
                  muteRemoteAudio: {
                    backgroundColor: 'rgba(239, 68, 68, 0.2)',
                    backdropFilter: 'blur(12px) saturate(180%)',
                    WebkitBackdropFilter: 'blur(12px) saturate(180%)',
                    border: '1px solid rgba(239, 68, 68, 0.4)',
                    boxShadow: '0 4px 16px rgba(239, 68, 68, 0.2)',
                  },
                  muteRemoteVideo: {
                    backgroundColor: 'rgba(239, 68, 68, 0.2)',
                    backdropFilter: 'blur(12px) saturate(180%)',
                    WebkitBackdropFilter: 'blur(12px) saturate(180%)',
                    border: '1px solid rgba(239, 68, 68, 0.4)',
                    boxShadow: '0 4px 16px rgba(239, 68, 68, 0.2)',
                  },
                },
                // Icon color and size
                theme: '#475569', // Slate-600 for good contrast
                iconSize: 24,
              }}
              playAudioOnUserJoin={false}
              playAudioOnUserLeave={false}
              onCameraClose={() => {
                setIsCameraOpen(false)
                if (selectedPatientBookedEventId) {
                  markBookedEventLog(selectedPatientBookedEventId, 'CAMERA_OFF', 'mentor', {
                    camera: false,
                    mic: isAudioOpen,
                  })
                }
              }}
              onCameraOpen={() => {
                setIsCameraOpen(true)
                if (selectedPatientBookedEventId) {
                  markBookedEventLog(selectedPatientBookedEventId, 'CAMERA_ON', 'mentor', {
                    camera: true,
                    mic: isAudioOpen,
                  })
                }
              }}
              onAudioClose={() => {
                setIsAudioOpen(false)
                if (selectedPatientBookedEventId) {
                  markBookedEventLog(selectedPatientBookedEventId, 'MIC_OFF', 'mentor', {
                    camera: isCameraOpen,
                    mic: false,
                  })
                }
              }}
              onAudioOpen={() => {
                setIsAudioOpen(true)
                if (selectedPatientBookedEventId) {
                  markBookedEventLog(selectedPatientBookedEventId, 'MIC_ON', 'mentor', {
                    camera: isCameraOpen,
                    mic: true,
                  })
                }
              }}
              onUsernameMapUpdate={(usernameMap) => {
                // Store username map - merge with existing to preserve any data we already have
                // This ensures we don't lose remote user data if the callback is called multiple times
                setUidToUsernameMap((prev) => {
                  const newMap = usernameMap || {}
                  
                  // Merge: new data takes precedence, but keep existing data if new map doesn't have it
                  const merged = { ...prev, ...newMap }
                  
                  // Get current state from refs (state might be stale in callback)
                  const currentRemoteUsers = remoteUsersRef.current || []
                  const currentAgoraRtcProps = agoraRtcPropsRef.current || {}
                  
                  // CRITICAL: Map RTM IDs to RTC UIDs
                  // The rtm-user-joined callback receives RTM IDs, but video components use RTC UIDs
                  // Since RTM and RTC IDs can be different, we need to map them correctly
                  Object.keys(newMap).forEach((rtmId) => {
                    const username = newMap[rtmId]
                    if (!username) return
                    
                    const rtmIdNum = Number(rtmId)
                    const rtmIdStr = String(rtmId)
                    
                    // Parse the username to check the role and determine if it's local user data
                    // This is the CORRECT way to identify local user data (by role, not by UID matching)
                    let isLocalUserRtmData = false
                    try {
                      const parsed = JSON.parse(username)
                      // Local user data has role='mentor' (since this is mentor's page)
                      // Check if the username in agoraRtmProps matches this username
                      if (parsed && parsed.role === 'mentor' && agoraRtmProps?.username) {
                        try {
                          const localParsed = JSON.parse(agoraRtmProps.username)
                          // If names match, it's likely the local user
                          isLocalUserRtmData = localParsed?.name === parsed.name
                        } catch (e) {
                          // If can't parse local username, just check role
                          isLocalUserRtmData = parsed.role === 'mentor'
                        }
                      }
                    } catch (e) {
                      // Not JSON or parsing failed, treat as remote user
                      isLocalUserRtmData = false
                    }
                    
                    // Store under RTM ID based on whether it's local or remote user data
                    if (isLocalUserRtmData && currentAgoraRtcProps?.uid !== undefined) {
                      // For local user: ONLY store under RTC UID (not RTM ID)
                      // This prevents collision where local user's RTM ID might match a remote user's RTC UID
                      const localRtcUid = currentAgoraRtcProps.uid
                      const localRtcUidNum = typeof localRtcUid === 'string' ? parseInt(localRtcUid, 10) : Number(localRtcUid)
                      const localRtcUidStr = String(localRtcUid)
                      merged[localRtcUid] = username
                      merged[localRtcUidNum] = username
                      merged[localRtcUidStr] = username
                    } else {
                      // For remote users: store under RTM ID in all formats
                      // This allows the exact match and timing-based mapping to work correctly
                      merged[rtmId] = username
                      if (!isNaN(rtmIdNum)) {
                        merged[rtmIdNum] = username
                        merged[rtmIdStr] = username
                      }
                    }
                    
                    // For remote users: try exact match first
                    // BUT: don't map local user data to remote users via exact match
                    let exactMatchFound = false
                    if (!isLocalUserRtmData) {
                      for (const remoteUser of currentRemoteUsers) {
                        const rtcUid = remoteUser.uid
                        const rtcUidNum = typeof rtcUid === 'string' ? parseInt(rtcUid, 10) : Number(rtcUid)
                        const rtcUidStr = String(rtcUid)
                        
                        // Check if RTM ID matches RTC UID exactly
                        if ((!isNaN(rtmIdNum) && (rtmIdNum === rtcUidNum || rtmIdStr === rtcUidStr)) ||
                            (rtmId === rtcUid || rtmId === rtcUidNum || rtmId === rtcUidStr)) {
                          merged[rtcUid] = username
                          merged[rtcUidNum] = username
                          merged[rtcUidStr] = username
                          exactMatchFound = true
                          break
                        }
                      }
                    }
                    
                    // If no exact match, use timing-based mapping (only for remote users, not local)
                    if (!exactMatchFound && !isNaN(rtmIdNum) && rtmIdNum !== 0 && !isLocalUserRtmData) {
                      // Find RTC users without usernames, sorted by join time (most recent first)
                      const usersWithoutUsername = currentRemoteUsers
                        .filter((remoteUser) => {
                          const rtcUid = remoteUser.uid
                          // Skip local user
                          if (rtcUid === 0 || (currentAgoraRtcProps?.uid !== undefined && rtcUid === currentAgoraRtcProps.uid)) {
                            return false
                          }
                          
                          const rtcUidNum = typeof rtcUid === 'string' ? parseInt(rtcUid, 10) : Number(rtcUid)
                          const rtcUidStr = String(rtcUid)
                          const hasUsername = merged[rtcUid] || merged[rtcUidNum] || merged[rtcUidStr] || 
                                             prev[rtcUid] || prev[rtcUidNum] || prev[rtcUidStr]
                          return !hasUsername
                        })
                        .map((remoteUser) => ({
                          user: remoteUser,
                          joinTime: rtcUserJoinTimesRef.current.get(remoteUser.uid) || 
                                   rtcUserJoinTimesRef.current.get(Number(remoteUser.uid)) || 
                                   rtcUserJoinTimesRef.current.get(String(remoteUser.uid)) || 
                                   0
                        }))
                        .sort((a, b) => b.joinTime - a.joinTime) // Most recent first
                      
                      // Map RTM username to the most recently joined RTC user without a username
                      if (usersWithoutUsername.length > 0) {
                        const mostRecentUser = usersWithoutUsername[0].user
                        const rtcUid = mostRecentUser.uid
                        const rtcUidNum = typeof rtcUid === 'string' ? parseInt(rtcUid, 10) : Number(rtcUid)
                        const rtcUidStr = String(rtcUid)
                        
                        merged[rtcUid] = username
                        merged[rtcUidNum] = username
                        merged[rtcUidStr] = username
                      }
                    }
                  })
                  
                  // Also ensure all keys are stored in both string and number formats for robust lookup
                  const finalMap = {}
                  Object.keys(merged).forEach((key) => {
                    const value = merged[key]
                    finalMap[key] = value
                    const keyNum = Number(key)
                    const keyStr = String(key)
                    if (!isNaN(keyNum)) {
                      finalMap[keyNum] = value
                      finalMap[keyStr] = value
                    }
                  })
                  
                  // Update window object IMMEDIATELY so CustomVideoPlaceholder can access it right away
                  // This avoids timing issues where state update hasn't propagated yet
                  if (typeof window !== 'undefined') {
                    window.__latestUidToUsernameMap = finalMap
                  }
                  
                  // Simple check: if the final map is identical to prev (same keys and values), return prev
                  // This prevents unnecessary re-renders while still allowing updates
                  const prevKeys = Object.keys(prev).sort().join(',')
                  const finalKeys = Object.keys(finalMap).sort().join(',')
                  if (prevKeys === finalKeys) {
                    // Check if any values changed
                    let valuesChanged = false
                    for (const key of Object.keys(finalMap)) {
                      if (prev[key] !== finalMap[key]) {
                        valuesChanged = true
                        break
                      }
                    }
                    if (!valuesChanged) {
                      return prev // No changes, return previous to avoid re-render
                    }
                  }
                  
                  return finalMap
                })
                
                // Parse usernames and update display via DOM manipulation (both mobile and desktop)
                if (usernameMap) {
                  setTimeout(() => {
                    Object.keys(usernameMap).forEach((uid) => {
                      const username = usernameMap[uid]
                      if (!username) return
                      
                      try {
                        const parsed = JSON.parse(username)
                        if (parsed && parsed.name && typeof parsed.name === 'string') {
                          // Follow role-based rules
                          const role = parsed.role
                          const shouldShowName = !role || role === 'mentor' || role === 'patient'
                          const shouldHide = role === 'auditor' || role === 'panelist'
                          
                          // Find all potential username elements in video cards
                          const videoContainer = videoFullscreenRef.current || videoContainerRef.current
                          if (!videoContainer) return
                          
                          // Try multiple selectors to find username elements
                          const selectors = [
                            `div[data-uid="${uid}"] [class*="username"]`,
                            `div[data-uid="${uid}"] span`,
                            `div[data-uid="${uid}"] p`,
                            `div[data-uid="${uid}"] div[style*="background"]`,
                            `[class*="video"][data-uid="${uid}"] [class*="username"]`,
                            `[class*="Video"][data-uid="${uid}"] [class*="username"]`,
                          ]
                          
                          selectors.forEach((selector) => {
                            try {
                              const elements = videoContainer.querySelectorAll(selector)
                              elements.forEach((el) => {
                                const text = el.textContent || el.innerText || ''
                                // If element contains JSON or raw username, replace with parsed name
                                if (text.includes('{') || text === username || text.includes('"name"')) {
                                  if (shouldHide) {
                                    el.textContent = ''
                                    el.innerText = ''
                                    el.style.display = 'none'
                                  } else if (shouldShowName) {
                                    el.textContent = parsed.name
                                    el.innerText = parsed.name
                                    el.style.display = ''
                                  } else {
                                    // Other roles - show name
                                    el.textContent = parsed.name
                                    el.innerText = parsed.name
                                    el.style.display = ''
                                  }
                                }
                              })
                            } catch (e) {
                              // Selector failed, continue
                            }
                          })
                        }
                      } catch (e) {
                        // Not JSON, try to find and update if it's the raw username
                        const videoContainer = videoFullscreenRef.current || videoContainerRef.current
                        if (videoContainer) {
                          const elements = videoContainer.querySelectorAll(`[class*="username"]`)
                          elements.forEach((el) => {
                            if (el.textContent === username && username.includes('{')) {
                              // Try to extract name from malformed JSON
                              const nameMatch = username.match(/"name"\s*:\s*"([^"]+)"/)
                              if (nameMatch && nameMatch[1]) {
                                el.textContent = nameMatch[1]
                                el.innerText = nameMatch[1]
                              }
                            }
                          })
                        }
                      }
                    })
                  }, 200)
                }
              }}
              />
            </Box>
          </Box>
        )}
        
        {/* Debug Panel - Desktop only */}
        {!isMobile && chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING && (
          <DebugPanel
            uidToUsernameMap={uidToUsernameMap}
            remoteUsers={remoteUsers}
            agoraRtcProps={agoraRtcProps}
            agoraRtmProps={agoraRtmProps}
          />
        )}
        
        {/* Focus/Swap button - Desktop only, positioned at bottom near debug button */}
        {!isMobile && chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING && (
          <>
            <Tooltip title="Select video to focus" arrow>
              <IconButton
                onClick={(e) => setFocusMenuAnchor(e.currentTarget)}
                sx={{
                  position: 'fixed',
                  bottom: 16,
                  left: 64, // Positioned to the right of debug button (which is at left: 16, width ~40px)
                  zIndex: 9999,
                  backgroundColor: 'rgba(103, 121, 227, 0.2)',
                  backdropFilter: 'blur(12px) saturate(180%)',
                  WebkitBackdropFilter: 'blur(12px) saturate(180%)',
                  border: '1px solid rgba(103, 121, 227, 0.4)',
                  color: '#6779e3',
                  width: '40px',
                  height: '40px',
                  boxShadow: '0 4px 16px rgba(103, 121, 227, 0.2)',
                  '&:hover': {
                    backgroundColor: 'rgba(103, 121, 227, 0.3)',
                    borderColor: 'rgba(103, 121, 227, 0.6)',
                    transform: 'scale(1.1)',
                    boxShadow: '0 6px 20px rgba(103, 121, 227, 0.3)',
                  },
                  transition: 'all 0.2s ease',
                }}
              >
                <CenterFocusStrongIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </Tooltip>
            
            {/* Layout Toggle Button - Desktop only, positioned at bottom after Focus button */}
            <Tooltip title={videoLayoutMode === layout.grid ? "Switch to Pin Layout" : "Switch to Grid Layout"} arrow>
              <IconButton
                onClick={() => setVideoLayoutMode(videoLayoutMode === layout.grid ? layout.pin : layout.grid)}
                sx={{
                  position: 'fixed',
                  bottom: 16,
                  left: 112, // Positioned to the right of Focus button (which is at left: 64, width ~40px, gap ~8px)
                  zIndex: 9999,
                  backgroundColor: 'rgba(103, 121, 227, 0.2)',
                  backdropFilter: 'blur(12px) saturate(180%)',
                  WebkitBackdropFilter: 'blur(12px) saturate(180%)',
                  border: '1px solid rgba(103, 121, 227, 0.4)',
                  color: '#6779e3',
                  width: '40px',
                  height: '40px',
                  boxShadow: '0 4px 16px rgba(103, 121, 227, 0.2)',
                  '&:hover': {
                    backgroundColor: 'rgba(103, 121, 227, 0.3)',
                    borderColor: 'rgba(103, 121, 227, 0.6)',
                    transform: 'scale(1.1)',
                    boxShadow: '0 6px 20px rgba(103, 121, 227, 0.3)',
                  },
                  transition: 'all 0.2s ease',
                }}
              >
                {videoLayoutMode === layout.grid ? (
                  <ViewComfyIcon sx={{ fontSize: 20 }} />
                ) : (
                  <ViewModuleIcon sx={{ fontSize: 20 }} />
                )}
              </IconButton>
            </Tooltip>
            
            {/* Focus/Swap Menu */}
            <Menu
              anchorEl={focusMenuAnchor}
              open={focusMenuOpen}
              onClose={() => setFocusMenuAnchor(null)}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              PaperProps={{
                sx: {
                  mt: 1,
                  minWidth: 240,
                  maxHeight: 400,
                  borderRadius: '12px',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                  border: '1px solid rgba(103, 121, 227, 0.1)',
                  overflow: 'auto',
                },
              }}
            >
              {getFocusMenuUsers.length > 0 ? (
                getFocusMenuUsers.map((userInfo) => {
                  const isFocused = focusedUserId !== null && (
                    focusedUserId === userInfo.uid ||
                    String(focusedUserId) === String(userInfo.uid) ||
                    Number(focusedUserId) === Number(userInfo.uid)
                  )
                  const profilePicUrl = getProfilePictureUrl(userInfo.profilePicId)
                  const initials = getInitials(userInfo.name)
                  
                  return (
                    <MenuItem
                      key={userInfo.uid}
                      onClick={() => {
                        // Focus on this user's video
                        try {
                          const videoContainer = videoFullscreenRef.current || videoContainerRef.current
                          if (videoContainer) {
                            // For local user, use uid 0 or agoraRtcProps.uid
                            const targetUid = userInfo.isLocal ? (agoraRtcProps?.uid || 0) : userInfo.uid
                            
                            const videoElement = videoContainer.querySelector(`[data-uid="${targetUid}"]`) || 
                              videoContainer.querySelector(`div[style*="position"][data-uid="${targetUid}"]`)
                            if (videoElement) {
                              videoElement.click()
                              setFocusedUserId(targetUid)
                            } else {
                              // Try alternative method
                              const allVideos = videoContainer.querySelectorAll('div[style*="position"]')
                              allVideos.forEach((videoDiv) => {
                                const uidAttr = videoDiv.getAttribute('data-uid')
                                if (uidAttr && (parseInt(uidAttr) === parseInt(targetUid) || String(uidAttr) === String(targetUid))) {
                                  videoDiv.click()
                                  setFocusedUserId(targetUid)
                                }
                              })
                            }
                          }
                        } catch (error) {
                          console.error('Error focusing user:', error)
                        }
                        setFocusMenuAnchor(null)
                      }}
                      sx={{
                        '&:hover': {
                          backgroundColor: 'rgba(103, 121, 227, 0.1)',
                        },
                        backgroundColor: isFocused ? 'rgba(103, 121, 227, 0.15)' : 'transparent',
                        borderLeft: isFocused ? '3px solid #6779e3' : '3px solid transparent',
                      }}
                    >
                      <Avatar
                        src={profilePicUrl || undefined}
                        sx={{
                          width: 32,
                          height: 32,
                          mr: 1.5,
                          fontSize: '14px',
                          bgcolor: profilePicUrl ? 'transparent' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        }}
                      >
                        {!profilePicUrl && initials}
                      </Avatar>
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography 
                          variant="body2" 
                          sx={{ 
                            fontSize: '14px',
                            fontWeight: isFocused ? 600 : 400,
                            color: isFocused ? '#6779e3' : 'inherit',
                          }}
                        >
                          {userInfo.name}
                          {userInfo.isLocal && (
                            <Typography component="span" variant="caption" sx={{ ml: 0.5, color: 'text.secondary', fontSize: '11px' }}>
                              (You)
                            </Typography>
                          )}
                        </Typography>
                        {userInfo.role && (
                          <Typography variant="caption" sx={{ fontSize: '11px', color: 'text.secondary', display: 'block' }}>
                            {userInfo.role === 'mentor' ? 'Mentor' : 
                             userInfo.role === 'patient' ? 'Patient' : 
                             userInfo.role === 'chamber-room' ? 'Chamber Room' : 
                             userInfo.role}
                          </Typography>
                        )}
                      </Box>
                      {isFocused && (
                        <CenterFocusStrongIcon sx={{ fontSize: 18, color: '#6779e3', ml: 1 }} />
                      )}
                    </MenuItem>
                  )
                })
              ) : (
                <MenuItem disabled>
                  <Typography variant="body2" sx={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.5)' }}>
                    No participants available
                  </Typography>
                </MenuItem>
              )}
            </Menu>
          </>
        )}
        
        {/* Mobile Vertical Separator - Hidden on mobile (calendar is in drawer) */}
        {false && isMobile && chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING && (
          <Box
            ref={refMobileResizer}
            sx={{
              width: '100%',
              height: '8px',
              background: 'linear-gradient(to bottom, rgba(103, 121, 227, 0.1), rgba(116, 80, 170, 0.1))',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'row-resize',
              position: 'relative',
              transition: 'all 0.2s ease',
              borderTop: '1px solid rgba(103, 121, 227, 0.15)',
              borderBottom: '1px solid rgba(116, 80, 170, 0.15)',
              flexShrink: 0,
              '&:hover': {
                height: '12px',
                background: 'linear-gradient(to bottom, rgba(103, 121, 227, 0.2), rgba(116, 80, 170, 0.2))',
                borderTop: '2px solid rgba(103, 121, 227, 0.4)',
                borderBottom: '2px solid rgba(116, 80, 170, 0.4)',
              },
              '&:active': {
                height: '16px',
                background: 'linear-gradient(to bottom, rgba(103, 121, 227, 0.3), rgba(116, 80, 170, 0.3))',
              },
            }}
          >
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                backgroundColor: '#6779E3',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 8px rgba(103, 121, 227, 0.4)',
                transition: 'all 0.2s ease',
                '&:hover': {
                  width: 28,
                  height: 28,
                  backgroundColor: '#5568D3',
                  boxShadow: '0 3px 12px rgba(103, 121, 227, 0.6)',
                },
              }}
            >
              <DragIndicatorIcon
                sx={{
                  fontSize: '16px',
                  color: 'white',
                  transform: 'rotate(90deg)', // Rotate 90 degrees for vertical dragging
                }}
              />
            </Box>
          </Box>
        )}
        
        {/* Desktop Horizontal Separator - Hidden on mobile */}
        <HotlineSectionSeparator 
          ref={refLeft} 
          className="left-resizer hide-on-print-only"
          style={{
            display: isMobile ? 'none' : 'flex',
            pointerEvents: 'auto',
            zIndex: 10002,
            position: 'relative',
          }}
        >
          <Box
            sx={{
              width: 24,
              height: 24,
              borderRadius: '50%',
              backgroundColor: '#6779E3',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 8px rgba(103, 121, 227, 0.4)',
              transition: 'all 0.2s ease',
              pointerEvents: 'none', // Allow clicks to pass through to separator
              '&:hover': {
                width: 28,
                height: 28,
                backgroundColor: '#5568D3',
                boxShadow: '0 3px 12px rgba(103, 121, 227, 0.6)',
              },
            }}
          >
            <DragIndicatorIcon
              style={{
                fontSize: '16px',
                color: 'white',
                pointerEvents: 'none', // Ensure icon doesn't block events
              }}
            />
          </Box>
        </HotlineSectionSeparator>
        <HotlineChamberInteractionPart
          style={{
            paddingTop: 0,
            padding: 0,
            // Mobile: Hide calendar (it's in drawer). Desktop: Show
            display: isMobile ? 'none' : undefined,
            width: isMobile ? '100%' : undefined,
            // CRITICAL: Fixed height enables scrolling
            height: '100%',
            // Flex properties - don't shrink, don't grow beyond natural size
            flexShrink: 0,
            // Add margin top on mobile when video is floating to prevent overlap
            marginTop: isMobile && isScrolledDown ? '180px' : 0,
            transition: 'margin-top 0.3s ease',
          }}
          ref={(node) => {
            refBox.current = node
            calendarScrollContainerRef.current = node
          }}
          className="resizable-box mobile-calendar-container"
        >
          {/* No wrapper div needed - content renders directly in scroll container */}
            {patientSelected ? (
              <div>
                {patientBookedSlotDetailsLoading ? (
                  <Spinner animation="border" variant="dark" size="sm" />
                ) : (
                  <div>
                    <HCIPMenuContainer className="hide-on-print-only" style={{ flexShrink: 0 }} data-testid="patient-menu-row">
                      {patientMenuOptions?.map((menuItem, menuItemIndex) => (
                        <HCIPMenuItem
                          key={menuItem.id ?? menuItemIndex}
                          selected={menuItem.id === selectedOptionPatientMenu}
                          onClick={() => {
                            setSelectedOptionPatientMenu(menuItem.id)
                            if (menuItem.id === 'assessments') {
                              setAssessmentDrawerOpen(true)
                            }
                          }}
                        >
                          {menuItem.label}
                        </HCIPMenuItem>
                      ))}
                      {/* Save/Leave buttons are now in the main page header */}
                      {selectedOptionPatientMenu === 'screening_report' && (
                        <>
                          <HCIPMenuItem
                            onClick={() => screeningReportRef?.current?.openPreviewDrawer?.()}
                            style={{
                              background: 'linear-gradient(135deg, rgba(103, 121, 227, 0.1) 0%, rgba(103, 121, 227, 0.05) 100%)',
                              color: '#6779e3',
                              border: '1px solid rgba(103, 121, 227, 0.2)',
                              fontSize: '12px',
                              padding: '6px 12px',
                              fontWeight: 600,
                              display: 'flex',
                              alignItems: 'center',
                              gap: '4px',
                            }}
                          >
                            <PreviewIcon sx={{ fontSize: 16 }} />
                            Preview
                          </HCIPMenuItem>
                          <HCIPMenuItem
                            onClick={() => screeningReportRef?.current?.openHistoryDrawer?.()}
                            style={{
                              background: 'linear-gradient(135deg, rgba(103, 121, 227, 0.1) 0%, rgba(103, 121, 227, 0.05) 100%)',
                              color: '#6779e3',
                              border: '1px solid rgba(103, 121, 227, 0.2)',
                              fontSize: '12px',
                              padding: '6px 12px',
                              fontWeight: 600,
                              display: 'flex',
                              alignItems: 'center',
                              gap: '4px',
                            }}
                          >
                            <HistoryIcon sx={{ fontSize: 16 }} />
                            History
                          </HCIPMenuItem>
                          <ScreeningReportActionsMenu screeningReportRef={screeningReportRef} />
                        </>
                      )}
                      {/* Prescription Action Buttons */}
                      {selectedOptionPatientMenu === 'prescription' && (
                        <>
                          <HCIPMenuItem
                            onClick={() => setRxDrawerOpen(true)}
                            style={{
                              background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(16, 185, 129, 0.05) 100%)',
                              color: '#10b981',
                              border: '1px solid rgba(16, 185, 129, 0.2)',
                              fontSize: '12px',
                              padding: '6px 12px',
                              fontWeight: 600,
                              display: 'flex',
                              alignItems: 'center',
                              gap: '4px',
                            }}
                          >
                            <MedicationIcon sx={{ fontSize: 16 }} />
                            Rx
                          </HCIPMenuItem>
                        </>
                      )}
                      {/* Therapy Report Action Buttons */}
                      {selectedOptionPatientMenu === 'therapy_report' && (
                        <>
                          <HCIPMenuItem
                            onClick={() => therapyReportRef?.current?.openSettings?.()}
                            style={{
                              background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(139, 92, 246, 0.05) 100%)',
                              color: '#8b5cf6',
                              border: '1px solid rgba(139, 92, 246, 0.2)',
                              fontSize: '12px',
                              padding: '6px 12px',
                              fontWeight: 600,
                              display: 'flex',
                              alignItems: 'center',
                              gap: '4px',
                            }}
                          >
                            <SettingsIcon sx={{ fontSize: 16 }} />
                            Settings
                          </HCIPMenuItem>
                          <HCIPMenuItem
                            onClick={() => {
                              // Open preview by triggering save and print
                              therapyReportRef?.current?.printReport?.()
                            }}
                            style={{
                              background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(139, 92, 246, 0.05) 100%)',
                              color: '#8b5cf6',
                              border: '1px solid rgba(139, 92, 246, 0.2)',
                              fontSize: '12px',
                              padding: '6px 12px',
                              fontWeight: 600,
                              display: 'flex',
                              alignItems: 'center',
                              gap: '4px',
                            }}
                          >
                            <PreviewIcon sx={{ fontSize: 16 }} />
                            Preview / Print
                          </HCIPMenuItem>
                        </>
                      )}
                      {/* Assessment Report Action Buttons – same pattern as therapy report, open assessment-report settings */}
                      {selectedOptionPatientMenu === 'assessment_report' && (
                        <>
                          <HCIPMenuItem
                            onClick={() => assessmentReportRef?.current?.openSettings?.()}
                            style={{
                              background: 'linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, rgba(99, 102, 241, 0.05) 100%)',
                              color: '#6366f1',
                              border: '1px solid rgba(99, 102, 241, 0.2)',
                              fontSize: '12px',
                              padding: '6px 12px',
                              fontWeight: 600,
                              display: 'flex',
                              alignItems: 'center',
                              gap: '4px',
                            }}
                          >
                            <SettingsIcon sx={{ fontSize: 16 }} />
                            Settings
                          </HCIPMenuItem>
                        </>
                      )}
                    </HCIPMenuContainer>
                    <PrescriptionDataProvider>
                      <div>
                        {selectedOptionPatientMenu === 'prescription' && (
                          <PrescriptionMakingPage
                            ref={prescriptionRef}
                            propEventId={selectedPatientBookedEventData?.id}
                            propPatientId={selectedPatientBookedEventData?.patientId}
                            propClinicId={selectedPatientBookedEventData?.clinicId}
                            propClinicBrandId={selectedPatientBookedEventData?.clinicBrandId || ''}
                            propMentorProfileData={mentorProfileData}
                            propBookedEventInfo={selectedPatientBookedEventData}
                            setHideLayoutComponents={setHideLayoutComponents}
                            // triggerSave={triggerSave}
                            // setTriggerSave={setTriggerSave}
                            auxiliaryDataFromProps={auxiliaryData}
                            getProcessAndSetEventData={getAndSetPatientBookedEventDetails}
                            inChamber
                            afterSaveFunction={(markAsCompleted = false) => {
                              if (newWantedMenuItemId === 'end') {
                                finallyCloseBookedEvent(markAsCompleted)
                              } else {
                                setSelectedOptionPatientMenu(newWantedMenuItemId)
                              }
                            }}
                            showPatientDetailsInHeader
                          />
                        )}
                        {selectedOptionPatientMenu === 'therapy_report' && (
                          <TherapyReportMakingPage
                            ref={therapyReportRef}
                            propEventId={selectedPatientBookedEventData?.id}
                            propPatientId={selectedPatientBookedEventData?.patientId}
                            propClinicId={selectedPatientBookedEventData?.clinicId}
                            propClinicBrandId={selectedPatientBookedEventData?.clinicBrandId || ''}
                            propMentorProfileData={mentorProfileData}
                            propBookedEventInfo={selectedPatientBookedEventData}
                            triggerSave={triggerSave}
                            setTriggerSave={setTriggerSave}
                            auxiliaryDataFromProps={auxiliaryData}
                            hideDocSide
                            leaveRoom={finallyCloseBookedEvent}
                            getProcessAndSetEventData={getAndSetPatientBookedEventDetails}
                            afterSaveFunction={() => {
                              if (newWantedMenuItemId === 'end') {
                                setSelectedPatientBookedEventId()
                                setPatientSelected(false)
                                setNewWantedMenuItemId()
                                setSelectedOptionPatientMenu()
                              } else {
                                setSelectedOptionPatientMenu(newWantedMenuItemId)
                              }
                            }}
                            showPatientDetailsInHeader
                          />
                        )}
                        {selectedOptionPatientMenu === 'assessment_report' && (
                          <AssessmentReportMakingPage
                            ref={assessmentReportRef}
                            propEventId={selectedPatientBookedEventData?.id}
                            propPatientId={selectedPatientBookedEventData?.patientId}
                            propClinicId={selectedPatientBookedEventData?.clinicId}
                            propClinicBrandId={selectedPatientBookedEventData?.clinicBrandId || ''}
                            propMentorProfileData={mentorProfileData}
                            propBookedEventInfo={selectedPatientBookedEventData}
                            triggerSave={triggerSave}
                            setTriggerSave={setTriggerSave}
                            auxiliaryDataFromProps={auxiliaryData}
                            getProcessAndSetEventData={getAndSetPatientBookedEventDetails}
                            afterSaveFunction={() => {
                              if (newWantedMenuItemId === 'end') {
                                setSelectedPatientBookedEventId()
                                setPatientSelected(false)
                                setNewWantedMenuItemId()
                                setSelectedOptionPatientMenu()
                              } else {
                                setSelectedOptionPatientMenu(newWantedMenuItemId)
                              }
                            }}
                            chamberRoomId={serverGivenNextAction?.channel?.chamberRoomId}
                            showPatientDetailsInHeader
                          />
                        )}
                        {selectedOptionPatientMenu === 'screening_report' && (
                          <ScreeningReportMakingPage
                            ref={screeningReportRef}
                            propEventId={selectedPatientBookedEventData?.id}
                            propPatientId={selectedPatientBookedEventData?.patientId}
                            propClinicId={selectedPatientBookedEventData?.clinicId}
                            propBookedEventInfo={selectedPatientBookedEventData}
                            propMentorProfileData={mentorProfileData}
                            auxiliaryDataFromProps={auxiliaryData}
                            getProcessAndSetEventData={getAndSetPatientBookedEventDetails}
                            leaveRoom={finallyCloseBookedEvent}
                          />
                        )}
                        {selectedOptionPatientMenu === 'past_prescriptions' && (
                          <LSPastPrescriptionsComponent
                            patientId={selectedPatientBookedEventData?.patientId}
                          />
                        )}
                        {selectedOptionPatientMenu === 'patient_history' && (
                          <LSPastVisitReportsComponent
                            patientId={selectedPatientBookedEventData?.patientId}
                            referenceBookedEventId={selectedPatientBookedEventData?.id}
                            addTopMargins
                          />
                        )}
                        {selectedOptionPatientMenu === 'vitals' && (
                          <VitalsListingPage
                            patientId={selectedPatientBookedEventData?.patientId}
                            clinicId={selectedPatientBookedEventData?.clinicId}
                          />
                        )}
                        {selectedOptionPatientMenu === 'assessments' && (
                          <Box sx={{ p: 3, maxWidth: 480 }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                              Assessment tests
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                              Start or view assessment runs for this session. Use the drawer to select an assessment.
                            </Typography>
                            <Button
                              variant="contained"
                              onClick={() => setAssessmentDrawerOpen(true)}
                              startIcon={<AssignmentIcon />}
                            >
                              Open assessment drawer
                            </Button>
                          </Box>
                        )}
                      </div>
                    </PrescriptionDataProvider>
                  </div>
                )}
              </div>
            ) : (
              <>
                {/* <HotlineCalendarComponentForMentor
                forMentor={true}
                mentorId={mentorProfileData?.id}
                mentorProfileData={mentorProfileData}
                containerRefForAutoScrolling={refBox}
                thisClinicData={chosenClinicData}
                mentorClinicAssociationData={mentorClinicAssociationData}
                bookedSlotClickFunctionOverride={(data) => {
                  if (data?.status !== STATUS_SESSION_CANCELLED) {
                    markJoinOrLeaveSession(data?.id, 'JOIN', 'mentor')
                    setSelectedPatientBookedEventId(data?.id)
                    setPatientSelected(true)
                  }
                }}
              /> */}

                <DayViewCalendarComponent
                  ref={calendarRef}
                  forMentor={true}
                  bookingLisitingApiSignature={`/api/secure/teacher/booked-slots/all-with-patient-info?get-patient-details=true`}
                  mentorAuthorisedToSaveAndGetPatientsUsingIdb={getAllRolesInBoolean().isDoctor}
                  mentorId={mentorProfileData?.id}
                  mentorProfileData={mentorProfileData}
                  mentorClinicAssociationData={mentorClinicAssociationData}
                  meetingBookApiSignature="/api/secure/meeting/book"
                  listOfPaymentLinksApiSignature="/api/secure/teacher/booked-slots/user-payment-link/get"
                  publicBookingJoiningLinksApiSignature="/api/secure/teacher/booked-slots/video-session-tokens/get"
                  patientSearchApiSignature="/api/secure/mentor/patient/list"
                  cancelAppointmentApiSignature="/api/secure/teacher/booked-slots/cancel"
                  pastPatientBookingsApiSignature="/api/secure/teacher/booked-event-history-of-a-patient"
                  createPatientApiSignature="/api/secure/patient/new"
                  sendSecureSessionLinkToPatientSignature="/api/secure/teacher/booked-slots/secure-join-link/send"
                  sendPublicSessionLinkToPatientSignature="/api/secure/teacher/booked-slots/public-join-link/send"
                  getPrescriptionImagesApiSignature="/api/secure/mentor/emr-reports/prescription/images/get-by-eventId"
                  savePrescriptionImagesApiSignature="/api/secure/mentor/emr-reports/prescription/images/save"
                  fileUploadApiSignature="/api/secure/mentor/emr-reports/file/upload"
                  sendPrescriptionPdfApiSignature="/api/secure/teacher/doctor/prescription/generate/pdf"
                  headerContainerStyles={{ display: 'none', height: 0, padding: 0, margin: 0 }}
                  // allProfessionalsDataForAssistant
                  thisClinicData={chosenClinicData}
                  currentView={selectedTab}
                  // setFetchDataTriggerForBookingRequests
                  // canPersonPrintPrescription
                  // chambersData
                  // assistantProfileInThisClinic
                  // LeftSideExtraComponent
                  // RightSideExtraComponent
                  containerRefForAutoScrolling={refBox}
                  bookedSlotClickFunctionOverride={async (data) => {
                    // Check if session is blocked (payment pending - slot held but not confirmed)
                    const isSessionBlocked = 
                      data?.status === BOOKING_STATUSES.BOOKING_INITIATED &&
                      data?.paymentStatus === BOOKING_PAYMENT_STATUSES.PENDING
                    
                    // Prevent joining blocked sessions
                    if (isSessionBlocked) {
                      toast.warning('This session is awaiting payment confirmation and cannot be joined yet.')
                      return
                    }
                    
                    if (data?.status !== STATUS_SESSION_CANCELLED) {
                      // Check if this is an offline event - offline events should open therapy report editing page, not join video call
                      const isOfflineEvent = data?.meetingSrc === 'offline'
                      
                      // Check if this is a video call event and join the video call channel
                      const isVideoCallEvent = 
                        data?.eventType === allAvailableEventTypes.consultation ||
                        data?.eventType === allAvailableEventTypes.therapySession ||
                        data?.eventType === allAvailableEventTypes.screening ||
                        data?.eventType === allAvailableEventTypes.assessment
                      
                      if (isVideoCallEvent && !isOfflineEvent) {
                        // Join the booked event's video call channel (only for online events)
                        await joinBookedEventVideoCall(data)
                      } else {
                        // Not a video call or is offline, use original behavior (opens therapy report editing page on split page)
                        markBookedEventLog(data?.id, 'JOIN', 'mentor')
                        setSelectedPatientBookedEventId(data?.id)
                        setPatientSelected(true)
                      }
                    }
                  }}
                  // emptySlotClickFunctionOverride={() => null}
                  // LeftSideExtraComponent={<CheckInInformationComponent />}
                  RightSideExtraComponent={
                    <CheckoutButtonComponent
                      text=" "
                      additionalFunctionBeforeAction={() => {
                        chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING &&
                          leaveThisSession()
                      }}
                      styleProp={{
                        width: '16px',
                        flexDirection: 'column',
                        borderRadius: '0px',
                        height: '100%',
                      }}
                      showExitButtonIfNotCheckedIn={true}
                    />
                  }
                  // minimalUI
                  // showBookingPopup={true}
                  useClinicAppointmentTypes={false}
                  clinicAppointmentTypesList={[]}
                  paymentLinkToSendViaQRCode={showPaymentQrToPatient}
                  eachSlotDurationInMins={eachSlotDurationInMins}
                  setEachSlotDurationInMins={setEachSlotDurationInMins}
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                  onBookedSlotsUpdate={setBookedSlotsInDay}
                />
              </>
            )}
        </HotlineChamberInteractionPart>
        </Box>

        {/* Booked Slots Drawer */}
        <BookedSlotsDrawer
          open={bookedSlotsDrawerOpen}
          onClose={() => setBookedSlotsDrawerOpen(false)}
          bookedSlotsInDay={bookedSlotsInDay}
          selectedDate={selectedDate}
          selectedClinic={chosenClinicData}
          mentorProfileData={mentorProfileData}
          forMentor={true}
        />

        {/* Patient Search Drawer */}
        <PatientSearchDrawer
          open={patientSearchOpen}
          onClose={() => setPatientSearchOpen(false)}
          onSelectPatient={(patient) => {
            setPatientSearchOpen(false)
            // You can add additional logic here if needed
          }}
          clinicId={chosenClinicData?.id}
          clinicBrandId={chosenClinicData?.clinicBrandId}
          mentorProfileData={mentorProfileData}
          searchPatientApiSignature="/api/secure/mentor/patient/list"
          createPatientApiSignature="/api/secure/patient/new"
        />

        {/* Calendar Drawer for Mobile */}
        {isMobile && (
          <Drawer
            anchor="bottom"
            open={calendarDrawerOpen}
            onClose={() => setCalendarDrawerOpen(false)}
            PaperProps={{
              sx: {
                height: '85vh',
                borderTopLeftRadius: '24px',
                borderTopRightRadius: '24px',
                background: 'rgba(255, 255, 255, 0.98)',
                backdropFilter: 'blur(20px) saturate(180%)',
                WebkitBackdropFilter: 'blur(20px) saturate(180%)',
              },
            }}
          >
            {/* Drawer Header with Tabs and Date Picker */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
                background: 'rgba(255, 255, 255, 0.98)',
              }}
            >
              {/* Top Row: Title, 3-dots Menu, and Close Button */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  p: 2,
                  pb: 1.5,
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 600, color: '#1f2937' }}>
                  Calendar
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {/* 3-dots Menu */}
                  <IconButton
                    onClick={(e) => {
                      const menuAnchor = e.currentTarget
                      setCombinedMenuAnchorEl(menuAnchor)
                    }}
                    sx={{
                      color: 'rgba(103, 121, 227, 0.8)',
                      backgroundColor: 'rgba(103, 121, 227, 0.1)',
                      border: '1px solid rgba(103, 121, 227, 0.2)',
                      padding: '6px',
                      '&:hover': {
                        backgroundColor: 'rgba(103, 121, 227, 0.2)',
                        borderColor: 'rgba(103, 121, 227, 0.4)',
                      },
                    }}
                  >
                    <MoreVertIcon sx={{ fontSize: 20 }} />
                  </IconButton>
                  <Menu
                    anchorEl={combinedMenuAnchorEl}
                    open={Boolean(combinedMenuAnchorEl)}
                    onClose={() => setCombinedMenuAnchorEl(null)}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    PaperProps={{
                      sx: {
                        mt: 1,
                        minWidth: 200,
                        borderRadius: '12px',
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                        border: '1px solid rgba(103, 121, 227, 0.1)',
                      },
                    }}
                  >
                    {/* Tabs Section */}
                    {MENTOR_CLINIC_BOOKING_TABS_LIST.filter((tab) => {
                      return tab.id === 'calendar' || tab.id === 'appointments'
                    }).length > 0 && (
                      <>
                        {MENTOR_CLINIC_BOOKING_TABS_LIST.filter((tab) => {
                          return tab.id === 'calendar' || tab.id === 'appointments'
                        }).map((tab) => {
                          const TabIcon = tab.icon
                          return (
                            <MenuItem
                              key={tab.id}
                              onClick={() => {
                                setSelectedTab(tab.id)
                                setCombinedMenuAnchorEl(null)
                              }}
                              selected={selectedTab === tab.id}
                              sx={{
                                py: 1.5,
                                px: 2,
                                '&.Mui-selected': {
                                  backgroundColor: 'rgba(103, 121, 227, 0.1)',
                                  '&:hover': {
                                    backgroundColor: 'rgba(103, 121, 227, 0.15)',
                                  },
                                },
                              }}
                            >
                              <ListItemIcon>
                                <TabIcon sx={{ fontSize: 20, color: selectedTab === tab.id ? '#6779e3' : 'rgba(103, 121, 227, 0.6)' }} />
                              </ListItemIcon>
                              <ListItemText
                                primary={tab.title}
                                primaryTypographyProps={{
                                  fontWeight: selectedTab === tab.id ? 600 : 400,
                                  color: selectedTab === tab.id ? '#6779e3' : 'rgba(103, 121, 227, 0.7)',
                                }}
                              />
                            </MenuItem>
                          )
                        })}
                        {/* Divider between tabs and actions if both exist */}
                        {(selectedTab === 'calendar' && (handleOpenPatientSearch || handleRefreshBookings || (eachSlotDurationInMins !== undefined && setEachSlotDurationInMins))) && (
                          <Box sx={{ borderTop: '1px solid rgba(103, 121, 227, 0.1)', my: 0.5 }} />
                        )}
                      </>
                    )}

                    {/* Actions Section (only when calendar tab is selected) */}
                    {selectedTab === 'calendar' && (
                      <>
                        {handleOpenPatientSearch && (
                          <MenuItem
                            onClick={() => {
                              handleOpenPatientSearch()
                              setCombinedMenuAnchorEl(null)
                            }}
                          >
                            <ListItemIcon>
                              <SearchIcon sx={{ fontSize: 20, color: 'rgba(103, 121, 227, 0.7)' }} />
                            </ListItemIcon>
                            <ListItemText primary="Search Patient" />
                          </MenuItem>
                        )}
                        {handleRefreshBookings && (
                          <MenuItem
                            onClick={() => {
                              handleRefreshBookings()
                              setCombinedMenuAnchorEl(null)
                            }}
                            disabled={isRefreshingBookings}
                          >
                            <ListItemIcon>
                              {isRefreshingBookings ? (
                                <CircularProgress size={16} sx={{ color: 'rgba(103, 121, 227, 0.7)' }} />
                              ) : (
                                <RefreshIcon sx={{ fontSize: 20, color: 'rgba(103, 121, 227, 0.7)' }} />
                              )}
                            </ListItemIcon>
                            <ListItemText primary="Refresh Bookings" />
                          </MenuItem>
                        )}
                        {eachSlotDurationInMins !== undefined && setEachSlotDurationInMins && (
                          <MenuItem
                            onClick={(e) => {
                              const anchor = combinedMenuAnchorEl
                              setCombinedMenuAnchorEl(null)
                              // Note: Slot duration popover functionality would need to be implemented separately
                              // For now, we'll just close the menu
                            }}
                          >
                            <ListItemIcon>
                              <HeightIcon sx={{ fontSize: 20, color: 'rgba(103, 121, 227, 0.7)' }} />
                            </ListItemIcon>
                            <ListItemText primary="Adjust Slot Duration" />
                          </MenuItem>
                        )}
                      </>
                    )}
                  </Menu>
                  <IconButton
                    onClick={() => setCalendarDrawerOpen(false)}
                    sx={{
                      color: '#6779e3',
                      '&:hover': {
                        backgroundColor: 'rgba(103, 121, 227, 0.1)',
                      },
                    }}
                  >
                    <ExitToAppIcon />
                  </IconButton>
                </Box>
              </Box>

              {/* Tabs Row: Calendar / Appointments */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  px: 2,
                  pb: 1.5,
                }}
              >
                {MENTOR_CLINIC_BOOKING_TABS_LIST.filter((tab) => {
                  const isCalendarOrAppointments = tab.id === 'calendar' || tab.id === 'appointments'
                  return isCalendarOrAppointments
                }).map((tab) => {
                  const TabIcon = tab.icon
                  const isSelected = selectedTab === tab.id
                  return (
                    <Box
                      key={tab.id}
                      onClick={() => setSelectedTab(tab.id)}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        px: 2,
                        py: 1,
                        borderRadius: '8px',
                        cursor: 'pointer',
                        background: isSelected
                          ? 'linear-gradient(135deg, rgba(103, 121, 227, 0.15) 0%, rgba(118, 75, 162, 0.12) 100%)'
                          : 'transparent',
                        border: isSelected
                          ? '1.5px solid rgba(103, 121, 227, 0.3)'
                          : '1.5px solid transparent',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          background: isSelected
                            ? 'linear-gradient(135deg, rgba(103, 121, 227, 0.2) 0%, rgba(118, 75, 162, 0.15) 100%)'
                            : 'rgba(103, 121, 227, 0.05)',
                          borderColor: isSelected
                            ? 'rgba(103, 121, 227, 0.4)'
                            : 'rgba(103, 121, 227, 0.2)',
                        },
                      }}
                    >
                      <TabIcon
                        sx={{
                          fontSize: 18,
                          color: isSelected ? '#6779e3' : 'rgba(103, 121, 227, 0.6)',
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: '14px',
                          fontWeight: isSelected ? 600 : 500,
                          color: isSelected ? '#6779e3' : 'rgba(103, 121, 227, 0.7)',
                        }}
                      >
                        {tab.title}
                      </Typography>
                    </Box>
                  )
                })}
              </Box>

              {/* Date Picker Row */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 1,
                  px: 2,
                  pb: 2,
                }}
              >
                <IconButton
                  onClick={onPrevClick}
                  size="small"
                  sx={{
                    padding: '4px',
                    borderRadius: '6px',
                    color: '#6779e3',
                    background: 'rgba(255, 255, 255, 0.8)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(103, 121, 227, 0.2)',
                    '&:hover': {
                      background: 'rgba(103, 121, 227, 0.1)',
                      borderColor: 'rgba(103, 121, 227, 0.4)',
                    },
                  }}
                >
                  <ArrowLeftIcon sx={{ fontSize: 18 }} />
                </IconButton>

                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    minWidth: '140px',
                    gap: 0.25,
                    px: 1.5,
                  }}
                >
                  <MomentDatePicker
                    date={dayjs(selectedDate, 'DD-MM-YYYY')}
                    onChange={(nextValue) => {
                      const newDate = nextValue?.format('DD-MM-YYYY')
                      setSelectedDate(newDate)
                      window.dispatchEvent(new CustomEvent('calendar-date-change', { detail: { date: newDate } }))
                    }}
                    calendarProps={{
                      minDetail: 'decade',
                      showNeighboringMonth: false,
                      locale: sessionStorage.getItem('languageCode') || 'en',
                    }}
                    clinicSchedules={clinicSchedules}
                    selectedDate={selectedDate}
                    format="DD-MM-YYYY"
                    buttonTextOverride={selectedDate}
                  />
                  {(() => {
                    const today = dayjs().format('DD-MM-YYYY')
                    const yesterday = dayjs().subtract(1, 'day').format('DD-MM-YYYY')
                    const tomorrow = dayjs().add(1, 'day').format('DD-MM-YYYY')

                    let label = null
                    if (selectedDate === today) {
                      label = 'Today'
                    } else if (selectedDate === yesterday) {
                      label = 'Yesterday'
                    } else if (selectedDate === tomorrow) {
                      label = 'Tomorrow'
                    }

                    return label ? (
                      <Typography
                        variant="caption"
                        sx={{
                          color: '#6779e3',
                          fontSize: '10px',
                          fontWeight: 600,
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                        }}
                      >
                        {label}
                      </Typography>
                    ) : null
                  })()}
                </Box>

                <IconButton
                  onClick={onNextClick}
                  size="small"
                  sx={{
                    padding: '4px',
                    borderRadius: '6px',
                    color: '#6779e3',
                    background: 'rgba(255, 255, 255, 0.8)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(103, 121, 227, 0.2)',
                    '&:hover': {
                      background: 'rgba(103, 121, 227, 0.1)',
                      borderColor: 'rgba(103, 121, 227, 0.4)',
                    },
                  }}
                >
                  <ArrowRightIcon sx={{ fontSize: 18 }} />
                </IconButton>

                {!isToday && (
                  <Button
                    onClick={handleGoToToday}
                    size="small"
                    sx={{
                      minWidth: 'auto',
                      padding: '6px 12px',
                      borderRadius: '6px',
                      background: 'rgba(103, 121, 227, 0.1)',
                      color: '#6779e3',
                      border: '1px solid rgba(103, 121, 227, 0.2)',
                      fontSize: '12px',
                      fontWeight: 600,
                      textTransform: 'none',
                      '&:hover': {
                        background: 'rgba(103, 121, 227, 0.2)',
                        borderColor: 'rgba(103, 121, 227, 0.4)',
                      },
                    }}
                  >
                    Today
                  </Button>
                )}
              </Box>
            </Box>
            <Box
              ref={(node) => {
                if (isMobile) {
                  refBox.current = node
                  calendarScrollContainerRef.current = node
                }
              }}
              sx={{
                flex: 1,
                overflowY: 'auto',
                overflowX: 'hidden',
                p: 0,
              }}
            >
              {!patientSelected ? (
                <DayViewCalendarComponent
                  ref={calendarRef}
                  forMentor={true}
                  bookingLisitingApiSignature={`/api/secure/teacher/booked-slots/all-with-patient-info?get-patient-details=true`}
                  mentorAuthorisedToSaveAndGetPatientsUsingIdb={getAllRolesInBoolean().isDoctor}
                  mentorId={mentorProfileData?.id}
                  mentorProfileData={mentorProfileData}
                  mentorClinicAssociationData={mentorClinicAssociationData}
                  meetingBookApiSignature="/api/secure/meeting/book"
                  listOfPaymentLinksApiSignature="/api/secure/teacher/booked-slots/user-payment-link/get"
                  publicBookingJoiningLinksApiSignature="/api/secure/teacher/booked-slots/video-session-tokens/get"
                  patientSearchApiSignature="/api/secure/mentor/patient/list"
                  cancelAppointmentApiSignature="/api/secure/teacher/booked-slots/cancel"
                  pastPatientBookingsApiSignature="/api/secure/teacher/booked-event-history-of-a-patient"
                  createPatientApiSignature="/api/secure/patient/new"
                  sendSecureSessionLinkToPatientSignature="/api/secure/teacher/booked-slots/secure-join-link/send"
                  sendPublicSessionLinkToPatientSignature="/api/secure/teacher/booked-slots/public-join-link/send"
                  getPrescriptionImagesApiSignature="/api/secure/mentor/emr-reports/prescription/images/get-by-eventId"
                  savePrescriptionImagesApiSignature="/api/secure/mentor/emr-reports/prescription/images/save"
                  fileUploadApiSignature="/api/secure/mentor/emr-reports/file/upload"
                  sendPrescriptionPdfApiSignature="/api/secure/teacher/doctor/prescription/generate/pdf"
                  headerContainerStyles={{ display: 'none', height: 0, padding: 0, margin: 0 }}
                  thisClinicData={chosenClinicData}
                  currentView={selectedTab}
                  containerRefForAutoScrolling={refBox}
                  bookedSlotClickFunctionOverride={async (data) => {
                    if (data?.status !== STATUS_SESSION_CANCELLED) {
                      // Check if this is an offline event - offline events should open therapy report editing page, not join video call
                      const isOfflineEvent = data?.meetingSrc === 'offline'
                      
                      const isVideoCallEvent = 
                        data?.eventType === allAvailableEventTypes.consultation ||
                        data?.eventType === allAvailableEventTypes.therapySession ||
                        data?.eventType === allAvailableEventTypes.screening ||
                        data?.eventType === allAvailableEventTypes.assessment
                      
                      if (isVideoCallEvent && !isOfflineEvent) {
                        // Join the booked event's video call channel (only for online events)
                        await joinBookedEventVideoCall(data)
                        setCalendarDrawerOpen(false) // Close drawer when joining video call
                      } else {
                        // Not a video call or is offline, use original behavior (opens therapy report editing page on split page)
                        markBookedEventLog(data?.id, 'JOIN', 'mentor')
                        setSelectedPatientBookedEventId(data?.id)
                        setPatientSelected(true)
                        setCalendarDrawerOpen(false) // Close drawer when selecting patient
                      }
                    }
                  }}
                  RightSideExtraComponent={
                    <CheckoutButtonComponent
                      text=" "
                      additionalFunctionBeforeAction={() => {
                        chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING &&
                          leaveThisSession()
                      }}
                      styleProp={{
                        width: '16px',
                        flexDirection: 'column',
                        borderRadius: '0px',
                        height: '100%',
                      }}
                      showExitButtonIfNotCheckedIn={true}
                    />
                  }
                  useClinicAppointmentTypes={false}
                  clinicAppointmentTypesList={[]}
                  paymentLinkToSendViaQRCode={showPaymentQrToPatient}
                  eachSlotDurationInMins={eachSlotDurationInMins}
                  setEachSlotDurationInMins={setEachSlotDurationInMins}
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                  onBookedSlotsUpdate={setBookedSlotsInDay}
                />
              ) : (
                <Box sx={{ p: 2 }}>
                  <Typography variant="body2" color="text.secondary">
                    Patient selected. Calendar is not available during active session.
                  </Typography>
                </Box>
              )}
            </Box>
          </Drawer>
        )}


        {/* Notification Panel for clean message display */}
        <NotificationPanel />
        
        {/* Rx Drawer - Prescription Preview */}
        {selectedPatientBookedEventData && (
          <Drawer
            anchor="right"
            open={rxDrawerOpen}
            onClose={() => setRxDrawerOpen(false)}
            PaperProps={{
              sx: {
                width: { xs: '100%', sm: '90%', md: '80%', lg: '70%', xl: '60%' },
                maxWidth: { xs: '100%', sm: '1200px', md: '1400px', lg: '1600px' },
                display: 'flex',
                flexDirection: 'column',
              },
            }}
          >
            <Box sx={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%', width: '100%', minWidth: 0 }}>
              <PrescriptionDataProvider>
                <RXDrawerComponent
                  mentorProfileData={mentorProfileData}
                  auxiliaryData={auxiliaryData}
                  bookedEventData={selectedPatientBookedEventData}
                  prescriptionRef={prescriptionRef}
                  onClose={() => setRxDrawerOpen(false)}
                />
              </PrescriptionDataProvider>
            </Box>
          </Drawer>
        )}
        
        {/* Idle Popup - only shows when alone in video call */}
        {chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING && (
          <EmrCheckedInIdlePopup
            currentClinicLocationData={chosenClinicData}
            mentorName={mentorProfileData?.name}
            externalIsIdle={isIdle}
            onResetIdle={() => {
              setIsIdle(false)
              if (idleTimerRef.current) {
                clearTimeout(idleTimerRef.current)
                idleTimerRef.current = null
              }
              // Restart timer if still alone
              if (remoteUsers.length === 0 && chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING) {
                idleTimerRef.current = setTimeout(() => {
                  setIsIdle(true)
                }, IDLE_TIME)
              }
            }}
          />
        )}
        
      </ScreeningSectionsProvider>
    </div>
  )
}

const UndecidedClinicIdUIComponent = () => {
  const { mentorProfileData, mentorClinicAssociationData } = useContext(MentorProfileContext)

  const navigate = useNavigate()
  return (
    <div style={{ maxWidth: '400px' }}>
      <div>Please select a clinic to remotely connect:</div>
      <div>
        {mentorClinicAssociationData?.map((clinicLoc, clinicLocIndex) => {
          return (
            <button
              className={`${'bg-light'} rounded m-1`}
              key={clinicLocIndex}
              onClick={() => navigate(`/mentor-home/join-chamber-room/${clinicLoc?.id}`)}
            >
              {clinicLoc?.title || clinicLoc?.name || clinicLoc?.firstName}
            </button>
          )
        })}
      </div>
      <div style={{ marginTop: '32px' }} onClick={() => navigate('/mentor-home')}>
        Exit
      </div>
    </div>
  )
}

export const NerdStatComponent = ({
  externalTrigger,
  resetOutsideTrigger,
  showTriggerButton = true,
  serverGivenNextAction,
}) => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (externalTrigger) {
      setOpen(true)
    }
  }, [externalTrigger])

  return (
    <div
      style={{
        position: 'relative',
        marginTop: 'auto',
        paddingTop: '16px',
        paddingLeft: '16px',
        zIndex: 1,
      }}
      className="hide-on-print-only"
    >
      {open ? (
        <div
          style={{
            height: '400px',
            width: '600px',
            borderRadius: '8px',
            background: 'rgba(0,0,0,0.4)',
            color: '#fff',
            cursor: 'pointer',
            padding: '4px',
            fontSize: '12px',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '24px' }}>
            <div>#Stats</div>
            <div
              onClick={() =>
                setOpen((prev) => {
                  if (resetOutsideTrigger) {
                    resetOutsideTrigger()
                  }
                  return !prev
                })
              }
            >
              [x]
            </div>
          </div>
          <div>Last action UTC: {serverGivenNextAction?.chamberScreenAction?.createdTime}</div>
          <div>Action: {serverGivenNextAction?.chamberScreenAction?.action}</div>
          <div>ChamberLastPresent UTC: {serverGivenNextAction?.channel?.chamberLastPresent}</div>
          <div>ChamberRoomId: {serverGivenNextAction?.channel?.chamberRoomId}</div>
          <div>ChamberRoomName: {serverGivenNextAction?.channel?.chamberRoomName}</div>
          <div>ChannelId: {serverGivenNextAction?.channel?.id}</div>
          <div>MentorId: {serverGivenNextAction?.channel?.mentorId}</div>
          <div>MentorLastPresent UTC: {serverGivenNextAction?.channel?.mentorLastPresent}</div>
          {/* <div>
            Token Expiry On:{' '}
            {dayjs(getAccessTokenExpiryReadable()).local().format('DD MMMM YYYY h:mm A')}
          </div> */}
          <div>MentorName: {serverGivenNextAction?.channel?.mentorName}</div>
        </div>
      ) : (
        showTriggerButton && (
          <div
            style={{
              height: '24px',
              width: '24px',
              borderRadius: '50%',
              background: 'rgba(0,0,0,0.2)',
              color: '#fff',
              position: 'absolute',
              // top: '16px',
              left: '16px',
              bottom: '16px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
              zIndex: '9999',
            }}
            onClick={() => setOpen((prev) => !prev)}
          >
            i
          </div>
        )
      )}
    </div>
  )
}
